import React from 'react';
import SvgIcon from './SvgIcon';

// Copy
export const Copy = (props) => (
  <SvgIcon
    viewBox='0 0 12 12'
    style={{ height: '12px', width: '12px' }}
    {...props}
  >
    <path d='M7,5 L7,12 L4.19220214e-13,12 L4.19220214e-13,5 L7,5 Z M12,-3.69482223e-13 L12,7 L8.5,7 L8.5,3.5 L5,3.5 L5,-3.69482223e-13 L12,-3.69482223e-13 Z' />
  </SvgIcon>
);

export const PurpleClockIcon = (props) => (
  <SvgIcon
    viewBox='0 0 19 19'
    style={{ height: '19px', width: '19px' }}
    {...props}
  >
    <path
      d='M9.5,0 C14.7566667,0 19,4.24333333 19,9.5 C19,14.7566667 14.7566667,19 9.5,19 C4.24333333,19 0,14.7566667 0,9.5 C0,4.24333333 4.24333333,0 9.5,0 Z M9.5,2.11111111 C5.42555556,2.11111111 2.11111111,5.42555556 2.11111111,9.5 C2.11111111,13.5744444 5.42555556,16.8888889 9.5,16.8888889 C13.5744444,16.8888889 16.8888889,13.5744444 16.8888889,9.5 C16.8888889,5.42555556 13.5744444,2.11111111 9.5,2.11111111 Z M9.05370377,5 C9.64377788,5 10.1074075,5.44507384 10.1074075,6.01153146 L10.1074075,6.01153146 L10.1074075,8.82682581 L13.6838889,12.2601659 C14.1053704,12.6647785 14.1053704,13.291928 13.6838889,13.6965406 C13.4942222,13.8988469 13.1991851,14 12.9462962,14 C12.6934073,14 12.4194443,13.8988469 12.2087036,13.6965406 L12.2087036,13.6965406 L8,9.65628161 L8,6.01153146 C8,5.44507384 8.46362966,5 9.05370377,5 Z'
      id='path-1'
    ></path>
  </SvgIcon>
);

export const PurpleMorningIcon = (props) => (
  <SvgIcon
    viewBox='0 0 19 19'
    width={props.width || '24px'}
    height={props.height || '19px'}
    {...props}
  >
    <path
      d='M10.9865854,7 C13.2134146,7 15.0109756,8.81900452 15.0109756,11.0723982 C15.0109756,11.1451312 15.0084,11.2175113 15.004161,11.2895928 L15.004161,11.2895928 L21.154878,11.2895928 C22.2817073,11.2895928 22.2817073,13 21.154878,13 L21.154878,13 L0.845121951,13 C-0.281707317,13 -0.281707317,11.2895928 0.845121951,11.2895928 L0.845121951,11.2895928 L6.99495366,11.2895928 C6.99125122,11.2175113 6.98902439,11.1451312 6.98902439,11.0723982 C6.98902439,8.81900452 8.78658537,7 10.9865854,7 Z M18.252344,3.31953193 C19.2147754,2.3571005 20.6428995,3.78522456 19.6804681,4.74765599 L19.6804681,4.74765599 L16.7310814,7.69704264 C15.7996962,8.6284279 14.3715721,7.20030384 15.3029574,6.26891858 L15.3029574,6.26891858 Z M2.30295736,4.74765599 C1.3715721,3.78522456 2.79969616,2.3571005 3.73108142,3.31953193 L3.73108142,3.31953193 L6.68046807,6.26891858 C7.6428995,7.20030384 6.21477544,8.6284279 5.25234401,7.69704264 L5.25234401,7.69704264 Z M10,0.974811083 C10,-0.324937028 12,-0.324937028 12,0.974811083 L12,0.974811083 L12,5.02518892 C12,6.32493703 10,6.32493703 10,5.02518892 L10,5.02518892 Z'
      id='path-1'
    ></path>
  </SvgIcon>
);

export const PurpleNightIcon = (props) => (
  <SvgIcon
    viewBox='-3 0 19 19'
    width={props.width || '19px'}
    height={props.height || '19px'}
    {...props}
  >
    <path
      d='M12.8472779,7.16312229 C12.737722,7.09849726 12.5998234,7.10723517 12.4992714,7.18516666 C11.6660694,7.83461051 10.639082,8.18567922 9.58268752,8.18213083 C6.95241284,8.17915906 4.82086177,6.04759758 4.81789001,3.41731007 C4.81434164,2.36091039 5.16540864,1.33387363 5.81484932,0.500711949 C5.91988111,0.365207854 5.89521993,0.170179538 5.75967214,0.065102876 C5.69216438,0.0127197872 5.60602766,-0.00945764246 5.52157642,0.00371575074 C2.34241304,0.504437757 0.000266127857,3.24410435 0,6.46249294 C0,10.0673011 2.93272898,13 6.53751951,13 C9.7558924,12.9997339 12.4955013,10.6576199 12.9962652,7.47844099 C13.0159143,7.35273932 12.9568339,7.22779168 12.8472779,7.16312229'
      id='path-1'
    ></path>
  </SvgIcon>
);
export const PurpleAfternoonIcon = (props) => (
  <SvgIcon
    viewBox='1 0 20 22'
    width={props.width || '19px'}
    height={props.height || '19px'}
    {...props}
  >
    <path
      d='M10,16.9748111 C10,15.675063 12,15.675063 12,16.9748111 L12,16.9748111 L12,21.0251889 C12,22.324937 10,22.324937 10,21.0251889 L10,21.0251889 Z M21.0251889,10 C22.324937,10 22.324937,12 21.0251889,12 L21.0251889,12 L16.9748111,12 C15.675063,12 15.675063,10 16.9748111,10 L16.9748111,10 Z M5.02518892,10 C6.32493703,10 6.32493703,12 5.02518892,12 L5.02518892,12 L0.974811083,12 C-0.324937028,12 -0.324937028,10 0.974811083,10 L0.974811083,10 Z M18.252344,3.31953193 C19.2147754,2.3571005 20.6428995,3.78522456 19.6804681,4.74765599 L19.6804681,4.74765599 L16.7310814,7.69704264 C15.7996962,8.6284279 14.3715721,7.20030384 15.3029574,6.26891858 L15.3029574,6.26891858 Z M2.30295736,4.74765599 C1.3715721,3.78522456 2.79969616,2.3571005 3.73108142,3.31953193 L3.73108142,3.31953193 L6.68046807,6.26891858 C7.6428995,7.20030384 6.21477544,8.6284279 5.25234401,7.69704264 L5.25234401,7.69704264 Z M10,0.974811083 C10,-0.324937028 12,-0.324937028 12,0.974811083 L12,0.974811083 L12,5.02518892 C12,6.32493703 10,6.32493703 10,5.02518892 L10,5.02518892 Z M16.7310814,14.3029574 L19.6804681,17.252344 C20.6428995,18.2147754 19.2147754,19.6428995 18.252344,18.6804681 L15.3029574,15.7310814 C14.3715721,14.7996962 15.7996962,13.3715721 16.7310814,14.3029574 Z M6.68046807,15.7310814 L3.73108142,18.6804681 C2.79969616,19.6428995 1.3715721,18.2147754 2.30295736,17.252344 L5.25234401,14.3029574 C6.21477544,13.3715721 7.6428995,14.7996962 6.68046807,15.7310814 Z M11,7 C13.209139,7 15,8.790861 15,11 C15,13.209139 13.209139,15 11,15 C8.790861,15 7,13.209139 7,11 C7,8.790861 8.790861,7 11,7 Z'
      id='path-1'
    ></path>
  </SvgIcon>
);

export const CopyCircle = (props) => (
  <SvgIcon viewBox='0 0 18 18' style={{ height: '18px', width: '18px' }}>
    <path
      d='M18,9 C18,13.9705655 13.9705655,18 9,18 C4.02943455,18 0,13.9705655 0,9 C0,4.02943455 4.02943455,0 9,0 C13.9705655,0 18,4.02943455 18,9'
      id='Fill-1'
      fill='#1B4160'
    ></path>
    <path
      d='M6.06,4.5 L6.06,6.84 L4.5,6.84 L4.5,12.3 L6.06,12.3 L6.06,13.86 L12.3000153,13.86 L12.3000153,12.3 L13.86,12.3 L13.86,6.84 L12.3000153,6.84 L12.3000153,4.5 L6.06,4.5 Z M5.28001529,7.62 L13.08,7.62 L13.08,11.52 L12.3000153,11.52 L12.3000153,9.96 L6.06,9.96 L6.06,11.52 L5.28001529,11.52 L5.28001529,7.62 Z'
      id='Page-1'
      fill='#FFFFFF'
    ></path>
    <path
      d='M18,9 C18,13.9705655 13.9705655,18 9,18 C4.02943455,18 0,13.9705655 0,9 C0,4.02943455 4.02943455,0 9,0 C13.9705655,0 18,4.02943455 18,9'
      id='Fill-1-Copy'
    ></path>
    <g
      id='SplashIcon/AddOn-Light'
      transform='translate(4.500000, 4.500000)'
      fill='#FFFFFF'
    >
      <polygon
        id='Fill-1'
        points='0 2.44333784 0 8.98810135 6.54809932 8.98810135 6.54809932 7.50709459 1.5517991 7.50709459 1.5517991 2.44333784'
      ></polygon>
      <polygon
        id='Fill-2'
        points='2.43641986 6.54474324 8.98451919 6.54474324 8.98451919 0 2.43641986 0'
      ></polygon>
    </g>
  </SvgIcon>
);

export const Instagram = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M13.115 10.12a2.995 2.995 0 01-2.995 2.995H4.362a2.995 2.995 0 01-2.995-2.995V4.362a2.996 2.996 0 012.995-2.996h5.758a2.996 2.996 0 012.995 2.996v5.758zm1.366-5.758A4.362 4.362 0 0010.12 0H4.362A4.362 4.362 0 000 4.362v5.758a4.362 4.362 0 004.36 4.36h5.759a4.362 4.362 0 004.36-4.36V4.362zM7.265 9.625a2.294 2.294 0 01-2.291-2.291 2.294 2.294 0 012.29-2.29 2.292 2.292 0 012.292 2.29 2.293 2.293 0 01-2.291 2.29zm0-5.867a3.58 3.58 0 00-3.576 3.576 3.58 3.58 0 003.576 3.576 3.58 3.58 0 003.577-3.576 3.58 3.58 0 00-3.577-3.576zm3.786-1.092a.852.852 0 100 1.703.852.852 0 000-1.703z' />
  </SvgIcon>
);

export const NowstaLogo = (props) => (
  <SvgIcon
    style={{ width: '16px', height: '15px' }}
    viewBox='0 0 16 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Icons/Nowsta@2x</title>
    <defs>
      <path
        d='M15.6155603,6.94272646 C14.1310961,7.76549009 12.6463891,8.58777919 11.1623295,9.41117554 C7.8841275,11.2300661 4.60705841,13.0508547 1.32772358,14.8676889 C0.689027688,15.2215334 0,14.8303589 0,14.1134955 C0.000566434975,9.98884213 0.00161838564,5.86410967 0.0112477802,1.7394563 C0.013756278,0.635135569 0.677860827,0.00329295898 1.80490459,0.00242297917 C4.40710687,0.000445752329 7.00947098,-0.00200600895 9.61167326,0.00273933547 C12.8390579,0.00851283784 15.5528479,2.35975191 15.9297699,5.49136287 C15.9966901,6.04735906 15.9936961,6.6130832 15.9953954,7.17437836 C16.0021927,9.40136849 16.0014644,11.6285168 15.9932106,13.855586 C15.9923205,14.087317 15.9606811,14.3321768 15.8786289,14.5473782 C15.737182,14.918385 15.3847785,15.079964 14.9952331,14.9577714 C14.7167089,14.8703779 14.4482188,14.7401973 14.1915428,14.6004469 C12.6980156,13.7874903 11.2092626,12.9661503 9.71937682,12.1468666 C9.62761436,12.0964078 9.53997878,12.0387518 9.41172171,11.9609282 C10.4809082,11.1157033 11.5261426,10.2895388 12.571296,9.46313706 C13.6071437,8.6441697 14.6428296,7.8248069 15.6785964,7.00568136 C15.6576383,6.98472276 15.6365993,6.96376415 15.6155603,6.94272646'
        id='path-1'
      ></path>
    </defs>
    <g
      id='Icons/Nowsta'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-1'></use>
        </mask>
        <use id='Mask' fill={props.color} xlinkHref='#path-1'></use>
      </g>
    </g>
  </SvgIcon>
);

// Checkbox
export const CheckOn = (props) => (
  <SvgIcon
    viewBox='0 0 14 14'
    style={{ height: '14px', width: '15px' }}
    {...props}
  >
    <path d='M2,0 C0.9,0 0,0.9 0,2 L0,12 C0,13.1 0.9,14 2,14 L12,14 C13.1,14 14,13.1 14,12 L14,2 C14,0.9 13.1,0 12,0 L2,0 Z' />
    <polygon
      fill='currentColor'
      points='2 8.19230769 3.4 6.84615385 5 8.30769231 10.6 3 12 4.34615385 5 11'
    />
  </SvgIcon>
);
export const CheckOnCircle = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M22.1292224 24.6057866l-4.7162387 4.7161664-.0481736.0481012-4.716094-4.716094.0481736-.0481736-4.15103075-4.1510307 4.71623865-4.7162387 4.1509585 4.1510307 9.2922242-9.2922242 4.7161664 4.7162387-9.2922966 9.2922242h.0000723zM19.9836166 0C8.94694394 0-.00003617 8.94705244-.00003617 19.9837251c0 11.0366727 8.9469801 19.9836528 19.98365277 19.9836528 11.0366727 0 19.9836528-8.9469801 19.9836528-19.9836528C39.9672694 8.94705244 31.0202893 0 19.9836166 0z' />
  </SvgIcon>
);
export const CheckOff = (props) => (
  <SvgIcon
    viewBox='0 0 14 14'
    style={{ height: '14px', width: '15px' }}
    {...props}
  >
    <path d='M2,0 C0.9,0 0,0.9 0,2 L0,12 C0,13.1 0.9,14 2,14 L12,14 C13.1,14 14,13.1 14,12 L14,2 C14,0.9 13.1,0 12,0 L2,0 Z' />
  </SvgIcon>
);
export const CheckIndeterminate = (props) => (
  <SvgIcon
    viewBox='3 1 19 21'
    style={{ height: '14px', width: '15px' }}
    {...props}
  >
    <path d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' />
  </SvgIcon>
);
export const CheckMark = (props) => (
  <svg width='14px' height='11px' viewBox='0 0 14 11'>
    <path
      d='M0,5.76442308 L1.78181818,3.91346154 L5.09090909,7.29807692 L12.2181818,0 L14,1.85096154 L5.09090909,11 L0,5.76442308 Z'
      fill='#278ADA'
    />
  </svg>
);
export const FillableCheckMark = (props) => (
  <svg width='14px' height='11px' viewBox='0 0 14 11' {...props}>
    <path d='M0,5.76442308 L1.78181818,3.91346154 L5.09090909,7.29807692 L12.2181818,0 L14,1.85096154 L5.09090909,11 L0,5.76442308 Z' />
  </svg>
);
export const CheckMarkEmpty = (props) => (
  <SvgIcon style={{ height: '11px', width: '14px' }} viewBox='0 0 14 11'>
    <path d='M0,5.76442308 L1.78181818,3.91346154 L5.09090909,7.29807692 L12.2181818,0 L14,1.85096154 L5.09090909,11 L0,5.76442308 Z' />
  </SvgIcon>
);
export const Proposals = (props) => (
  <svg
    width='14px'
    height='17px'
    viewBox='0 0 14 17'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.8,8.78021978 C12.1195959,8.78021978 14,10.6202803 14,12.8901099 C14,15.1599395 12.1195959,17 9.8,17 C7.48040405,17 5.6,15.1599395 5.6,12.8901099 C5.6,10.6202803 7.48040405,8.78021978 9.8,8.78021978 Z M4.9720078,0 C5.16914447,0 5.33357325,0.135214444 5.37160018,0.314944172 L5.37988539,0.394432195 L5.37988539,2.76125096 C5.37988539,3.69259306 6.12151781,4.4564038 7.06479846,4.53045652 L7.21533453,4.53634086 L9.66263338,4.53634086 C9.85974089,4.53634086 10.024166,4.67153062 10.0621925,4.85129736 L10.0704776,4.93080528 L10.0711401,7.87379783 C9.98135132,7.86922549 9.89095189,7.86691087 9.8,7.86691087 C6.96493828,7.86691087 4.66666667,10.1158737 4.66666667,12.8901099 C4.66666667,13.7313325 4.87798459,14.524258 5.25150924,15.2208291 L0.815721852,15.2203646 C0.399877425,15.2203646 0.0566928473,14.9194293 0.0063558379,14.5304294 L0,14.431468 L0,0.788928844 C0,0.386700077 0.311196545,0.0548241016 0.713401916,0.00614631103 L0.815721852,0 L4.9720078,0 Z M11.6471663,11.1483479 L9.11118657,13.4904199 L7.9855004,12.4454256 L7.28,13.1291798 L8.21074706,13.9979874 L9.07854592,14.8080586 L12.32,11.7822324 L11.6471663,11.1483479 Z M6.89948799,0.493356782 L6.95226015,0.530538534 L9.52598773,3.01566439 C9.56487606,3.05298382 9.58660287,3.10383879 9.58630296,3.15685301 C9.58574757,3.24762709 9.52187785,3.32371977 9.43542231,3.34618948 L9.38116452,3.35292503 L7.21534786,3.35292503 C6.91123913,3.35292503 6.65895485,3.13834799 6.61153908,2.85722856 L6.60353148,2.76126062 L6.60353148,0.670566958 C6.60323157,0.617584972 6.62495838,0.566697773 6.66384671,0.529378345 C6.72782751,0.468042994 6.82326553,0.456085308 6.89948799,0.493356782 Z'
      id='path-1'
    ></path>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Splashicon/Proposals'>
        <mask id='mask-2' fill='white'>
          <use></use>
        </mask>
        <use id='Mask' fill='#278ADA'></use>
      </g>
    </g>
  </svg>
);

// Arrows
export const ArrowUp = (props) => (
  <SvgIcon
    viewBox='0 0 12 8'
    style={{ height: '8px', width: '12px' }}
    {...props}
  >
    <polygon points='6.00003849 0 7.99360578e-14 5.87245583 2.17367079 7.99989955 5.99998717 4.25498788 9.82632921 8 12 5.87253117' />
  </SvgIcon>
);
export const ArrowDown = (props) => (
  <SvgIcon
    viewBox='0 0 12 8'
    style={{ height: '8px', width: '12px' }}
    {...props}
  >
    <polygon
      transform='translate(6.000000, 4.000000) rotate(180.000000) translate(-6.000000, -4.000000) '
      points='6.00003849 0 7.99360578e-14 5.87245583 2.17367079 7.99989955 5.99998717 4.25498788 9.82632921 8 12 5.87253117'
    />
  </SvgIcon>
);
export const ArrowLeft = (props) => (
  <SvgIcon
    viewBox='0 0 8 12'
    style={{ height: '12px', width: '8px' }}
    {...props}
  >
    <polygon
      transform='translate(4.000000, 6.000000) rotate(270.000000) translate(-4.000000, -6.000000) '
      points='4.00003849 2 -2 7.87245583 0.173670785 9.99989955 3.99998717 6.25498788 7.82632921 10 10 7.87253117'
    />
  </SvgIcon>
);
export const ArrowRight = (props) => (
  <SvgIcon
    viewBox='0 0 8 12'
    style={{ height: '12px', width: '8px' }}
    {...props}
  >
    <polygon
      transform='translate(4.000000, 6.000000) rotate(90.000000) translate(-4.000000, -6.000000) '
      points='4.00003849 2 -2 7.87245583 0.173670785 9.99989955 3.99998717 6.25498788 7.82632921 10 10 7.87253117'
    />
  </SvgIcon>
);
export const ArrowUpRight = (props) => (
  <SvgIcon viewBox='0 0 15 14' {...props}>
    <path d='M3.513 0v3.309h4.963l-8.485 8.347L2.334 14l8.486-8.348v4.688h3.309V0z' />
  </SvgIcon>
);
export const ArrowDownRight = (props) => (
  <SvgIcon viewBox='0 0 14 14' {...props}>
    <path d='M2.344.847L0 3.19l8.348 8.485H3.66v3.309H14V4.369h-3.309v4.963z' />
  </SvgIcon>
);
export const ArrowCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path
      fill='#278ADA'
      d='M10.9310537 21.921099c-6.03705972 0-10.93105766-4.8983315-10.93105766-10.9407371 0-6.0424055 4.89399794-10.94073707 10.93105766-10.94073707 6.0370597 0 10.9310577 4.89833156 10.9310577 10.94073707 0 6.0424056-4.893998 10.9407371-10.9310577 10.9407371z'
    />
    <path
      fill='#FFFFFF'
      d='M15 11.50002886L10.59565812 7 9.00007534 8.6302531l2.80868375 2.86973728L9 14.3697469 10.59560162 16'
    />
  </SvgIcon>
);

// Pagination
export const FirstPage = (props) => (
  <SvgIcon
    viewBox='0 0 8 12'
    style={{ height: '12px', width: '8px' }}
    {...props}
  >
    <polygon
      transform='translate(5.000000, 6.000000) rotate(270.000000) translate(-5.000000, -6.000000) '
      points='5 3 11 9 -1 9'
    />
    <rect x='0' y='0' width='2' height='12' />
  </SvgIcon>
);
export const PreviousPage = (props) => (
  <SvgIcon
    viewBox='0 0 6 12'
    style={{ height: '12px', width: '6px' }}
    {...props}
  >
    <polygon
      transform='translate(3.000000, 6.000000) rotate(270.000000) translate(-3.000000, -6.000000) '
      points='3 3 9 9 -3 9'
    />
  </SvgIcon>
);
export const NextPage = (props) => (
  <SvgIcon
    viewBox='0 0 6 12'
    style={{ height: '12px', width: '6px' }}
    {...props}
  >
    <polygon
      transform='translate(3.000000, 6.000000) rotate(90.000000) translate(-3.000000, -6.000000) '
      points='3 3 9 9 -3 9'
    />
  </SvgIcon>
);
export const LastPage = (props) => (
  <SvgIcon
    viewBox='0 0 8 12'
    style={{ height: '12px', width: '8px' }}
    {...props}
  >
    <polygon
      transform='translate(3.000000, 6.000000) rotate(90.000000) translate(-3.000000, -6.000000) '
      points='3 3 9 9 -3 9'
    />
    <rect x='6' y='0' width='2' height='12' />
  </SvgIcon>
);

// Actions
export const Add = (props) => (
  <SvgIcon viewBox='0 0 40 41' {...props}>
    <polygon points='15.6110217 0 15.6110217 15.6110217 15.5206425 15.6110217 0 15.6110217 0 24.4794315 15.5204204 24.4793575 15.5204204 24.4795796 15.5205685 24.4795796 15.5205685 40.0906012 24.3890524 40.0906012 24.3890524 24.4796536 24.4795055 24.4796536 24.4795055 24.4795796 40 24.4795796 40 15.6110957 24.4796536 15.6111697 24.4796536 15.6110217 24.4795796 15.6110217 24.4795796 0' />
  </SvgIcon>
);
export const AddCircle = (props) => (
  <SvgIcon viewBox='0 0 25 25' height='25px' width='26px' {...props}>
    <path
      fill={props.fillColor}
      d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783'
    />
    <path
      fill='#FFFFFF'
      d='M9.64387561 8 8.0166147 9.62726091 10.8644317 12.4750395 10.8644125 12.4750972 10.8644317 12.4751356 8 15.3395673 9.62726091 16.9668282 12.4916927 14.1023773 12.5082689 14.1189728 15.3561244 16.9668282 16.9834045 15.3395673 14.1355683 12.4917695 14.1356067 12.4917503 14.1355683 12.4916927 17 9.62729933 15.3727583 8.00003842 12.5083073 10.8644125 12.4917311 10.8478362z'
      transform='translate(12.500000, 12.483414) rotate(45.000000) translate(-12.500000, -12.483414)'
    />
  </SvgIcon>
);

export const SubtractCircle = (props) => (
  <SvgIcon viewBox='0 0 25 25' height='25px' width='26px' {...props}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path d='M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7 14h-14v-4h14v4z' />
    </svg>
  </SvgIcon>
);
export const ImportCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <path
      fill='#FFFFFF'
      d='M12.408779,13.4978008 L8.00001146,13.4978008 C10.0919382,9.97204144 12.1600465,6.48592046 14.2283554,2.99999511 C14.2580497,3.0071843 14.2879732,3.01437349 14.3173809,3.02153822 C13.7373968,5.71501441 13.1576707,8.40851506 12.570865,11.1344649 L16.9856803,11.1344649 C14.7523904,14.7904366 12.5519764,18.3928561 10.3512471,21.9950556 C10.3247057,21.9874507 10.2981643,21.9798458 10.2716229,21.972192 C10.9803586,19.161757 11.6892949,16.3508329 12.408779,13.4978008'
    />
  </SvgIcon>
);
export const EditIcon = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path
      fill='#FFFFFF'
      d='M15.7027299,6.99999779 L14.5456268,8.15707879 L16.842919,10.454371 L18,9.29726794 L15.7027299,6.99999779 Z M9.26267165,13.4400781 L11.5599418,15.7373482 L16.0855898,11.2117002 L13.7882976,8.91440798 L9.26267165,13.4400781 Z M8,16.9999757 L10.8843118,16.3454108 L8.65458697,14.115686 L8,16.9999757 Z'
    />
  </SvgIcon>
);
export const EditCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path
      fill={props.fillColor}
      d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783'
    />
    <path
      fill='#FFFFFF'
      d='M15.7027299,6.99999779 L14.5456268,8.15707879 L16.842919,10.454371 L18,9.29726794 L15.7027299,6.99999779 Z M9.26267165,13.4400781 L11.5599418,15.7373482 L16.0855898,11.2117002 L13.7882976,8.91440798 L9.26267165,13.4400781 Z M8,16.9999757 L10.8843118,16.3454108 L8.65458697,14.115686 L8,16.9999757 Z'
    />
  </SvgIcon>
);
export const WritePaper = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path fill={props.fillColor || '#FFFFFF'} d="M16.3154 11.485C15.9334 11.485 15.6233 11.7979 15.6233 12.1835V14.6019H8.38416V7.29505H10.7746C11.1566 7.29505 11.4667 6.9821 11.4667 6.5965C11.4667 6.2109 11.1566 5.89795 10.7746 5.89795H7.69208C7.31005 5.89795 7 6.2109 7 6.5965V15.3004C7 15.686 7.31005 15.999 7.69208 15.999H16.3154C16.6974 15.999 17.0075 15.686 17.0075 15.3004V12.1835C17.0075 11.7979 16.6974 11.485 16.3154 11.485Z" />
    <path fill={props.fillColor || '#FFFFFF'} d="M19.6581 5.29997L17.5819 3.20433C17.312 2.93189 16.8732 2.93189 16.6033 3.20433L10.1559 9.70921C10.0341 9.83216 9.96209 9.99702 9.95378 10.1703L9.84997 12.3707C9.84028 12.5677 9.91364 12.7591 10.0521 12.8974C10.1822 13.0287 10.358 13.1014 10.542 13.1014C10.5531 13.1014 10.5642 13.1014 10.5753 13.1014L12.7553 12.9966C12.927 12.9882 13.0903 12.9156 13.2121 12.7926L19.6581 6.28632C19.7882 6.155 19.8602 5.97757 19.8602 5.79175C19.8602 5.60594 19.7868 5.42851 19.6581 5.29718V5.29997ZM12.4217 11.6149L11.2687 11.6707L11.3241 10.507L15.9624 5.82528L17.0601 6.93318L12.4217 11.6149Z" />
  </SvgIcon>
);
export const RemoveCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.9795615,12.5101989 C24.9795615,19.4081193 19.3876989,24.9999819 12.4897785,24.9999819 C5.59185805,24.9999819 -4.52079576e-06,19.4081193 -4.52079576e-06,12.5101989 C-4.52079576e-06,5.61227848 5.59185805,0.0204159132 12.4897785,0.0204159132 C19.3876989,0.0204159132 24.9795615,5.61227848 24.9795615,12.5101989' />
    <polygon
      fill={props.xFillColor || '#FFFFFF'}
      points='9.64387561 8 8.0166147 9.62726091 10.8644317 12.4750395 10.8644125 12.4750972 10.8644317 12.4751356 8 15.3395673 9.62726091 16.9668282 12.4916927 14.1023773 12.5082689 14.1189728 15.3561244 16.9668282 16.9834045 15.3395673 14.1355683 12.4917695 14.1356067 12.4917503 14.1355683 12.4916927 17 9.62729933 15.3727583 8.00003842 12.5083073 10.8644125 12.4917311 10.8478362'
    />
  </SvgIcon>
);

export const DeleteCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path
      d='M24.9795615,12.5101989 C24.9795615,19.4081193 19.3876989,24.9999819 12.4897785,24.9999819 C5.59185805,24.9999819 -4.52079576e-06,19.4081193 -4.52079576e-06,12.5101989 C-4.52079576e-06,5.61227848 5.59185805,0.0204159132 12.4897785,0.0204159132 C19.3876989,0.0204159132 24.9795615,5.61227848 24.9795615,12.5101989'
      id='Fill-1'
    />
    <path
      fill='#FFFFFF'
      d='M11.2971201,6 L11.2971201,6.9809062 L7,6.9809062 L7,9.12896449 L17.8495761,9.12896449 L17.8495761,6.9809062 L13.5524768,6.9809062 L13.5524768,6 L11.2971201,6 Z M14.8426499,10.1527106 L14.8426499,16.5305453 L13.5524768,16.5305453 L13.5524768,10.1527106 L11.2971201,10.1527106 L11.2971201,16.5305453 L10.0069471,16.5305453 L10.0069471,10.1527106 L7.85884698,10.1527106 L7.85884698,18.7705766 L16.9906664,18.7705766 L16.9906664,10.1527106 L14.8426499,10.1527106 Z'
    />
  </SvgIcon>
);
export const Settings = (props) => (
  <SvgIcon viewBox='0 0 12 12' {...props}>
    <path d='M5.60489641,7.59561373 C4.49250001,7.58717657 3.59380466,6.69780485 3.60268043,5.61338026 C3.61114166,4.52895566 4.52397971,3.65334483 5.63640049,3.66180576 C6.74896757,3.67007655 7.64734592,4.55944827 7.63864085,5.64387286 C7.62996016,6.72829746 6.71748787,7.60407466 5.60489641,7.59561373 L5.60489641,7.59561373 Z M9.90005836,6.21213341 C9.92510069,6.03236249 9.94365688,5.85223506 9.94497362,5.66148395 C9.94672926,5.47037634 9.93105037,5.29024891 9.90893412,5.11014526 L11.1329847,4.19225356 C11.2435903,4.10861873 11.2726804,3.95736778 11.2049661,3.83349602 L10.0675274,1.87973499 C9.99947177,1.75567309 9.84356071,1.70942319 9.7166178,1.75351032 L8.27681793,2.30470641 C7.97848014,2.07797259 7.65736773,1.89004971 7.30662881,1.74673683 L7.09953581,0.255617356 C7.08302787,0.120575264 6.96288808,0.0185688128 6.81858379,0.0175706136 L4.51205595,7.06104973e-06 C4.36806865,-0.000967371501 4.24622198,0.0990189149 4.22786086,0.234061007 L3.99677404,1.72168678 C3.64381617,1.85953334 3.31948508,2.04826428 3.01795299,2.26487351 L1.58695573,1.69200224 C1.45523356,1.64040484 1.3044919,1.68983947 1.23402225,1.81276057 L0.0654208181,3.74905312 C-0.0104620751,3.87195045 0.0227001147,4.02372426 0.131989037,4.10897523 L1.34138484,5.04528608 C1.31622059,5.2249144 1.2978107,5.41034179 1.29646958,5.59579294 C1.29493339,5.78122032 1.31010022,5.9670042 1.33255785,6.14713163 L0.108336593,7.06499956 C-0.00229344746,7.14861062 -0.0315785872,7.2999091 0.0361844463,7.42394724 L1.17362317,9.37766073 C1.24216649,9.50158003 1.39771179,9.5478537 1.52465471,9.50371903 L2.96450334,8.95259424 C3.26262168,9.17930429 3.58392916,9.36739354 3.9346437,9.51051629 L4.14195616,11.0016595 C4.15826903,11.1366541 4.27855512,11.2386843 4.42254242,11.2396587 L6.72907026,11.2572223 C6.87337455,11.2582443 6.99487984,11.1582104 7.01360672,11.0232159 L7.24435217,9.53559011 C7.59748072,9.39774355 7.92166551,9.20917897 8.22353897,8.99237961 L9.65431678,9.56525088 C9.78623402,9.61684828 9.93717075,9.56743741 10.0071283,9.44451631 L11.1757054,7.5082 C11.2454435,7.38530267 11.2185724,7.23357639 11.1093322,7.14830166 L9.90005836,6.21213341 Z' />
  </SvgIcon>
);
export const SettingsCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <path
      fill='#FFFFFF'
      d='M12.4703493,14.4622708 C11.3579529,14.4538337 10.4592575,13.564462 10.4681333,12.4800374 C10.4765945,11.3956128 11.3894326,10.5200019 12.5018534,10.5284629 C13.6144204,10.5367337 14.5127988,11.4261054 14.5040937,12.51053 C14.495413,13.5949546 13.5829407,14.4707318 12.4703493,14.4622708 L12.4703493,14.4622708 Z M16.7655112,13.0787905 C16.7905536,12.8990196 16.8091097,12.7188922 16.8104265,12.5281411 C16.8121821,12.3370334 16.7965032,12.156906 16.774387,11.9768024 L17.9984375,11.0589107 C18.1090432,10.9752758 18.1381333,10.8240249 18.070419,10.7001531 L16.9329803,8.74639209 C16.8649246,8.62233019 16.7090136,8.5760803 16.5820707,8.62016743 L15.1422708,9.17136352 C14.843933,8.9446297 14.5228206,8.75670682 14.1720817,8.61339393 L13.9649887,7.12227446 C13.9484807,6.98723237 13.8283409,6.88522592 13.6840366,6.88422772 L11.3775088,6.86666417 C11.2335215,6.86568974 11.1116748,6.96567602 11.0933137,7.10071811 L10.8622269,8.58834389 C10.509269,8.72619044 10.1849379,8.91492139 9.88340586,9.13153062 L8.4524086,8.55865934 C8.32068643,8.50706195 8.16994477,8.55649658 8.09947511,8.67941768 L6.93087368,10.6157102 C6.85499079,10.7386076 6.88815298,10.8903814 6.9974419,10.9756323 L8.2068377,11.9119432 C8.18167345,12.0915715 8.16326356,12.2769989 8.16192244,12.46245 C8.16038625,12.6478774 8.17555308,12.8336613 8.19801071,13.0137887 L6.97378946,13.9316567 C6.86315942,14.0152677 6.83387428,14.1665662 6.90163731,14.2906043 L8.03907604,16.2443178 C8.10761936,16.3682371 8.26316466,16.4145108 8.39010757,16.3703761 L9.82995621,15.8192513 C10.1280745,16.0459614 10.449382,16.2340506 10.8000966,16.3771734 L11.007409,17.8683166 C11.0237219,18.0033112 11.144008,18.1053414 11.2879953,18.1063158 L13.5945231,18.1238794 C13.7388274,18.1249014 13.8603327,18.0248675 13.8790596,17.889873 L14.109805,16.4022472 C14.4629336,16.2644007 14.7871184,16.0758361 15.0889918,15.8590367 L16.5197696,16.431908 C16.6516869,16.4835054 16.8026236,16.4340945 16.8725812,16.3111734 L18.0411583,14.3748571 C18.1108964,14.2519598 18.0840253,14.1002335 17.9747851,14.0149588 L16.7655112,13.0787905 Z'
    />
  </SvgIcon>
);
export const Print = (props) => (
  <SvgIcon viewBox='0 0 11 11' {...props}>
    <path
      fill={props.fillColor}
      d='M1.733 0v2.6H0v6.067h1.733V10.4h6.934V8.667H10.4V2.6H8.667V0H1.733zM.867 3.467h8.666V7.8h-.866V6.067H1.733V7.8H.867V3.467z'
    />
  </SvgIcon>
);
export const PrintCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <path
      fill='#FFFFFF'
      d='M8.16666667,6 L8.16666667,9.25 L6,9.25 L6,16.8333333 L8.16666667,16.8333333 L8.16666667,19 L16.8333546,19 L16.8333546,16.8333333 L19,16.8333333 L19,9.25 L16.8333546,9.25 L16.8333546,6 L8.16666667,6 Z M7.08335458,10.3333333 L17.9166667,10.3333333 L17.9166667,15.75 L16.8333546,15.75 L16.8333546,13.5833333 L8.16666667,13.5833333 L8.16666667,15.75 L7.08335458,15.75 L7.08335458,10.3333333 Z'
    />
  </SvgIcon>
);
export const Search = (props) => (
  <SvgIcon viewBox='0 0 11 11' {...props}>
    <path d='M6.725 6.135a1.85 1.85 0 0 1 0-3.7 1.85 1.85 0 0 1 0 3.7m0-6.135a4.285 4.285 0 0 0-3.884 6.072L0 8.92l2.058 2.062 2.825-2.83a4.242 4.242 0 0 0 1.842.418 4.285 4.285 0 0 0 0-8.569' />
  </SvgIcon>
);
export const StarCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <polygon
      fill='#FFFFFF'
      points='11.6501 6.1220602 11.7737919 10.8548572 7.644599 9.31847763 7 11.3624588 11.1291255 12.6106619 8.38567227 16.3968052 10.1137541 17.6450084 12.5830439 13.7768755 15.1070384 17.7412132 16.8357939 16.465523 14.1332007 12.7343538 18.3308418 11.4859148 17.6860744 9.40070307 13.6255655 10.9235076 13.7629336 6.1220602'
    />
  </SvgIcon>
);

export const ServiceCircle = (props) => (
  <SvgIcon
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Color/Blue</title>
    <defs>
      <path
        d='M10.0003704,0.000370384088 L7.87510649,2.06563206 L5.00018519,1.34042002 L4.19200711,4.19163673 L1.34004963,4.99981481 L2.06600244,7.8747361 L0,10.0014815 L2.06600244,12.1267454 L1.34004963,15.0001852 L4.19200711,15.8098448 L5.00018519,18.6610615 L7.87510649,17.9343679 L10.0003704,19.9996296 L12.1263751,17.9343679 L14.9998148,18.6610615 L15.8079929,15.8098448 L18.6606911,15.0001852 L17.9347383,12.1267454 L20,10.0014815 L17.9347383,7.8747361 L18.6606911,4.99981481 L15.8079929,4.19163673 L14.9998148,1.34042002 L12.1263751,2.06563206 L10.0003704,0.000370384088 Z M7.8839957,11.009667 L4.45868365,8.52142672 L8.69143302,8.52142672 L10.0003704,4.49535168 L11.308567,8.52142672 L15.5420571,8.52142672 L12.1167451,11.009667 L13.4249417,15.0357421 L10.0003704,12.5475018 L6.57505834,15.0357421 L7.8839957,11.009667 Z'
        id='path-10'
      ></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-3' fill='white'>
          <use xlinkHref='#path-10'></use>
        </mask>
        <use id='Mask' fill='#278ADA' xlinkHref='#path-10'></use>
        <g
          mask='url(#mask-3)'
          fill={props.color ? `${props.color}` : '#278ADA'}
          id='Rectangle-11'
        >
          <rect x='0' y='0' width='20' height='20'></rect>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const SignOutCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <path
      fill='currentColor'
      d='M7,7 L7,18.7152247 L16.2326036,18.7152247 L16.2326036,15.658319 L14.3460263,15.658319 L14.3460263,16.8473695 L8.88619408,16.8473695 L8.88619408,8.86711808 L14.3460263,8.86711808 L14.3460263,10.0573185 L16.2326036,10.0573185 L16.2326036,7 L7,7 Z M18.1636868,11.9741841 L11.6129554,11.9741841 L11.6129554,13.8409484 L18.1636868,13.8409484 L18.1636868,16.179158 L21.4703494,12.9073746 L18.1636868,9.63597453 L18.1636868,11.9741841 Z'
    />
  </SvgIcon>
);
export const TempItem = (props) => (
  <SvgIcon viewBox='0 0 17 17' {...props}>
    <path d='M2.26669294 6.3423544c-.17436734.4576642-.28334136.9371855-.32692207 1.4166623l-1.9397198-.217948c.0653488-.6320761.19613543-1.242295.41408347-1.85255844l1.8525584.65384414zm1.54740442-2.48458992c-.34869016.34869016-.65384414.74100555-.9153729 1.15508903L1.24234603 3.966694c.34869017-.52305752.74100556-1.02434693 1.19871426-1.48205563l1.37303707 1.3731261zM1.93977086 9.2410278c.04358072.4795213.15255474.9589536.32692208 1.4166623l-1.8525584.6538442C.2179991 10.7230834.06539986 10.0910519.00005106 9.4589759l1.9397198-.2179481zm1.98330052 6.4730481l1.04615953-1.6563785c.414128.2615288.8717922.4794768 1.3295009.6320761l-.65384413 1.8525584c-.61026343-.2179926-1.17694616-.4795213-1.72181628-.828256zM6.2769192 2.31031554c-.4576642.17432283-.8935603.37045826-1.3294564.63203153L3.9013033 1.2859241C4.4461734.93718944 5.0128116.6756607 5.62307504.45775716l.65384415 1.8525584zM1.24234602 13.0333505l1.65637845-1.0461595c.26152875.4140835.56668273.8063989.9153729 1.1551336l-1.3730371 1.3730815c-.4577087-.435896-.85002408-.9371855-1.19871425-1.4820556zM7.5410268.04362915c.3051094-.0217681.5448701-.04362522.9589536-.04362522 4.5987215 0 8.5000183 3.81413533 8.5000183 8.50001837 0 4.685883-3.9012968 8.4999738-8.5000183 8.4999738-.4140835 0-.6538442 0-.9589536-.0435807l.217948-1.9397644c.2397607.0218127.4577087.0436253.7410056.0436253 3.639768 0 6.560254-2.9423432 6.560254-6.560254 0-3.61795542-2.920486-6.56020953-6.560254-6.56020953-.2832969 0-.5230575.0217681-.7627737.0435807L7.5410268.04362915zm1.8050203 4.62387247l.00001 2.97849358 2.9784836.00004-.00001 1.6920542-2.9785236.00002.00002 2.9612272-1.6920742-.00001.00001-2.9785136-2.97851357.00001V7.6287588l2.97855347-.0000499-.0000199-2.96120728h1.6920642z' />
  </SvgIcon>
);
export const TempItemCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566 12.489783c0 6.8979204-5.5918626 12.489783-12.489783 12.489783C5.59186257 24.979566 0 19.3877034 0 12.489783 0 5.59186257 5.59186257 0 12.489783 0c6.8979204 0 12.489783 5.59186257 12.489783 12.489783' />
    <path
      fill='#FFFFFF'
      d='M6.26669294 10.3423544c-.17436734.4576642-.28334136.9371855-.32692207 1.4166623l-1.93971981-.217948c.0653488-.6320761.19613544-1.242295.41408348-1.85255844l1.8525584.65384414zm1.54740442-2.48458992c-.34869016.34869016-.65384414.74100555-.91537289 1.15508903L5.24234602 7.96669399c.34869017-.52305751.74100556-1.02434692 1.19871426-1.48205562l1.37303708 1.37312611zM5.93977087 13.2410278c.04358071.4795213.15255473.9589536.32692207 1.4166623l-1.8525584.6538442c-.19613543-.5884509-.34873468-1.2204824-.41408348-1.8525584l1.93971981-.2179481zm1.98330051 6.4730481l1.04615953-1.6563785c.414128.2615288.87179219.4794768 1.32950089.6320761l-.65384414 1.8525584c-.61026343-.2179926-1.17694616-.4795213-1.72181628-.828256zM10.2769192 6.31031554c-.4576642.17432283-.89356029.37045826-1.32945639.63203153L7.90130329 5.28592411c.54487011-.34873468 1.11150833-.61026343 1.72177176-.82816696l.65384415 1.85255839zM5.24234602 17.0333505l1.65637845-1.0461595c.26152875.4140835.56668273.8063989.91537289 1.1551336l-1.37303708 1.3730815c-.4577087-.435896-.85002409-.9371855-1.19871426-1.4820556zM11.5410268 4.04362915c.3051094-.0217681.5448701-.04362522.9589536-.04362522 4.5987215 0 8.5000183 3.81413533 8.5000183 8.50001837 0 4.685883-3.9012968 8.4999738-8.5000183 8.4999738-.4140835 0-.6538442 0-.9589536-.0435807l.217948-1.9397644c.2397607.0218127.4577087.0436253.7410056.0436253 3.639768 0 6.560254-2.9423432 6.560254-6.560254 0-3.61795542-2.920486-6.56020953-6.560254-6.56020953-.2832969 0-.5230575.02176809-.7627737.0435807l-.1961799-1.93976432z'
    />
    <path
      fill='#FFFFFF'
      d='M13.34604698 8.66750156l-1.69206422 5e-8.00001998 2.96120725-2.97855352.00004994 6e-8 1.69206415 2.97851358-.00000997-.00000997 2.97851358 1.69207414.00001004-.00001994-2.96122729 2.97852355-.00001994.00000995-1.69205425-2.97848358-.00003997z'
    />
  </SvgIcon>
);
export const Connect = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M21.9781884 13l-.0363779 8.3126309L28.3404233 27H40v13H27v-9.2531964l-6.9017441-6.1345744L13 30.2787341V40H0V27h10.8927785l7.114509-5.6794457L18.0437364 13H14V0h13v13h-5.0218116z' />
  </SvgIcon>
);
export const ConnectCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566 12.489783c0 6.8979204-5.5918626 12.489783-12.489783 12.489783C5.59186257 24.979566 0 19.3877034 0 12.489783 0 5.59186257 5.59186257 0 12.489783 0c6.8979204 0 12.489783 5.59186257 12.489783 12.489783' />
    <path
      fill='#FFFFFF'
      d='M13.14291122 9.225l-.0118228 2.70160504L15.21063756 13.775H19V18h-4.225v-3.00728882l-2.24306685-1.99373669L10.225 14.84058858V18H6v-4.225h3.540153l2.31221543-1.84581985L11.86421433 9.225H10.55V5h4.225v4.225h-1.63208878z'
    />
  </SvgIcon>
);
export const WithSubRentals = (props) => (
  <SvgIcon viewBox='0 0 14 22' {...props}>
    <path
      fill={props.fillColor}
      d='M14 14.201V8.237H8.078v2.135H4.659V7.749h3.078V0H0v7.749h2.964v11.323h5.114v2.168H14v-5.965H8.078v2.104H4.659v-5.312h3.419v2.135H14zM9.515 9.673h3.049v3.09H9.515v-3.09zm0 7.04h3.049v3.09H9.515v-3.09z'
    />
  </SvgIcon>
);

// Properties
export const TitleCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M10.9310537 21.921099c-6.03705972 0-10.93105766-4.8983315-10.93105766-10.9407371 0-6.0424055 4.89399794-10.94073707 10.93105766-10.94073707 6.0370597 0 10.9310577 4.89833156 10.9310577 10.94073707 0 6.0424056-4.893998 10.9407371-10.9310577 10.9407371z' />
    <path
      fill='#FFFFFF'
      d='M15.5887258 7.52162207c.7744582 0 1.4020364.63521184 1.4020364 1.3895732v5.16125023c0 .7146593-.5608364 1.310169-1.2685091 1.3763608H6.40202764c-.7744582 0-1.40203637-.6219995-1.40203637-1.3895732V8.91119526c0-.75436135.62757818-1.3895732 1.40203637-1.3895732h9.18669816zm-2.0165236 6.84315443c.3937309 0 .4973454-.2464514.2279127-.5545534l-.9531709-1.0679344c-.2694109-.3080588-.8288509-.5544886-1.2433091-.5544886h-1.2018545c-.41445822 0-.97392004.2464298-1.24335276.5544886l-.9531709 1.0679344c-.29011638.308102-.18650183.5545534.22793453.5545534h5.13901093zm-2.5768146-6.2023489c-.9739418 0-1.78206542.80096157-1.78206542 1.76622407 0 .98582713.80812362 1.76624573 1.78206542 1.76624573.9946255 0 1.7820437-.8010049 1.7820437-1.76624573 0-.9857839-.8081018-1.76622408-1.7820437-1.76622408zm.3077026-3.64080553c.7121184 0 1.3030111.87832958 1.3030111 1.98777332H9.99999127c0-1.0863367.59089273-1.98777334 1.30309893-1.98777334z'
    />
  </SvgIcon>
);
export const PhoneCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,10.9891032 C21.9423354,17.0483162 17.0303787,21.9602729 10.9711657,21.9602729 C4.91195271,21.9602729 -3.97111913e-06,17.0483162 -3.97111913e-06,10.9891032 C-3.97111913e-06,4.92989025 4.91195271,0.017933574 10.9711657,0.017933574 C17.0303787,0.017933574 21.9423354,4.92989025 21.9423354,10.9891032' />
    <path
      fill='#FFFFFF'
      d='M16.0567,12.8864841 L13.3443462,11.8694011 L12.3272632,12.8864841 C10.9844292,11.9912747 9.8321296,10.8389751 8.93692022,9.49610144 L9.95400325,8.47901841 L8.93692022,5.76674404 L8.7473787,5.76674404 C8.00053032,5.76674404 7.28421986,6.06350578 6.75598159,6.59154549 C6.19875415,7.14881264 5.88563141,7.90475487 5.88563141,8.69278375 C5.88563141,9.21895704 6.02533538,9.73563935 6.29044729,10.1900942 C7.58082274,12.402087 9.42135704,14.2425816 11.6333498,15.532957 C12.0878444,15.7981087 12.6044076,15.9378126 13.1306603,15.9378126 C13.9187289,15.9378126 14.6746314,15.6246502 15.2318588,15.0674227 C15.7599383,14.5393036 16.0567,13.8229931 16.0567,13.0760256 L16.0567,12.8864841 Z'
    />
  </SvgIcon>
);
export const CellCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.942,11.011c0,6.06-4.912,10.972-10.971,10.972S0,17.07,0,11.011 C0,4.952,4.912,0.04,10.971,0.04S21.942,4.952,21.942,11.011' />
    <path
      fill='#FFFFFF'
      d='M14.082,4.979H8.055c-0.269,0-0.486,0.218-0.486,0.487v11.07c0,0.269,0.218,0.486,0.486,0.486h6.027 c0.27,0,0.486-0.218,0.486-0.486V5.465C14.568,5.196,14.352,4.979,14.082,4.979z M11.069,16.318c-0.504,0-0.913-0.408-0.913-0.912 s0.409-0.912,0.913-0.912c0.503,0,0.912,0.408,0.912,0.912S11.572,16.318,11.069,16.318z M13.404,13.624H8.733V6.143h4.671V13.624z'
    />
  </SvgIcon>
);
export const FaxCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,11.0109047 C21.9423354,17.0701177 17.0303787,21.9820744 10.9711657,21.9820744 C4.91195271,21.9820744 -3.97111913e-06,17.0701177 -3.97111913e-06,11.0109047 C-3.97111913e-06,4.9516917 4.91195271,0.0397350181 10.9711657,0.0397350181 C17.0303787,0.0397350181 21.9423354,4.9516917 21.9423354,11.0109047' />
    <path
      fill='#FFFFFF'
      d='M7.66666667,6 L7.66666667,8.5 L6,8.5 L6,14.3333333 L7.66666667,14.3333333 L7.66666667,16 L14.3333497,16 L14.3333497,14.3333333 L16,14.3333333 L16,8.5 L14.3333497,8.5 L14.3333497,6 L7.66666667,6 Z M6.83334967,9.33333333 L15.1666667,9.33333333 L15.1666667,13.5 L14.3333497,13.5 L14.3333497,11.8333333 L7.66666667,11.8333333 L7.66666667,13.5 L6.83334967,13.5 L6.83334967,9.33333333 Z'
    />
  </SvgIcon>
);
export const Email = (props) => (
  <SvgIcon viewBox='0 0 49 38' {...props}>
    <path d='M24.5097918,25.8284113 L46,8.20084245 L46,34.7746502 L3.01975596,34.7746502 L3.01975596,8.20084245 L24.5097918,25.8284113 Z M45.9999311,2.26665564 L24.5097229,19.8938797 L3.01985937,2.26665564 L3.01985937,2.26579386 L45.9999311,2.26579386 L45.9999311,2.26665564 Z' />
  </SvgIcon>
);
export const EmailCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,10.9891032 C21.9423354,17.0483162 17.0303787,21.9602729 10.9711657,21.9602729 C4.91195271,21.9602729 -3.97111913e-06,17.0483162 -3.97111913e-06,10.9891032 C-3.97111913e-06,4.92989025 4.91195271,0.017933574 10.9711657,0.017933574 C17.0303787,0.017933574 21.9423354,4.92989025 21.9423354,10.9891032' />
    <polygon
      fill='#FFFFFF'
      points='10.9711458 12.6947148 6.01975596 8.63325271 6.01975596 14.7559639 15.9225755 14.7559639 15.9225755 8.63325271'
    />
    <polygon
      fill='#FFFFFF'
      points='15.9225596 7.26599242 15.9225596 7.26579386 6.01977978 7.26579386 6.01977978 7.26599242 10.97113 11.3273751'
    />
  </SvgIcon>
);
export const WebsiteCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,11.0109047 C21.9423354,17.0701177 17.0303787,21.9820744 10.9711657,21.9820744 C4.91195271,21.9820744 -3.97111913e-06,17.0701177 -3.97111913e-06,11.0109047 C-3.97111913e-06,4.9516917 4.91195271,0.0397350181 10.9711657,0.0397350181 C17.0303787,0.0397350181 21.9423354,4.9516917 21.9423354,11.0109047' />
    <polygon
      fill='#FFFFFF'
      points='7.97578539 6.37946078 7.97578539 15.6205392 11.2442035 12.3521211 14.5126217 15.6205392 14.5126217 6.37946078'
    />
  </SvgIcon>
);
export const Location = (props) => (
  <SvgIcon viewBox='0 0 10 15' {...props}>
    <path d='M3.125 5a1.876 1.876 0 1 1 3.751.001A1.876 1.876 0 0 1 3.125 5M5 0a5 5 0 0 0-5 5c0 2.761 5 10 5 10s5-7.239 5-10a5 5 0 0 0-5-5' />
  </SvgIcon>
);
export const LocationCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,10.9891032 C21.9423354,17.0483162 17.0303787,21.9602729 10.9711657,21.9602729 C4.91195271,21.9602729 -3.97111913e-06,17.0483162 -3.97111913e-06,10.9891032 C-3.97111913e-06,4.92989025 4.91195271,0.017933574 10.9711657,0.017933574 C17.0303787,0.017933574 21.9423354,4.92989025 21.9423354,10.9891032' />
    <path
      fill='#FFFFFF'
      d='M9.65819458,9.35257329 C9.65819458,8.62784404 10.2463968,8.03960217 10.9711657,8.03960217 C11.6958949,8.03960217 12.2840971,8.62784404 12.2840971,9.35257329 C12.2840971,10.0773819 11.6958949,10.6655444 10.9711657,10.6655444 C10.2463968,10.6655444 9.65819458,10.0773819 9.65819458,9.35257329 M10.9711657,5.85139639 C9.0376278,5.85139639 7.4699491,7.41903538 7.4699491,9.35257329 C7.4699491,11.2861509 10.9711657,16.3550065 10.9711657,16.3550065 C10.9711657,16.3550065 14.4723823,11.2861509 14.4723823,9.35257329 C14.4723823,7.41903538 12.9047036,5.85139639 10.9711657,5.85139639'
    />
  </SvgIcon>
);
export const Company = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M21.7458268,3.91918432 C14.5116871,-0.0378299181 7.54566174,3.34707384 7.49909664,3.36970532 L7.49796091,3.36970532 L7.49796091,3.37020455 L7.49796091,3.37028775 L7.49796091,37.6445808 L10.5865088,37.6445808 L10.5865088,22.9650715 C12.8200111,22.1148101 16.1180208,21.6954621 19.9982565,23.8174961 C27.2572201,27.787823 34.2481505,24.3639797 34.2481505,24.3639797 L34.2481505,22.1280396 L34.2506654,22.1280396 L34.2506654,2.96292113 C34.2506654,2.96292113 29.0068186,7.88892876 21.7458268,3.91918432' />
  </SvgIcon>
);
export const CompanyCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,10.9891032 C21.9423354,17.0483162 17.0303787,21.9602729 10.9711657,21.9602729 C4.91195271,21.9602729 -3.97111913e-06,17.0483162 -3.97111913e-06,10.9891032 C-3.97111913e-06,4.92989025 4.91195271,0.017933574 10.9711657,0.017933574 C17.0303787,0.017933574 21.9423354,4.92989025 21.9423354,10.9891032' />
    <path
      fill='#FFFFFF'
      d='M11.2259985,6.83326455 C9.33314345,5.7978886 7.51044211,6.68356849 7.49825808,6.68949015 L7.49796091,6.68949015 L7.49796091,6.68962078 L7.49796091,6.68964255 L7.49796091,15.6577121 L8.30609755,15.6577121 L8.30609755,11.8167325 C8.89050651,11.5942566 9.75345007,11.4845318 10.7687365,12.0397744 C12.6680868,13.0786337 14.4973047,12.182765 14.4973047,12.182765 L14.4973047,11.5977182 L14.4979627,11.5977182 L14.4979627,6.58305269 C14.4979627,6.58305269 13.1258795,7.87197144 11.2259985,6.83326455'
    />
  </SvgIcon>
);
export const Venue = (props) => (
  <SvgIcon viewBox='0 0 23 37' {...props}>
    <path d='M11.5000409,24.5292479 C12.3694409,24.5292479 13.2183964,24.4415404 14.0393431,24.2754011 L12.351552,36.1205543 C12.2002631,37.1127521 10.7997164,37.1127521 10.6483253,36.1205543 L8.96073867,24.2754011 C9.78158311,24.4415404 10.6306409,24.5292479 11.5000409,24.5292479 Z M11.5,0 C17.8512711,0 23,5.19113092 23,11.5947075 C23,17.9982841 17.8512711,23.189415 11.5,23.189415 C5.14883111,23.189415 0,17.9982841 0,11.5947075 C0,5.19113092 5.14883111,0 11.5,0 Z M6.32254667,7.57520891 C7.36695111,7.57520891 8.21365778,6.72163231 8.21365778,5.66852368 C8.21365778,4.61541504 7.36695111,3.76183844 6.32254667,3.76183844 C5.27804,3.76183844 4.43143556,4.61541504 4.43143556,5.66852368 C4.43143556,6.72163231 5.27804,7.57520891 6.32254667,7.57520891 Z' />
  </SvgIcon>
);
export const Planner = (props) => (
  <SvgIcon viewBox='0 0 12 15' {...props}>
    <path d='M11.24 1.5c.45 0 .75.3.75.75v12c0 .45-.3.75-.75.75H.75C.3 15 0 14.7 0 14.25v-12c0-.45.3-.75.75-.75h2.248V.75c0-.45.3-.75.749-.75h4.496c.45 0 .75.3.75.75v.75h2.248zm-.749 12V3H8.993v.75c0 .45-.3.75-.75.75H3.747c-.45 0-.75-.3-.75-.75V3H1.5v10.5h8.992zM4.496 3h2.998V1.5H4.496V3zM8.25 7C8.7 7 9 7.4 9 8s-.3 1-.75 1h-4.5C3.3 9 3 8.6 3 8s.3-1 .75-1h4.5zm0 3c.45 0 .75.4.75 1s-.3 1-.75 1h-4.5C3.3 12 3 11.6 3 11s.3-1 .75-1h4.5z' />
  </SvgIcon>
);
export const Document = (props) => (
  <SvgIcon viewBox='0 0 28 44' {...props}>
    <path d='M26.0149941,10.5018879 L20.0089479,10.5018879 C19.0719182,10.5018879 18.3123142,9.75115698 18.3123142,8.82516419 L18.3123142,2.90032643 C18.3114825,2.75018025 18.3717333,2.6059705 18.4795749,2.5002106 C18.7013571,2.28293702 19.0594429,2.28430697 19.2793769,2.50349848 L26.4166046,9.54612159 C26.5244462,9.65188149 26.584697,9.7959999 26.5838653,9.94623742 C26.5820172,10.2549321 26.3273373,10.5037145 26.0149941,10.5018879 Z M27.9265347,41.897482 C27.9265347,43.1322608 26.9137294,44.133144 25.6644488,44.133144 L2.26208581,44.133144 C1.01280528,44.133144 0,43.1322608 0,41.897482 L0,3.23575337 C0,2.00088322 1.01280528,1 2.26208581,1 L13.7879208,1 C14.4126997,1 14.9190099,1.50048727 14.9190099,2.11778535 L14.9190099,8.82513679 C14.9190099,11.6033891 17.1978218,13.8555819 20.0089109,13.8555819 L26.795538,13.8555819 C27.4202244,13.8555819 27.9265347,14.3559778 27.9265347,14.9734586 L27.9265347,41.897482 Z' />
  </SvgIcon>
);
export const DocumentCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,11.0109047 C21.9423354,17.0701177 17.0303787,21.9820744 10.9711657,21.9820744 C4.91195271,21.9820744 -3.97111944e-06,17.0701177 -3.97111944e-06,11.0109047 C-3.97111944e-06,4.9516917 4.91195271,0.0397350181 10.9711657,0.0397350181 C17.0303787,0.0397350181 21.9423354,4.9516917 21.9423354,11.0109047' />
    <polygon
      fill='#FFFFFF'
      points='11.5596043 5.22710029 11.5596043 8.73885708 14.941703 8.73885708'
    />
    <polygon
      fill='#FFFFFF'
      points='7.05015994 5.22710029 7.05015994 15.7623228 14.9417007 15.7623228 14.9417007 9.9094108 10.4322127 9.9094108 10.4322127 5.22710029'
    />
  </SvgIcon>
);
export const CardCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,11.0109047 C21.9423354,17.0701177 17.0303787,21.9820744 10.9711657,21.9820744 C4.91195271,21.9820744 -3.97111913e-06,17.0701177 -3.97111913e-06,11.0109047 C-3.97111913e-06,4.9516917 4.91195271,0.0397350181 10.9711657,0.0397350181 C17.0303787,0.0397350181 21.9423354,4.9516917 21.9423354,11.0109047' />
    <path
      fill='#FFFFFF'
      d='M16.766,8.029c0-0.568-0.46-1.029-1.028-1.029l0,0H6.251C5.685,7.003,5.228,7.463,5.228,8.029V8.98h11.538 V8.029z M6.257,14.995h9.486c0.567,0,1.028-0.46,1.028-1.028l0,0V10.3H5.228v3.67C5.227,14.538,5.687,14.999,6.255,15 c0,0,0.001,0,0.002,0V14.995z'
    />
  </SvgIcon>
);
export const TaxCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path d='M21.9423354,11.0109047 C21.9423354,17.0701177 17.0303787,21.9820744 10.9711657,21.9820744 C4.91195271,21.9820744 -3.97111944e-06,17.0701177 -3.97111944e-06,11.0109047 C-3.97111944e-06,4.9516917 4.91195271,0.0397350181 10.9711657,0.0397350181 C17.0303787,0.0397350181 21.9423354,4.9516917 21.9423354,11.0109047' />
    <path
      fill='#FFFFFF'
      d='M13.6428571,16.281086 C12.3432831,16.281086 11.2857143,15.2307908 11.2857143,13.9397285 C11.2857143,12.6486663 12.3432831,11.598371 13.6428571,11.598371 C14.9426237,11.598371 16,12.6486663 16,13.9397285 C16,15.2307908 14.9426237,16.281086 13.6428571,16.281086 L13.6428571,16.281086 Z M7.35714286,10.6228054 C6.05737628,10.6228054 5,9.57251022 5,8.28144796 C5,6.99038571 6.05737628,5.9400905 7.35714286,5.9400905 C8.65690943,5.9400905 9.71428571,6.99038571 9.71428571,8.28144796 C9.71428571,9.57251022 8.65690943,10.6228054 7.35714286,10.6228054 L7.35714286,10.6228054 Z M14.3052258,6.26808458 L15.4387984,7.39444841 L6.65353058,16.1183642 L5.51995798,14.9919685 L14.3052258,6.26808458 Z'
    />
  </SvgIcon>
);
export const DollarsCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px', fill: '#278ADA' }}
    {...props}
  >
    <path d='M19.95 10.51a9.475 9.475 0 1 1-18.95 0 9.475 9.475 0 0 1 18.95 0' />
    <path
      fill='#FFF'
      d='M10.791 9.973c.578.234 1.046.464 1.403.688.358.225.64.503.847.835.207.332.31.744.31 1.236 0 .454-.095.848-.287 1.184a2.138 2.138 0 0 1-.814.806 3.137 3.137 0 0 1-1.236.378v1.166h-.932V15.1a3.435 3.435 0 0 1-1.277-.387 2.37 2.37 0 0 1-.926-.911c-.234-.4-.352-.902-.352-1.503h1.77c0 .5.117.86.351 1.08.235.222.532.332.891.332.34 0 .6-.089.78-.267.179-.177.269-.41.269-.7 0-.215-.038-.395-.114-.542a1.084 1.084 0 0 0-.364-.39 3.464 3.464 0 0 0-.688-.34c-.586-.226-1.059-.45-1.418-.67a2.558 2.558 0 0 1-.85-.83c-.207-.331-.31-.745-.31-1.242 0-.437.097-.826.293-1.166.195-.34.47-.613.826-.82a3.024 3.024 0 0 1 1.236-.38V5.114h.932v1.266c.453.066.848.217 1.183.451.336.234.595.545.777.932.181.386.272.834.272 1.341H11.6c0-.445-.092-.78-.276-1.007-.183-.227-.433-.34-.75-.34-.32 0-.56.09-.72.272-.16.182-.24.42-.24.712 0 .192.035.356.108.492.072.137.192.264.36.381.168.117.404.237.709.358z'
    />
  </SvgIcon>
);
export const HelpCircle = (props) => (
  <SvgIcon
    viewBox='0 0 16 16'
    style={{ height: '16px', width: '17px' }}
    {...props}
  >
    <circle cx='7.483' cy='8' r='7.483' />
    <path
      fill='currentColor'
      d='M8.152,11.672c0,0.223-0.195,0.416-0.417,0.416H6.706c-0.222,0-0.417-0.193-0.417-0.416v-0.668 c0-0.223,0.195-0.416,0.417-0.416h1.029c0.223,0,0.417,0.193,0.417,0.416V11.672z M9.794,7.639C9.516,8.027,9.182,8.334,8.736,8.557 c-0.223,0.166-0.39,0.334-0.473,0.5C8.208,9.195,8.18,9.334,8.152,9.529c0,0.139-0.139,0.25-0.278,0.25H6.595 c-0.167,0-0.306-0.139-0.278-0.305c0.028-0.361,0.111-0.641,0.25-0.836c0.167-0.25,0.5-0.555,1.001-0.888 c0.251-0.168,0.446-0.335,0.584-0.585c0.139-0.223,0.223-0.501,0.223-0.779c0-0.306-0.084-0.557-0.251-0.751 C7.958,5.441,7.735,5.357,7.429,5.357c-0.25,0-0.445,0.083-0.612,0.222C6.706,5.664,6.65,5.802,6.595,5.941 C6.539,6.136,6.372,6.247,6.178,6.247L4.981,6.22c-0.14,0-0.279-0.139-0.25-0.278c0.056-0.64,0.278-1.113,0.723-1.446 c0.501-0.39,1.168-0.584,1.975-0.584c0.89,0,1.557,0.222,2.058,0.667c0.5,0.445,0.75,1.029,0.75,1.78 C10.211,6.832,10.072,7.276,9.794,7.639z'
    />
  </SvgIcon>
);
export const ReminderCircle = (props) => (
  <SvgIcon
    viewBox='0 0 30 30'
    style={{ height: '30px', width: '30px' }}
    {...props}
  >
    <circle cx='15' cy='15' r='15' />
    <path
      fill='#FFF'
      d='M18.1 19.5C18.1 19.5 18.1 19.5 18.1 19.5 18.4 20.2 18.1 21 17.4 21.3 16.7 21.6 15.8 21.3 15.5 20.6 15.5 20.6 15.5 20.6 15.5 20.6 16.3 20.3 16.8 20.1 16.8 20.1 16.8 20.1 17.4 19.8 18.1 19.5ZM20.7 16.1C22.2 16.7 16.4 19.1 16.4 19.1 16.4 19.1 10.6 21.6 11.2 20.1 13.1 15.6 10.9 14 11 12.6 11.1 11.8 11.7 11.3 12.2 10.9L11.9 10.4C11.8 10.1 11.9 9.7 12.3 9.6 12.6 9.4 13 9.6 13.2 9.9L13.4 10.4C13.9 10.3 14.8 10.2 15.4 10.8 16.5 11.6 16.2 14.3 20.7 16.1Z'
    />
  </SvgIcon>
);

// Misc Icons
export const Filter = (props) => (
  <SvgIcon viewBox='0 0 25 21' {...props}>
    <path d='M10.7500771,3.76341763 C11.6617069,4.67132398 11.6617069,6.14859792 10.7500771,7.05650427 C9.8384473,7.96444125 8.35508406,7.96447188 7.44345424,7.0565349 C6.53179366,6.14859792 6.53182442,4.67132398 7.44345424,3.76338699 C8.35508406,2.85548065 9.83841654,2.85548065 10.7500771,3.76341763 Z M12.9251372,9.22268052 C13.5155726,8.63465669 13.9407661,7.94339554 14.2009022,7.20679574 L24.5255398,7.20673447 L24.525509,3.53650997 L14.1729415,3.53650997 C13.9107752,2.82861444 13.495025,2.16483218 12.9251372,1.59724137 C10.8141499,-0.505123807 7.3793507,-0.505123807 5.26839414,1.59721074 C4.69847555,2.16480155 4.28272535,2.8285838 4.02055911,3.53650997 L0,3.53650997 L0,7.20679574 L3.99262916,7.20673447 C4.25276525,7.94339554 4.67795873,8.63465669 5.26839414,9.22268052 C7.3793507,11.3250457 10.8141499,11.3250457 12.9251372,9.22268052 Z' />
    <path
      d='M7.44345424,13.7296787 C8.35508406,12.8217724 9.83841654,12.8217724 10.7500771,13.7297094 C11.6617069,14.6376157 11.6617069,16.1148896 10.7500771,17.022796 C9.8384473,17.930733 8.35508406,17.9307636 7.44345424,17.0228266 C6.53179366,16.1148896 6.53182442,14.6376157 7.44345424,13.7296787 M5.26839414,19.1889722 C7.3793507,21.2913374 10.8141499,21.2913374 12.9251372,19.1889722 C13.5155726,18.6009484 13.9407661,17.9096873 14.2009022,17.1730875 L24.5255398,17.1730262 L24.525509,13.5028017 L14.1729415,13.5028017 C13.9107752,12.7949062 13.495025,12.1311239 12.9251372,11.5635331 C10.8141499,9.46116792 7.3793507,9.46116792 5.26839414,11.5635025 C4.69847555,12.1310933 4.28272535,12.7948755 4.02055911,13.5028017 L2.06057393e-13,13.5028017 L2.06057393e-13,17.1730875 L3.99262916,17.1730262 C4.25276525,17.9096873 4.67795873,18.6009484 5.26839414,19.1889722'
      transform='translate(12.262770, 15.376251) rotate(180.000000) translate(-12.262770, -15.376251) '
    />
  </SvgIcon>
);
export const Camera = (props) => (
  <SvgIcon viewBox='0 0 25 19' {...props}>
    <path d='M12.5,16.6013541 C9.32924837,16.6013541 6.74995915,14.088393 6.74995915,10.9996229 C6.74995915,7.91093247 9.32924837,5.3979714 12.5,5.3979714 C15.6707108,5.3979714 18.25,7.91093247 18.25,10.9996229 C18.25,14.088393 15.6707108,16.6013541 12.5,16.6013541 M21.75,3.20600522 L16.7745098,3.20600522 C16.7745098,1.4572874 15.3194853,0.0397920657 13.5245507,0.0397920657 L11.4754902,0.0397920657 C9.68047386,0.0397920657 8.22544935,1.4572874 8.22544935,3.20600522 L3.25004085,3.20600522 C1.45498366,3.20600522 0,4.62346076 0,6.37217858 L0,15.6271469 C0,17.3758249 1.45498366,18.7932804 3.25004085,18.7932804 L21.75,18.7932804 C23.5449346,18.7932804 24.9999592,17.3758249 24.9999592,15.6271469 L24.9999592,6.37217858 C24.9999592,4.62346076 23.5449346,3.20600522 21.75,3.20600522' />
    <path d='M9.2499183,10.9996309 C9.2499183,12.7454436 10.7080065,14.1658043 12.5,14.1658043 C14.2919526,14.1658043 15.75,12.7454436 15.75,10.9996309 C15.75,9.25385798 14.2919526,7.83345753 12.5,7.83345753 C10.7080065,7.83345753 9.2499183,9.25385798 9.2499183,10.9996309 Z' />
  </SvgIcon>
);
export const Upload = (props) => (
  <SvgIcon
    viewBox='0 0 16 12'
    style={{ height: '16px', width: '12px' }}
    {...props}
  >
    <path d='M7.99998822,2.68396425 L8.00004711,2.68392586 L9.66304301,4.31026894 L9.66300375,4.31030734 L13.4232063,7.98760998 L11.7601908,9.61395306 L9.15745834,7.06861546 L9.15745834,11.4349528 L6.80561412,11.4349528 L6.80561412,7.10468646 L4.23980527,9.61393386 L2.57678975,7.98759078 L6.33697269,4.31030734 L6.33693344,4.31028814 L7.99994896,2.68394505 L7.99998822,2.68396425 Z M0,0 L16,0 L16,3.75865915 L13.6481362,3.75865915 L13.6481362,2.30000108 L2.35186385,2.30000108 L2.35186385,3.75865915 L0,3.75865915 L0,2.30000108 L0,0.00838905001 L0,0 Z' />
  </SvgIcon>
);
export const DownloadCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <polygon
      fill='#FFFFFF'
      points='11.2854198 5.00000201 11.2854198 9.57953221 9.57520597 7.90991477 7.84354874 9.61566644 10.759022 12.4725188 12.4906384 14.1782906 14.2223774 12.4725389 17.1377893 9.61568658 15.4061116 7.9099349 13.7343664 9.5417 13.7343664 5.00000201'
    />
    <polygon
      fill='#FFFFFF'
      points='16.5323915 14.051094 16.5323915 15.5809732 8.44894654 15.5809732 8.44894654 14.051094 6 14.051094 6 15.5809732 6 17.9844765 6 17.9932752 18.9813381 17.9932752 18.9813381 14.051094'
    />
  </SvgIcon>
);
export const Calendar = (props) => (
  <SvgIcon
    viewBox='0 0 14 14'
    style={{ height: '14px', width: '15px' }}
    {...props}
  >
    <path d='M1.83119286,10.903999 C1.83119286,10.6770304 2.01047857,10.4928681 2.2318,10.4928681 L3.90326429,10.4928681 C4.12444286,10.4928681 4.30383571,10.6767738 4.30383571,10.903999 L4.30383571,12.0155696 C4.30383571,12.2425382 4.12465714,12.4267372 3.90326429,12.4267372 L2.23162143,12.4267372 C2.01047857,12.4267372 1.83094286,12.2427948 1.83094286,12.0155696 L1.83094286,10.903999 L1.83119286,10.903999 Z M1.83119286,8.03348586 C1.83119286,7.80648063 2.01047857,7.62235497 2.2318,7.62235497 L3.90326429,7.62235497 C4.12444286,7.62235497 4.30383571,7.80629738 4.30383571,8.03348586 L4.30383571,9.12537592 C4.30383571,9.3523445 4.12465714,9.53647016 3.90326429,9.53647016 L2.23162143,9.53647016 C2.01047857,9.53647016 1.83094286,9.3525644 1.83094286,9.12537592 L1.83094286,8.03348586 L1.83119286,8.03348586 Z M1.83119286,5.15311414 C1.83119286,4.92614555 2.01047857,4.74198325 2.2318,4.74198325 L3.90326429,4.74198325 C4.12444286,4.74198325 4.30383571,4.92614555 4.30383571,5.15311414 L4.30383571,6.24496754 C4.30383571,6.47193613 4.12465714,6.65613508 3.90326429,6.65613508 L2.23162143,6.65613508 C2.01047857,6.65613508 1.83094286,6.47215602 1.83094286,6.24496754 L1.83094286,5.15311414 L1.83119286,5.15311414 Z M5.53990714,10.903999 C5.53990714,10.6770304 5.71912143,10.4928681 5.94055,10.4928681 L7.90287143,10.4928681 C8.12408571,10.4928681 8.30358571,10.6767738 8.30358571,10.903999 L8.30358571,12.0155696 C8.30358571,12.2425382 8.12408571,12.4267372 7.90287143,12.4267372 L5.94055,12.4267372 C5.7193,12.4267372 5.53990714,12.2427948 5.53990714,12.0155696 L5.53990714,10.903999 Z M5.53990714,8.03348586 C5.53990714,7.80648063 5.71912143,7.62235497 5.94055,7.62235497 L7.90287143,7.62235497 C8.12408571,7.62235497 8.30358571,7.80629738 8.30358571,8.03348586 L8.30358571,9.12537592 C8.30358571,9.3523445 8.12408571,9.53647016 7.90287143,9.53647016 L5.94055,9.53647016 C5.7193,9.53647016 5.53990714,9.3525644 5.53990714,9.12537592 L5.53990714,8.03348586 Z M5.53990714,5.15311414 C5.53990714,4.92614555 5.71912143,4.74198325 5.94055,4.74198325 L7.90287143,4.74198325 C8.12408571,4.74198325 8.30358571,4.92614555 8.30358571,5.15311414 L8.30358571,6.24496754 C8.30358571,6.47193613 8.12408571,6.65613508 7.90287143,6.65613508 L5.94055,6.65613508 C5.7193,6.65613508 5.53990714,6.47215602 5.53990714,6.24496754 L5.53990714,5.15311414 Z M9.39419286,10.903999 C9.39419286,10.6770304 9.57340714,10.4928681 9.79483571,10.4928681 L11.7569071,10.4928681 C11.9781214,10.4928681 12.1575143,10.6767738 12.1575143,10.903999 L12.1575143,12.0155696 C12.1575143,12.2425382 11.9783,12.4267372 11.7569071,12.4267372 L9.79483571,12.4267372 C9.57358571,12.4267372 9.39419286,12.2427948 9.39419286,12.0155696 L9.39419286,10.903999 Z M9.39419286,8.03348586 C9.39419286,7.80648063 9.57340714,7.62235497 9.79483571,7.62235497 L11.7569071,7.62235497 C11.9781214,7.62235497 12.1575143,7.80629738 12.1575143,8.03348586 L12.1575143,9.12537592 C12.1575143,9.3523445 11.9781214,9.53647016 11.7569071,9.53647016 L9.79483571,9.53647016 C9.57358571,9.53647016 9.39419286,9.3525644 9.39419286,9.12537592 L9.39419286,8.03348586 Z M9.39419286,5.15311414 C9.39419286,4.92614555 9.57340714,4.74198325 9.79483571,4.74198325 L11.7569071,4.74198325 C11.9781214,4.74198325 12.1575143,4.92614555 12.1575143,5.15311414 L12.1575143,6.24496754 C12.1575143,6.47193613 11.9781214,6.65613508 11.7569071,6.65613508 L9.79483571,6.65613508 C9.57358571,6.65613508 9.39419286,6.47215602 9.39419286,6.24496754 L9.39419286,5.15311414 Z M0.699157143,13.9754597 L13.2891214,13.9754597 C13.6757643,13.9754597 13.9883357,13.6540461 13.9883357,13.2577215 L13.9883357,2.85051728 C13.9883357,2.45441257 13.6755857,2.13277906 13.2891214,2.13277906 L10.9576214,2.13277906 L10.9576214,0.957035602 C10.9576214,0.429067016 10.5397286,1.46596859e-05 10.0252286,1.46596859e-05 C9.51069286,1.46596859e-05 9.09255,0.429067016 9.09255,0.957035602 L9.09255,2.13277906 L4.89597857,2.13277906 L4.89597857,0.957035602 C4.89597857,0.429067016 4.47805,1.46596859e-05 3.9633,1.46596859e-05 C3.44883571,1.46596859e-05 3.03094286,0.429067016 3.03094286,0.957035602 L3.03094286,2.13277906 L0.699157143,2.13277906 C0.312692857,2.13277906 1.42857143e-05,2.45441257 1.42857143e-05,2.85051728 L1.42857143e-05,13.2577215 C1.42857143e-05,13.6540461 0.312692857,13.9754597 0.699157143,13.9754597 L0.699157143,13.9754597 Z' />
  </SvgIcon>
);
export const CircularCalendar = (props) => (
  <SvgIcon
    viewBox='0 0 30 30'
    xmlns='http://www.w3.org/2000/svg'
    xlink='http://www.w3.org/1999/xlink'
    style={{ width: '30px', height: '30px' }}
    {...props}
  >
    <defs>
      <path
        d='M29.9754792,14.9877396 C29.9754792,23.2652441 23.2652441,29.9754792 14.9877396,29.9754792 C6.71023508,29.9754792 0,23.2652441 0,14.9877396 C0,6.71023508 6.71023508,0 14.9877396,0 C23.2652441,0 29.9754792,6.71023508 29.9754792,14.9877396'
        id='path-1'
      />
      <path
        d='M1.83270739,10.9231427 C1.83270739,10.6957753 2.01214278,10.5112894 2.23364899,10.5112894 L3.90650875,10.5112894 C4.12787197,10.5112894 4.3074146,10.6955183 4.3074146,10.9231427 L4.3074146,12.0366664 C4.3074146,12.2640338 4.12808644,12.4485564 3.90650875,12.4485564 L2.23347027,12.4485564 C2.01214278,12.4485564 1.83245718,12.2642908 1.83245718,12.0366664 L1.83245718,10.9231427 L1.83270739,10.9231427 Z M1.83270739,8.04758608 C1.83270739,7.82018199 2.01214278,7.63573283 2.23364899,7.63573283 L3.90650875,7.63573283 C4.12787197,7.63573283 4.3074146,7.81999843 4.3074146,8.04758608 L4.3074146,9.14139459 C4.3074146,9.36876196 4.12808644,9.55321113 3.90650875,9.55321113 L2.23347027,9.55321113 C2.01214278,9.55321113 1.83245718,9.36898225 1.83245718,9.14139459 L1.83245718,8.04758608 L1.83270739,8.04758608 Z M1.83270739,5.16215352 C1.83270739,4.93478614 2.01214278,4.75030026 2.23364899,4.75030026 L3.90650875,4.75030026 C4.12787197,4.75030026 4.3074146,4.93478614 4.3074146,5.16215352 L4.3074146,6.25592531 C4.3074146,6.48329269 4.12808644,6.66781528 3.90650875,6.66781528 L2.23347027,6.66781528 C2.01214278,6.66781528 1.83245718,6.48351297 1.83245718,6.25592531 L1.83245718,5.16215352 L1.83270739,5.16215352 Z M5.544518,10.9231427 C5.544518,10.6957753 5.72388191,10.5112894 5.94549535,10.5112894 L7.90945508,10.5112894 C8.13085405,10.5112894 8.31050392,10.6955183 8.31050392,10.9231427 L8.31050392,12.0366664 C8.31050392,12.2640338 8.13085405,12.4485564 7.90945508,12.4485564 L5.94549535,12.4485564 C5.72406063,12.4485564 5.544518,12.2642908 5.544518,12.0366664 L5.544518,10.9231427 Z M5.544518,8.04758608 C5.544518,7.82018199 5.72388191,7.63573283 5.94549535,7.63573283 L7.90945508,7.63573283 C8.13085405,7.63573283 8.31050392,7.81999843 8.31050392,8.04758608 L8.31050392,9.14139459 C8.31050392,9.36876196 8.13085405,9.55321113 7.90945508,9.55321113 L5.94549535,9.55321113 C5.72406063,9.55321113 5.544518,9.36898225 5.544518,9.14139459 L5.544518,8.04758608 Z M5.544518,5.16215352 C5.544518,4.93478614 5.72388191,4.75030026 5.94549535,4.75030026 L7.90945508,4.75030026 C8.13085405,4.75030026 8.31050392,4.93478614 8.31050392,5.16215352 L8.31050392,6.25592531 C8.31050392,6.48329269 8.13085405,6.66781528 7.90945508,6.66781528 L5.94549535,6.66781528 C5.72406063,6.66781528 5.544518,6.48351297 5.544518,6.25592531 L5.544518,5.16215352 Z M9.40202158,10.9231427 C9.40202158,10.6957753 9.58138549,10.5112894 9.80299893,10.5112894 L11.7667085,10.5112894 C11.9881074,10.5112894 12.1676501,10.6955183 12.1676501,10.9231427 L12.1676501,12.0366664 C12.1676501,12.2640338 11.9882861,12.4485564 11.7667085,12.4485564 L9.80299893,12.4485564 C9.58156421,12.4485564 9.40202158,12.2642908 9.40202158,12.0366664 L9.40202158,10.9231427 Z M9.40202158,8.04758608 C9.40202158,7.82018199 9.58138549,7.63573283 9.80299893,7.63573283 L11.7667085,7.63573283 C11.9881074,7.63573283 12.1676501,7.81999843 12.1676501,8.04758608 L12.1676501,9.14139459 C12.1676501,9.36876196 11.9881074,9.55321113 11.7667085,9.55321113 L9.80299893,9.55321113 C9.58156421,9.55321113 9.40202158,9.36898225 9.40202158,9.14139459 L9.40202158,8.04758608 Z M9.40202158,5.16215352 C9.40202158,4.93478614 9.58138549,4.75030026 9.80299893,4.75030026 L11.7667085,4.75030026 C11.9881074,4.75030026 12.1676501,4.93478614 12.1676501,5.16215352 L12.1676501,6.25592531 C12.1676501,6.48329269 11.9881074,6.66781528 11.7667085,6.66781528 L9.80299893,6.66781528 C9.58156421,6.66781528 9.40202158,6.48351297 9.40202158,6.25592531 L9.40202158,5.16215352 Z M0.699726558,14 L13.300202,14 C13.6871676,14 14,13.6780217 14,13.2810007 L14,2.85551097 C14,2.4587103 13.6869889,2.13651168 13.300202,2.13651168 L10.9667554,2.13651168 L10.9667554,0.958702436 C10.9667554,0.429806205 10.5485137,0 10.0335841,0 C9.51861885,0 9.10012689,0.429806205 9.10012689,0.958702436 L9.10012689,2.13651168 L4.90005183,2.13651168 L4.90005183,0.958702436 C4.90005183,0.429806205 4.48177434,0 3.96659458,0 C3.45170078,0 3.03345903,0.429806205 3.03345903,0.958702436 L3.03345903,2.13651168 L0.699726558,2.13651168 C0.312939621,2.13651168 0,2.4587103 0,2.85551097 L0,13.2810007 C0,13.6780217 0.312939621,14 0.699726558,14 L0.699726558,14 Z'
        id='path-3'
      />
    </defs>
    <g
      id='Pinnacle-(SecondaryOrders)'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-Orders-ParentOrderForm-OrderDetails'
        transform='translate(-453, -335)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='1410' />
        <g id='Group-6' transform='translate(165, 280)'>
          <g id='Row' transform='translate(5, 0)' fill='#FFFFFF'>
            <rect id='Rectangle-3' x='0' y='0' width='595' height='130' />
          </g>
          <g id='Group' transform='translate(250, 55.0245)'>
            <g
              id='Lines/Dividers-Blue'
              transform='translate(0, 14.9755)'
              fill='#355A78'
            >
              <polygon id='Rectangle-14-Copy-5' points='0 0 40 0 40 1 0 1' />
            </g>
            <g
              id='Lines/Dividers-Blue-Copy'
              transform='translate(65, 14.9755)'
              fill='#355A78'
            >
              <polygon id='Rectangle-14-Copy-5' points='0 0 40 0 40 1 0 1' />
            </g>
            <g id='Calendar/Order-Solid' transform='translate(38, 0)'>
              <mask id='mask-2' fill='white'>
                <use href='#path-1' />
              </mask>
              <use id='Mask' fill='#278ADA' href='#path-1' />
              <g id='Color/Blue' mask='url(#mask-2)' fill='#466B88'>
                <g transform='translate(0, -0.0245)' id='Rectangle-11'>
                  <rect x='0' y='0' width='30' height='30' />
                </g>
              </g>
            </g>
            <g id='Color/Blue' transform='translate(46, 7.9755)'>
              <mask id='mask-4' fill='white'>
                <use href='#path-3' />
              </mask>
              <use id='Mask' fill='#278ADA' href='#path-3' />
              <g mask='url(#mask-4)' fill='#FFFFFF' id='Rectangle-3'>
                <polygon points='0 0 14 0 14 10.350415 14 14 0 14' />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);
export const Clock = (props) => (
  <SvgIcon
    viewBox='0 0 14 14'
    height={props.height || '14px'}
    width={props.width || '15px'}
    {...props}
  >
    <path d='M6.99427857,1.07142857e-05 C3.12556429,1.07142857e-05 -7.1428567e-06,3.14740357 -7.1428567e-06,6.99429643 C-7.1428567e-06,10.8411536 3.12556429,13.9885821 6.99427857,13.9885821 C10.8192786,13.9885821 13.9885643,10.8411536 13.9885643,6.99429643 C13.9885643,3.14740357 10.8192786,1.07142857e-05 6.99427857,1.07142857e-05 M6.99427857,1.02076071 C7.51885,1.02076071 7.97781429,1.45790357 7.97781429,1.982475 L7.97781429,6.75383214 L10.11985,8.08711786 C10.3602429,8.21826071 10.4695643,8.48054643 10.4695643,8.74283214 C10.4695643,8.93958214 10.4039929,9.13626071 10.27285,9.33301071 C10.0979571,9.59529643 9.79195714,9.70458214 9.50781429,9.70458214 C9.3111,9.70458214 9.13627857,9.63901071 8.96138571,9.55154643 L6.31667143,7.86854643 C6.07624286,7.71554643 5.9451,7.38768929 5.96695714,7.05986786 L5.96695714,1.982475 C5.96695714,1.45790357 6.42599286,1.02076071 6.99427857,1.02076071' />
  </SvgIcon>
);

export const BlueClock = (props) => (
  <SvgIcon
    viewBox='0 0 15 15'
    style={{ height: '14px', width: '15px' }}
    fill='#278ADA'
    {...props}
  >
    <path d='M7.5,0 C11.65,0 15,3.35 15,7.5 C15,11.65 11.65,15 7.5,15 C3.35,15 0,11.65 0,7.5 C0,3.35 3.35,0 7.5,0 Z M7.5,1.66666667 C4.28333333,1.66666667 1.66666667,4.28333333 1.66666667,7.5 C1.66666667,10.7166667 4.28333333,13.3333333 7.5,13.3333333 C10.7166667,13.3333333 13.3333333,10.7166667 13.3333333,7.5 C13.3333333,4.28333333 10.7166667,1.66666667 7.5,1.66666667 Z M7.14766087,3.94736842 C7.61350885,3.94736842 7.97953227,4.29874251 7.97953227,4.74594589 L7.97953227,4.74594589 L7.97953227,6.9685467 L10.8030702,9.67907834 C11.1358187,9.99850932 11.1358187,10.4936274 10.8030702,10.8130583 C10.6533333,10.9727738 10.4204093,11.0526316 10.2207602,11.0526316 C10.021111,11.0526316 9.80482448,10.9727738 9.63845021,10.8130583 L9.63845021,10.8130583 L6.31578947,7.62338022 L6.31578947,4.74594589 C6.31578947,4.29874251 6.68181289,3.94736842 7.14766087,3.94736842 Z' />
  </SvgIcon>
);

export const FilledBlueClock = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M7.5,0 C11.65,0 15,3.35 15,7.5 C15,11.65 11.65,15 7.5,15 C3.35,15 0,11.65 0,7.5 C0,3.35 3.35,0 7.5,0 Z M7.5,1.66666667 C4.28333333,1.66666667 1.66666667,4.28333333 1.66666667,7.5 C1.66666667,10.7166667 4.28333333,13.3333333 7.5,13.3333333 C10.7166667,13.3333333 13.3333333,10.7166667 13.3333333,7.5 C13.3333333,4.28333333 10.7166667,1.66666667 7.5,1.66666667 Z M7.14766087,3.94736842 C7.61350885,3.94736842 7.97953227,4.29874251 7.97953227,4.74594589 L7.97953227,4.74594589 L7.97953227,6.9685467 L10.8030702,9.67907834 C11.1358187,9.99850932 11.1358187,10.4936274 10.8030702,10.8130583 C10.6533333,10.9727738 10.4204093,11.0526316 10.2207602,11.0526316 C10.021111,11.0526316 9.80482448,10.9727738 9.63845021,10.8130583 L9.63845021,10.8130583 L6.31578947,7.62338022 L6.31578947,4.74594589 C6.31578947,4.29874251 6.68181289,3.94736842 7.14766087,3.94736842 Z' />
  </SvgIcon>
);

export const OutlinedClock = (props) => (
  <SvgIcon
    viewBox='0 0 15 15'
    style={{ height: '14px', width: '15px' }}
    {...props}
  >
    <path d='M7.5,0 C11.65,0 15,3.35 15,7.5 C15,11.65 11.65,15 7.5,15 C3.35,15 0,11.65 0,7.5 C0,3.35 3.35,0 7.5,0 Z M7.5,1.66666667 C4.28333333,1.66666667 1.66666667,4.28333333 1.66666667,7.5 C1.66666667,10.7166667 4.28333333,13.3333333 7.5,13.3333333 C10.7166667,13.3333333 13.3333333,10.7166667 13.3333333,7.5 C13.3333333,4.28333333 10.7166667,1.66666667 7.5,1.66666667 Z M7.14766087,3.94736842 C7.61350885,3.94736842 7.97953227,4.29874251 7.97953227,4.74594589 L7.97953227,4.74594589 L7.97953227,6.9685467 L10.8030702,9.67907834 C11.1358187,9.99850932 11.1358187,10.4936274 10.8030702,10.8130583 C10.6533333,10.9727738 10.4204093,11.0526316 10.2207602,11.0526316 C10.021111,11.0526316 9.80482448,10.9727738 9.63845021,10.8130583 L9.63845021,10.8130583 L6.31578947,7.62338022 L6.31578947,4.74594589 C6.31578947,4.29874251 6.68181289,3.94736842 7.14766087,3.94736842 Z' />
  </SvgIcon>
);

export const MenuIcon = (props) => (
  <SvgIcon
    viewBox='0 0 17 15'
    style={{ height: '15px', width: '17px' }}
    {...props}
  >
    <path d='M0,0 L17,0 L17,3 L0,3 L0,0 Z M0,6 L17,6 L17,9 L0,9 L0,6 Z M0,12 L17,12 L17,15 L0,15 L0,12 Z' />
  </SvgIcon>
);
export const Close = (props) => (
  <SvgIcon
    viewBox='0 0 10 10'
    style={{ height: props.height || '10px', width: props.width || '10px' }}
    {...props}
  >
    <polygon
      fill={props.fillColor}
      points='1.82652846 0 0.0184607767 1.80806768 3.18270193 4.97226615 3.18268059 4.97233018 3.18270193 4.97237286 0 8.15507479 1.80806768 9.96314247 4.99076961 6.7804192 5.0091877 6.79885863 8.17347154 9.96314247 9.98156057 8.15507479 6.81729807 4.99085498 6.81734075 4.99083364 6.81729807 4.99076961 10 1.80811036 8.19195366 4.26838768e-05 5.00923039 3.18268059 4.9908123 3.1642625'
    />
  </SvgIcon>
);
export const Expand = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <polygon points='16.7843888 5.31208502e-06 16.7843888 5.8432935e-05 11.1678509 5.8432935e-05 11.1678509 3.18228951 16.7843888 3.18228951 16.7843888 8.78388313 19.9750945 8.78388313 19.9750679 3.18228951 19.9751744 3.18228951 19.9751744 5.8432935e-05 19.9750413 5.8432935e-05 19.9750413 5.31208502e-06' />
    <polygon points='16.7844607 11.2003798 16.7844607 16.802 11.1678429 16.802 11.1678429 19.984178 16.7844607 19.984178 16.7844607 19.9842842 19.9751664 19.9842842 19.9751664 19.9841514 19.9751931 19.9841514 19.9751931 16.802 19.9751664 16.802 19.9751931 11.2003798' />
    <polygon points='7.19041278e-05 11.2004515 9.85352863e-05 16.8020452 -7.98934752e-06 16.8020452 -7.98934752e-06 19.9842497 0.000125166445 19.9842497 0.000125166445 19.9843559 3.19077763 19.9843559 3.19077763 19.9842497 8.80728895 19.9842497 8.80728895 16.8020452 3.19077763 16.8020452 3.19077763 11.2004515' />
    <polygon points='7.19041278e-05 5.31208499e-05 7.19041278e-05 0.000185922975 -7.98934752e-06 0.000185922975 -7.98934752e-06 3.18233732 7.19041278e-05 3.18233732 4.52729694e-05 8.7839575 3.190751 8.7839575 3.19077763 3.18233732 8.80728895 3.18233732 8.80728895 0.00015936255 3.19077763 0.000185922975 3.19077763 5.31208499e-05' />
  </SvgIcon>
);
export const Collapse = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <polygon points='11.1796782 -2.64550266e-06 11.1797048 5.57936243 11.1795718 5.57936243 11.1795718 8.74893915 11.1797314 8.74893915 11.1797314 8.74907143 14.366141 8.74907143 14.366141 8.74893915 19.9751835 8.74893915 19.9751835 5.57936243 14.366141 5.57936243 14.366141 -2.64550266e-06' />
    <polygon points='11.1796782 11.241664 11.1796782 11.2417963 11.1795718 11.2417963 11.1795718 14.4113201 11.1796782 14.4113201 11.1796782 19.9906852 14.3660878 19.9906852 14.3661144 14.4113201 19.9751835 14.4113201 19.9751835 11.2417169 14.366141 11.2417434 14.366141 11.241664' />
    <polygon points='5.63563032 11.2415926 5.63563032 11.241672 0.026587766 11.241672 0.026587766 14.4112487 5.63563032 14.4112487 5.63563032 19.9906402 8.82211968 19.9906402 8.82209309 14.4112487 8.82217287 14.4112487 8.82217287 11.241672 8.82203989 11.241672 8.82203989 11.2415926' />
    <polygon points='5.63567819 0.0856640212 5.6356516 5.6650291 0.0265824468 5.6650291 0.0265824468 8.83460582 5.635625 8.83460582 5.635625 8.83471164 8.82211436 8.83471164 8.82211436 8.83457937 8.82216755 8.83457937 8.82216755 5.6650291 8.82214096 5.6650291 8.82214096 0.0856640212' />
  </SvgIcon>
);
export const ViewList = (props) => (
  <SvgIcon
    viewBox='0 0 19 12'
    style={{ height: '12px', width: '19px' }}
    {...props}
  >
    <polygon points='1.30246917e-06 -9.67741936e-06 1.30246917e-06 3.41587742 1.30246917e-06 5.12394194 19.2621829 5.12394194 19.2621829 3.41587742 19.2621829 -9.67741936e-06' />
    <polygon points='16.8444189 6.83260161 -2.15053763e-06 6.83260161 -2.15053763e-06 11.9574242 16.8444189 11.9574242 19.2621794 11.9574242 19.2621794 6.83260161' />
  </SvgIcon>
);
export const ViewImageList = (props) => (
  <SvgIcon
    viewBox='0 0 19 12'
    style={{ height: '12px', width: '19px' }}
    {...props}
  >
    <polygon points='7.14781573 -9.67741936e-06 7.14781573 3.41587742 7.14781573 5.12394194 19.2538845 5.12394194 19.2538845 3.41587742 19.2538845 -9.67741936e-06' />
    <polygon points='0 -4.83871008e-06 0 3.41588226 0 5.12394677 5.17856327 5.12394677 5.17856327 3.41588226 5.17856327 -4.83871008e-06' />
    <polygon points='4.52859429 6.83260645 -9.79591823e-06 6.83260645 -9.79591823e-06 11.957429 4.52859429 11.957429 5.17860245 11.957429 5.17860245 6.83260645' />
    <polygon points='17.7343465 6.83260161 7.14781356 6.83260161 7.14781356 11.9574242 17.7343465 11.9574242 19.2538824 11.9574242 19.2538824 6.83260161' />
  </SvgIcon>
);
export const ViewAscending = (props) => (
  <SvgIcon
    viewBox='0 0 11 11'
    style={{ height: '11px', width: '11px' }}
    {...props}
  >
    <polygon points='0 11 3 11 3 8 0 8' />
    <polygon points='4 11 7 11 7 3 4 3' />
    <polygon points='8 11 11 11 11 0 8 0' />
  </SvgIcon>
);
export const ViewDescending = (props) => (
  <SvgIcon
    viewBox='0 0 11 11'
    style={{ height: '11px', width: '11px' }}
    {...props}
  >
    <polygon points='8 11 11 11 11 8 8 8' />
    <polygon points='4 11 7 11 7 3 4 3' />
    <polygon points='0 11 3 11 3 0 0 0' />
  </SvgIcon>
);
export const ViewPreview = (props) => (
  <SvgIcon
    viewBox='0 0 30 30'
    style={{ height: '30px', width: '30px' }}
    {...props}
  >
    <path d='M15,19.2856349 C12.7922006,19.2856349 11.0000648,17.3656016 11.0000648,15.0000694 C11.0000648,12.6343984 12.7922006,10.7142262 15,10.7142262 C17.2077994,10.7142262 18.9999352,12.6343984 18.9999352,15.0000694 C18.9999352,17.3656016 17.2077994,19.2856349 15,19.2856349 M15,9 C10.581161,9 7,15.0000694 7,15.0000694 C7,15.0000694 10.581161,21 15,21 C19.418839,21 23,15.0000694 23,15.0000694 C23,15.0000694 19.418839,9 15,9' />
    <path d='M15,17 C13.896171,17 13,16.1040639 13,15.0001175 C13,13.8960536 13.896171,13 15,13 C16.103829,13 17,13.8960536 17,15.0001175 C17,16.1040639 16.103829,17 15,17' />
  </SvgIcon>
);
export const DragHandle = (props) => (
  <SvgIcon
    viewBox='0 0 9 16'
    style={{ height: '17px', width: '9px' }}
    {...props}
  >
    <path d='M2 4C.8954305 4 0 3.1045695 0 2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm5 0c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm-5 6c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm5 0c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm-5 6c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm5 0c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2z' />
  </SvgIcon>
);
export const Map = (props) => {
  let { backgroundColor, ...newProps } = props;
  return (
    <SvgIcon
      viewBox='0 0 16 17'
      style={{
        height: '17px',
        width: '16px',
        backgroundColor: `${
          props.backgroundColor ? `${props.backgroundColor}` : 'none'
        }`,
      }}
      {...newProps}
    >
      <path d='M.44.055l4.022 2.153a.34.34 0 0 1 .176.302v14.16c0 .245-.247.396-.44.302L.175 14.819A.34.34 0 0 1 0 14.517V.357C0 .112.247-.058.44.055M11.803.055l3.99 2.153a.34.34 0 0 1 .175.302v14.16c0 .245-.245.396-.437.302l-3.99-2.153a.34.34 0 0 1-.175-.302V.357c0-.245.245-.415.437-.302M9.875.055l-3.99 2.153a.34.34 0 0 0-.175.302v14.16c0 .245.245.396.437.302l3.99-2.153a.34.34 0 0 0 .175-.302V.357c.018-.245-.227-.415-.437-.302' />
    </SvgIcon>
  );
};

export const MapMarker = (props) => (
  <SvgIcon
    viewBox='0 0 20 30'
    style={{
      height: '30px',
      width: '20px',
      fill: `${props.color ? `${props.color}` : '#966CB8'}`,
    }}
    {...props}
  >
    <path d='M0 10c0 5.523 6.347 7.366 10 20 3.16-12.568 10-14.477 10-20S15.522 0 10 0C4.477 0 0 4.477 0 10z' />
  </SvgIcon>
);
export const MultiMapMarker = (props) => (
  <SvgIcon
    viewBox='0 0 32 30'
    style={{ height: '30px', width: '32px' }}
    {...props}
  >
    <path d='M0 10c0 5.523 6.347 7.366 10 20 3.16-12.568 10-14.477 10-20S15.522 0 10 0C4.477 0 0 4.477 0 10z' />
    <path d='M14.072.112A10.834 10.834 0 0 1 15.628 0C21.356 0 26 4.477 26 10s-7.094 7.432-10.372 20A40.023 40.023 0 0 0 14 25.52c3.555-8.659 8.888-10.731 8.888-15.52 0-5.013-3.826-9.164-8.816-9.888z' />
    <path d='M20.072.112A10.834 10.834 0 0 1 21.628 0C27.356 0 32 4.477 32 10s-7.094 7.432-10.372 20A40.023 40.023 0 0 0 20 25.52c3.555-8.659 8.888-10.731 8.888-15.52 0-5.013-3.826-9.164-8.816-9.888z' />
  </SvgIcon>
);
export const GpsMarker = (props) => (
  <SvgIcon
    width='16px'
    height='15px'
    viewBox='0 0 16 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Icons/GPS</title>
    <defs>
      <path
        d='M9.99122218,11.2798901 L10.0833714,11.287683 C12.0193143,11.6304341 13,12.2055335 13,12.9999524 C13,13.6807686 12.3013143,14.1863806 10.8638286,14.5457606 C9.69217143,14.8386247 8.1424,15 6.5,15 C4.8576,15 3.30782857,14.8386247 2.13617143,14.5457606 C0.698685714,14.1863806 0,13.6807686 0,12.9999524 C0,12.2055335 0.980685714,11.6304341 2.91685714,11.287683 C3.19571429,11.2383676 3.46068571,11.4279721 3.50125714,11.7082645 L3.50125714,11.7082645 L3.50619573,11.7963146 C3.49873721,12.0280753 3.33015873,12.2300864 3.09417143,12.2719922 C1.58108571,12.5406843 1.13154286,12.8906926 1.02342857,13.0008667 C1.11605714,13.0984119 1.46582857,13.3743613 2.61182857,13.630596 C3.67725714,13.8687731 5.05822857,14.0000333 6.5,14.0000333 C7.94177143,14.0000333 9.3228,13.8687731 10.3884,13.630596 C11.5344,13.3745327 11.8841714,13.0984119 11.9768,13.0008667 C11.8686857,12.8906926 11.4189143,12.5410272 9.90594286,12.2721065 C9.64051429,12.2249054 9.4604,11.9751851 9.49897143,11.7083788 L9.49897143,11.7083788 C9.53954286,11.4279721 9.80451429,11.2383676 10.0833714,11.287683 Z M4.00017143,0.669830234 C5.54725714,-0.223276745 7.45308571,-0.223276745 9.00017143,0.669830234 C10.5472571,1.56293721 11.5001714,3.21360509 11.5001714,5.00004762 C11.5001714,6.77734708 10.7050857,8.65013453 9.13702857,10.5666944 C8.44154286,11.4198576 7.66091429,12.1999905 6.80714286,12.8948642 C6.62657143,13.0352675 6.37388571,13.0352675 6.19331429,12.8948642 L6.19331429,12.8948642 L5.83181408,12.5918769 C5.11814344,11.975605 4.45949388,11.2979772 3.86331429,10.5666944 C2.29525714,8.65013453 1.50017143,6.77734708 1.50017143,5.00004762 C1.50017143,3.21366223 2.45308571,1.56293721 4.00017143,0.669830234 Z M6.50017143,2.49975952 C5.8372,2.49975952 5.20131429,2.76313722 4.73228571,3.23189124 C4.26354286,3.70087383 4.00017143,4.33683183 4.00017143,4.99981904 C4.00017143,5.66280626 4.26354286,6.29870711 4.73228571,6.76774685 C5.20125714,7.23650087 5.8372,7.49987857 6.50017143,7.49987857 C7.16291429,7.49919284 7.7984,7.23558656 8.26714286,6.76683254 C8.73588571,6.29807853 8.99948571,5.66257768 9.00017143,4.99981904 C9.00017143,4.33683183 8.7368,3.70093097 8.26805714,3.23189124 C7.79908571,2.76313722 7.16314286,2.49975952 6.50017143,2.49975952 Z'
        id='path-1'
      ></path>
    </defs>
    <g
      id='Icons/GPS'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue' transform='translate(1.500000, 0.000000)'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-1'></use>
        </mask>
        <use id='Mask' fill='#FFFFFF' xlinkHref='#path-1'></use>
        <g mask='url(#mask-2)' fill='#278ADA' id='Rectangle-11'>
          <g transform='translate(-2.000000, 0.000000)'>
            <rect x='0' y='0' width='17' height='16'></rect>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const StopService = (props) => (
  <SvgIcon viewBox='0 0 18 35' width='25px' height='33px' {...props}>
    <title>Combined Shape</title>
    <g
      id='7000s-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='D21635_MapView-TruckSelected-StopAdded'
        transform='translate(-200.000000, -1337.000000)'
        fill={props.markerColor}
      >
        <path
          d='M216,1337 C217.104569,1337 218,1337.89543 218,1339 L218,1363.89111 C218,1364.5014 217.72135,1365.07829 217.243316,1365.45769 L209,1372 L200.756684,1365.45769 C200.27865,1365.07829 200,1364.5014 200,1363.89111 L200,1339 C200,1337.89543 200.895431,1337 202,1337 L216,1337 Z M209.000222,1351 L207.725064,1352.2392 L206.000111,1351.80406 L205.515204,1353.51485 L203.80403,1353.99978 L204.239601,1355.72479 L203,1357.00089 L204.239601,1358.27609 L203.80403,1360.00022 L205.515204,1360.48604 L206.000111,1362.19683 L207.725064,1361.7608 L209.000222,1363 L210.275825,1361.7608 L211.999889,1362.19683 L212.484796,1360.48604 L214.196415,1360.00022 L213.760843,1358.27609 L215,1357.00089 L213.760843,1355.72479 L214.196415,1353.99978 L212.484796,1353.51485 L211.999889,1351.80406 L210.275825,1352.2392 L209.000222,1351 Z M209.000222,1353.69709 L209.78514,1356.11282 L212.325234,1356.11282 L210.270047,1357.60582 L211.054965,1360.02156 L209.000222,1358.52856 L206.945035,1360.02156 L207.730397,1357.60582 L205.67521,1356.11282 L208.21486,1356.11282 L209.000222,1353.69709 Z'
          id='Combined-Shape'
        ></path>
      </g>
    </g>
    <text
      style={{
        fontSize: '12px',
        fill: '#fff',
        fontFamily: 'Heebo-Regular, Heebo',
      }}
      textAnchor='middle'
      x='50%'
      y='14px'
    >
      {props?.number}
    </text>
  </SvgIcon>
);

export const Directions = (props) => (
  <SvgIcon
    viewBox='0 0 20 20'
    style={{ height: '20px', width: '20px' }}
    {...props}
  >
    <path d='M11.436 5.406a.45.45 0 0 1 .196-.463.472.472 0 0 1 .124-.06c.01-.003.022-.002.034-.005.031-.007.063-.014.095-.014.025 0 .05.006.074.01.018.004.037.003.054.008a.467.467 0 0 1 .122.057l3.792 3.519-3.792 3.52a.474.474 0 0 1-.25.074c-.023 0-.045-.006-.067-.01-.021-.003-.043-.003-.063-.01a.476.476 0 0 1-.123-.059.45.45 0 0 1-.196-.463l.369-2.037-3.944-.015-.026 4.771H5.86l-.023-5.335a1.43 1.43 0 0 1 1.426-1.435l4.542-.015-.37-2.038zM10.43.176a.6.6 0 0 0-.243-.146.609.609 0 0 0-.619.147l-9.39 9.39a.61.61 0 0 0 0 .863l9.39 9.391a.61.61 0 0 0 .862 0l9.39-9.39a.61.61 0 0 0 0-.863L10.431.177z' />
  </SvgIcon>
);
export const Hexagon = (props) => (
  <SvgIcon
    viewBox='0 0 20 23'
    style={{ height: '23px', width: '20px' }}
    {...props}
  >
    <path d='M10.066.066l9.526 5.5v11l-9.526 5.5-9.527-5.5v-11z' />
  </SvgIcon>
);

export const Duplicate = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '25px' }}
    {...props}
  >
    <polygon points='0 6.85804387 0 24.7776515 18.1635666 24.7776515 18.1635666 20.7226448 4.30448667 20.7226448 4.30448667 6.85804387' />
    <path d='M6.75830838,18.0877202 L24.921875,18.0877202 L24.921875,0.168168018 L6.75830838,0.168168018 L6.75830838,18.0877202 Z M9.86149709,7.8224698 L14.5011209,7.8224698 L14.5280581,7.8224698 L14.5280581,3.22661422 L17.1791752,3.22661422 L17.1790624,7.8224698 L17.1791752,7.8224698 L17.1791752,7.8225253 L21.8186863,7.8225253 L21.8186863,10.4333629 L17.1790624,10.4333629 L17.1790624,10.4334184 L17.1520689,10.4334184 L17.1520689,15.0292185 L14.5011209,15.0292185 L14.5011209,10.4333629 L14.5010082,10.4333629 L14.5010082,10.4333074 L9.86149709,10.4333074 L9.86149709,7.8224698 Z' />
  </SvgIcon>
);

export const Alert = (props) => {
  const {title, ...otherProps} = props;
  return (
    <SvgIcon viewBox='0 0 15 14' {...otherProps} fill='#ff886d'>
      {title && <title>{title}</title>}
      <path d='M14.8812691,12.5793443 C15.2263017,13.219408 14.7762446,14 14.0862633,14 L0.915694312,14 C0.210691531,14 -0.224344062,13.219408 0.120667551,12.5793443 L6.70593111,0.480080458 C7.05096367,-0.160026819 7.95099397,-0.160026819 8.29600558,0.480080458 L14.8812691,12.5793443 Z M6.4238001,9.60887106 L8.57620495,9.60887106 L8.57620495,3.81280073 L6.4238001,3.81280073 L6.4238001,9.60887106 Z M8.63513641,11.3250048 C8.63513641,10.6725127 8.12692098,10.1435853 7.50000043,10.1435853 C6.87310084,10.1435853 6.36488541,10.6725127 6.36488541,11.3250048 C6.36488541,11.9774969 6.87310084,12.5064243 7.50000043,12.5064243 C8.12692098,12.5064243 8.63513641,11.9774969 8.63513641,11.3250048 Z' />
    </SvgIcon>
  );
};

export const OverbookingModalIcon = (props) => (
  <SvgIcon
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.00176 0.0418797C9.30351 0.0197553 9.57295 0 9.99994 0C15.4102 0 20 4.48723 20 10C20 15.5129 15.4102 20 9.99994 20C9.51279 20 9.23071 20 8.87176 19.9488L9.12817 17.6667C9.14709 17.6684 9.16589 17.6701 9.18461 17.6718C9.44498 17.6957 9.68901 17.718 9.99994 17.718C14.282 17.718 17.7179 14.2564 17.7179 10C17.7179 5.74362 14.282 2.28213 9.99994 2.28213C9.66665 2.28213 9.38458 2.30774 9.10256 2.33341L8.87176 0.0513239C8.91609 0.0481612 8.95925 0.0449969 9.00176 0.0418797ZM6.61534 0.538535L7.38457 2.71802C6.84614 2.92311 6.33332 3.15386 5.8205 3.46159L4.58972 1.51285C5.23075 1.10257 5.89738 0.794893 6.61534 0.538535ZM4.48713 4.53855L2.87178 2.92311C2.3333 3.46159 1.87175 4.05134 1.46153 4.66671L3.41021 5.89749C3.7179 5.41033 4.0769 4.94878 4.48713 4.53855ZM6.37127 8.65147L4.70589 10.3168L6.49207 12.103L8.15744 13.7683L9.82277 12.103L14.3781 7.54774L12.7127 5.88237L8.15744 10.4376L6.37127 8.65147ZM0.487158 6.69238L2.66665 7.46161C2.46151 8.00004 2.3333 8.56419 2.28203 9.12828L0 8.87187C0.0768812 8.12825 0.230748 7.41034 0.487158 6.69238ZM0 11.1282L2.28203 10.8718C2.3333 11.436 2.46151 12 2.66665 12.5385L0.487158 13.3077C0.25641 12.6154 0.0768812 11.8719 0 11.1282ZM4.61533 18.4872C5.25636 18.8975 5.92304 19.2052 6.641 19.4616L7.41023 17.2821C6.87175 17.1026 6.33332 16.8462 5.84611 16.5385L4.61533 18.4872ZM1.46153 15.3334C1.87175 15.9744 2.3333 16.5642 2.87178 17.077L4.48713 15.4616C4.0769 15.0513 3.7179 14.5898 3.41021 14.1026L1.46153 15.3334Z'
      fill='#278ADA'
    />
  </SvgIcon>
);

export const AlertWhite = (props) => (
  <SvgIcon viewBox='0 0 15 14' {...props} fill='white'>
    <path d='M14.8812691,12.5793443 C15.2263017,13.219408 14.7762446,14 14.0862633,14 L0.915694312,14 C0.210691531,14 -0.224344062,13.219408 0.120667551,12.5793443 L6.70593111,0.480080458 C7.05096367,-0.160026819 7.95099397,-0.160026819 8.29600558,0.480080458 L14.8812691,12.5793443 Z M6.4238001,9.60887106 L8.57620495,9.60887106 L8.57620495,3.81280073 L6.4238001,3.81280073 L6.4238001,9.60887106 Z M8.63513641,11.3250048 C8.63513641,10.6725127 8.12692098,10.1435853 7.50000043,10.1435853 C6.87310084,10.1435853 6.36488541,10.6725127 6.36488541,11.3250048 C6.36488541,11.9774969 6.87310084,12.5064243 7.50000043,12.5064243 C8.12692098,12.5064243 8.63513641,11.9774969 8.63513641,11.3250048 Z' />
  </SvgIcon>
);

export const Bell = (props) => (
  <SvgIcon
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='white'
    {...props}
  >
    <path d='M0 0h24v24H0V0z' fill='none' />
    <path d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z' />
  </SvgIcon>
);

export const AlertOutline = (props) => (
  <SvgIcon viewBox='0 0 16 14' {...props}>
    <path d='M14.1 14H.9c-.3 0-.6-.2-.8-.4-.2-.3-.2-.7 0-1L6.7.5C7-.1 8-.1 8.3.5l-.4.2.4-.2 6.6 12.1c.2.3.2.7 0 1-.2.2-.5.4-.8.4zM1 13h13L7.5 1.1 1 13z' />
    <path d='M8.5 9h-2V5h2z' />
    <path d='M8.5 11.2c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1' />
  </SvgIcon>
);
export const Smiley = (props) => (
  <SvgIcon viewBox='0 0 36 36' {...props}>
    <path d='M28.7 23.5C27.5 27.5 23 30.3 18 30.3 13 30.3 8.5 27.5 7.3 23.5 7 22.5 7.5 21.6 8.4 21.3 9.4 21 10.4 21.5 10.6 22.4 11.4 25 14.5 26.8 18 26.8 21.5 26.8 24.6 25 25.4 22.4 25.6 21.5 26.6 21 27.6 21.3 28.5 21.6 29 22.5 28.7 23.5M10.8 9C12.5 9 13.8 10.3 13.8 12 13.8 13.7 12.5 15 10.8 15 9.1 15 7.8 13.7 7.8 12 7.8 10.3 9.1 9 10.8 9M25.2 9C26.9 9 28.2 10.3 28.2 12 28.2 13.7 26.9 15 25.2 15 23.5 15 22.2 13.7 22.2 12 22.2 10.3 23.5 9 25.2 9M18 0C8.1 0 0 8.1 0 18 0 27.9 8.1 36 18 36 27.9 36 36 27.9 36 18 36 8.1 27.9 0 18 0' />
  </SvgIcon>
);
export const SmileyCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <path
      d='M18.804 17.055C18.382 18.401 16.913 19.341 15.231 19.341 13.549 19.341 12.08 18.401 11.658 17.055 11.561 16.745 11.733 16.415 12.043 16.317 12.353 16.22 12.683 16.393 12.78 16.703 13.046 17.55 14.076 18.164 15.231 18.164 16.386 18.164 17.416 17.55 17.681 16.703 17.779 16.393 18.109 16.22 18.419 16.317 18.729 16.415 18.901 16.745 18.804 17.055M12.831 12.231C13.383 12.231 13.831 12.679 13.831 13.231 13.831 13.783 13.383 14.231 12.831 14.231 12.279 14.231 11.831 13.783 11.831 13.231 11.831 12.679 12.279 12.231 12.831 12.231M17.631 12.231C18.183 12.231 18.631 12.679 18.631 13.231 18.631 13.783 18.183 14.231 17.631 14.231 17.079 14.231 16.631 13.783 16.631 13.231 16.631 12.679 17.079 12.231 17.631 12.231M15.231 9.231C11.917 9.231 9.231 11.917 9.231 15.231 9.231 18.545 11.917 21.231 15.231 21.231 18.545 21.231 21.231 18.545 21.231 15.231 21.231 11.917 18.545 9.231 15.231 9.231'
      fill='#FFFFFF'
    />
  </SvgIcon>
);
export const HeartCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <path
      d='M15.2 19.9L10.9 15.5C10.3 14.9 10 14.2 10 13.4 10 12.6 10.3 11.9 10.9 11.4 11.4 10.8 12.1 10.5 12.9 10.5 13.7 10.5 14.4 10.8 15 11.4L15.2 11.6 15.4 11.4C16 10.8 16.7 10.5 17.5 10.5 18.3 10.5 19 10.8 19.6 11.4 20.1 11.9 20.4 12.6 20.4 13.4 20.4 14.2 20.1 14.9 19.6 15.5L19.6 15.5 18.8 16.2 15.2 19.9Z'
      fill='#FFFFFF'
    />
  </SvgIcon>
);
export const PenCircle = (props) => (
  <SvgIcon viewBox='0 0 25 25' {...props}>
    <circle cx='12.5' cy='12.5' r='12.5' />
    <path
      fill='#FFFFFF'
      d='M7.08333333 17.2889706l3.45051403-3.45668744c-.25545514-.52520425-.16683688-1.17608933.2685764-1.61221065.548703-.54992 1.43831528-.54992 1.98704043 0 .5487251.5497873.5485923 1.4414795 0 1.9912667-.4350593.4360328-1.0840857.524983-1.6080066.2694172l-3.4297147 3.4358881 7.6186479-2.2956886.628559-3.1257353 1.9177169-1.2782271-4.1247873-4.13366012-1.2941585 1.91218512-3.1022365.63904717-2.3121511 7.65440497z'
    />
  </SvgIcon>
);

// Inventory
export const Items = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <polygon points='0 17.1395434 17.2705991 17.1395434 17.2705991 0 0 0' />
    <polygon points='0 39.9978995 17.2705991 39.9978995 17.2705991 22.8551598 0 22.8551598' />
    <polygon points='22.6752995 17.1398174 39.9459908 17.1398174 39.9459908 9.13242009e-05 22.6752995 9.13242009e-05' />
    <polygon points='22.6752995 39.9980822 39.9459908 39.9980822 39.9459908 22.8553425 22.6752995 22.8553425' />
  </SvgIcon>
);
export const ItemsCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <polygon points='10.5 14.1 14.6 14.1 14.6 10 10.5 10' fill='#FFFFFF' />
    <polygon points='10.5 19.6 14.6 19.6 14.6 15.5 10.5 15.5' fill='#FFFFFF' />
    <polygon points='15.5 14.1 19.6 14.1 19.6 10 15.5 10' fill='#FFFFFF' />
    <polygon points='15.5 19.6 19.6 19.6 19.6 15.5 15.5 15.5' fill='#FFFFFF' />
  </SvgIcon>
);
export const Accessories = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <polygon points='20 1 15.2786822 15.5308548 0 15.5307922 12.3606902 24.5113577 7.63937239 39.0421498 20 30.0616469 32.3606276 39.0421498 27.6393098 24.5113577 40 15.5308548 24.7213178 15.5308548' />
  </SvgIcon>
);
export const Addons = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <polygon points='0 10.8592793 0 39.9471171 29.1026637 39.9471171 29.1026637 33.3648649 6.89688488 33.3648649 6.89688488 10.8592793' />
    <polygon points='10.8285327 29.0877477 39.9311964 29.0877477 39.9311964 0 10.8285327 0' />
  </SvgIcon>
);
export const DuplicateCircle = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M20,10 C20,15.5228505 15.5228505,20 10,20 C4.4771495,20 0,15.5228505 0,10 C0,4.4771495 4.4771495,0 10,0 C15.5228505,0 20,4.4771495 20,10'
      // fill='#1B4160'
      id='Fill-1'
    />
    <g
      xmlns='http://www.w3.org/2000/svg'
      fill='#FFFFFF'
      id='SplashIcon/AddOn-Light'
      transform='translate(5.000000, 5.000000)'
    >
      <polygon
        id='Fill-1'
        points='0 2.71481982 0 9.98677928 7.27566591 9.98677928 7.27566591 8.34121622 1.72422122 8.34121622 1.72422122 2.71481982'
      />
      <polygon
        id='Fill-2'
        points='2.70713318 7.27193694 9.9827991 7.27193694 9.9827991 0 2.70713318 0'
      />
    </g>
  </SvgIcon>
);

export const Bundles = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path
      fill={props.fillColor}
      d='M0 23.1395434V0h17.2705991v23.1395434H0zm0 16.8583561V28.8551598h17.2705991v11.1427397H0zM22.6752995 9.13981735V.00009132h17.2706913v9.13972603H22.6752995zm0 30.85826485V14.8553425h17.2706913v25.1427397H22.6752995z'
    />
  </SvgIcon>
);
export const Maintenance = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    {props.title && <title>{props.title}</title>}
    <path d='M14.0273623 29.4254259l15.3548249-15.3549068c.1669003-.1669002.3338006-.1669002.5563343-.111185 2.5591375.9457682 5.5077089.389434 7.5105122-1.6690027 1.8915364-1.8916182 2.503504-4.61757416 1.8359029-7.00981137-.1112668-.38943396-.6119676-.50070081-.8901347-.22261551l-2.5035041 2.39223722c-1.0570351 1.11266847-2.7260378 1.11266847-3.7830728 0-1.0570351-1.05703505-1.0570351-2.78167118 0-3.83870623l2.4478706-2.44778882c.2781671-.27824894.1112669-.72323451-.2780853-.83458317-2.392319-.66751927-5.1183568-.05555161-7.0098932 1.83598479-2.0584366 2.05843667-2.5591374 5.00692631-1.6690027 7.51051218.0556335.16690027.0556335.38935211-.1112668.55625241L10.1886561 25.5310044c-.1669003.1669003-.33380054.1669003-.55633423.1113487-2.55913749-.9457682-5.50770893-.389434-7.51051218 1.6689209C.17463986 29.2585256-.38169437 31.9289299.28590671 34.3768006c.11126685.3893521.61196766.5007008.89013478.2224518l2.44787063-2.4478706c1.05703505-1.057035 2.78167118-1.057035 3.83870623 0 1.05703505 1.0570351 1.05703505 2.7816712 0 3.8387062l-2.44787064 2.4478707c-.27816712.2782489-.16690027.7789497.2225337.8902166 2.39223721.6675192 5.11827499.111185 7.00981139-1.835903 2.0584366-2.0585185 2.5591375-5.00709 1.6690027-7.5105122-.0556334-.1669003-.0556334-.389434.1112668-.5563342' />
    <path d='M12.64287 18.3307216c.2734903.274485.7657727.274485 1.039263 0l4.6493347-4.6676188c.2734902-.2745659.2734902-.7687843 0-1.0433501L6.95427231 1.19781485C5.47742483-.2849213 2.85191821-.44958003 1.26567463 1.03307536c-1.64094164 1.53756855-1.6956397 4.1733196-.10939611 5.76588207L12.64287 18.3307216zm24.5390476 15.5101367c-.1082442-.107971-.2166477-.215942-.3249716-.2699275l-2.0039912-1.0257245c-.0541619-.0539854-.1624857-.1079709-.2166477-.1619564l-9.7491464-9.7173896c-.2708096-.2699275-.7582669-.2699275-1.0290765 0l-1.1915623 1.1876809c-.2708097.2699275-.2708097.7558764 0 1.0257245l9.7491463 9.717469c.054162.0539061.1084035.1619564.1624858.2158626l1.0290766 1.9974634c.0541619.107971.1624857.215942.2708892.323913l2.6538547 1.7815214c.3249715.2160214.8124288.1619565 1.0832385-.1078916l1.1915623-1.187681c.2708096-.2700068.3249716-.7558763.1083239-1.0797893l-1.7331816-2.6992749z' />
  </SvgIcon>
);
export const Receipt = (props) => (
  <SvgIcon viewBox='0 0 28 40' {...props}>
    <path d='M15.0428858,26.3992549 L15.0428858,27.311281 C15.0428858,27.9740261 14.5064476,28.5112157 13.8446294,28.5112157 C13.1828765,28.5112157 12.6463077,27.9740261 12.6463077,27.311281 L12.6463077,26.5592549 C11.8673333,26.5093203 11.097366,26.3642222 10.3535058,26.1272941 C9.66401399,25.9013464 9.2662704,25.1799739 9.44282051,24.475268 L9.46677389,24.3792549 C9.62296037,23.782915 10.1612914,23.367098 10.7768998,23.3672288 C10.9319114,23.3672941 11.0857483,23.3929804 11.2322098,23.4432418 C11.9183077,23.6823922 12.6389324,23.8067059 13.3653007,23.8112157 C14.4637622,23.8112157 15.1188578,23.411281 15.1188578,22.7472288 C15.1188578,22.0832418 14.5516131,21.655268 13.0977016,21.1472941 C11.3280886,20.5512157 9.29903497,19.5672941 9.29903497,17.2312157 C9.29903497,15.375268 10.6090956,13.935268 12.7341585,13.4632418 L12.7341585,12.6872288 C12.7341585,12.0244837 13.2707273,11.4872941 13.9325455,11.4872941 C14.5942984,11.4872941 15.1308671,12.0244837 15.1308671,12.6872288 L15.1308671,13.291281 C15.7079021,13.3225882 16.2806946,13.4109542 16.8404336,13.555268 C17.5729371,13.7621961 17.9990723,14.5246797 17.7924336,15.2582092 C17.6267179,15.8460523 17.0948485,16.2549412 16.4849184,16.2632418 C16.3496177,16.2648758 16.215035,16.2460523 16.0855431,16.2072941 C15.5289371,16.0438301 14.9518368,15.9616078 14.3718648,15.9632418 C13.3892541,15.9632418 12.8221399,16.3072941 12.8221399,16.9033072 C12.8221399,17.4232418 13.4051795,17.815268 15.1308671,18.4672941 C17.603352,19.3432418 18.6618042,20.535268 18.6618042,22.4672941 C18.6618042,24.3992549 17.2478368,25.955268 15.0428858,26.3992549 L15.0428858,26.3992549 Z M27.9591748,3.80566013 L24.4626993,-2.61437908e-05 L20.968965,3.80258824 L17.4753613,-2.61437908e-05 L13.9815618,3.80258824 L10.4878275,-2.61437908e-05 L6.99422378,3.80258824 L3.50042424,-2.61437908e-05 L0.00388344988,3.80566013 L0.00349184149,3.80566013 L-3.26340323e-05,39.9984706 L0.00388344988,39.9984706 L3.50042424,36.1927843 L6.99422378,39.9953987 L10.4878275,36.1927843 L13.9815618,39.9953987 L17.4753613,36.1927843 L20.968965,39.9953987 L24.4626993,36.1927843 L27.9591748,39.9984706 L27.9608718,39.9984706 L27.9608718,3.80566013 L27.9591748,3.80566013 Z' />
  </SvgIcon>
);
export const ReceiptCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <path
      fill='#FFFFFF'
      d='M15.3 17.2L15.3 17.5C15.3 17.8 15.1 18 14.8 18 14.6 18 14.4 17.8 14.4 17.5L14.4 17.3C14.1 17.3 13.9 17.2 13.6 17.1 13.4 17 13.2 16.8 13.3 16.5L13.3 16.5C13.4 16.3 13.5 16.2 13.8 16.2 13.8 16.2 13.9 16.2 13.9 16.2 14.2 16.3 14.4 16.3 14.7 16.3 15 16.3 15.3 16.2 15.3 15.9 15.3 15.7 15.1 15.6 14.6 15.4 14 15.2 13.2 14.8 13.2 14 13.2 13.4 13.7 12.9 14.4 12.7L14.4 12.4C14.4 12.2 14.6 12 14.9 12 15.1 12 15.3 12.2 15.3 12.4L15.3 12.6C15.5 12.7 15.7 12.7 15.9 12.7 16.1 12.8 16.3 13.1 16.2 13.3 16.2 13.5 16 13.7 15.8 13.7 15.7 13.7 15.7 13.7 15.6 13.7 15.4 13.6 15.2 13.6 15 13.6 14.7 13.6 14.5 13.7 14.5 13.9 14.5 14.1 14.7 14.2 15.3 14.4 16.1 14.8 16.5 15.2 16.5 15.8 16.5 16.5 16 17.1 15.3 17.2L15.3 17.2ZM19.8 9.3L18.5 8 17.3 9.3 16.1 8 14.9 9.3 13.7 8 12.4 9.3 11.2 8 10 9.3 10 9.3 10 22 10 22 11.2 20.6 12.4 22 13.7 20.6 14.9 22 16.1 20.6 17.3 22 18.5 20.6 19.8 22 19.8 22 19.8 9.3 19.8 9.3Z'
    />
  </SvgIcon>
);
export const Count = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M11.625 6v3H15v2.625h-3.375V15H9v-3.375H6V15H3.375v-3.375H0V9h3.375V6H0V3.375h3.375V0H6v3.375h3V0h2.625v3.375H15V6h-3.375zM9 6H6v3h3V6z' />
  </SvgIcon>
);
export const Refresh = (props) => (
  <SvgIcon viewBox='0 0 18 19' {...props}>
    <path d='M8.985.008c-.4 0-.632.02-.926.042l.19 1.873c.231-.021.462-.042.736-.042a6.328 6.328 0 0 1 6.335 6.334 6.328 6.328 0 0 1-6.335 6.335c-.197 0-.361-.01-.525-.025v-2.16L4.62 15.48l3.84 2.733v-1.797c.151.006.315.006.525.006 4.44 0 8.207-3.684 8.207-8.208S13.425.008 8.985.008M2.966 6.132L1.177 5.5a7.605 7.605 0 0 0-.4 1.789l1.874.21c.041-.463.146-.926.315-1.368M1.977 12.593a7.656 7.656 0 0 0 1.158 1.431l1.325-1.326a6.461 6.461 0 0 1-.883-1.115l-1.6 1.01zM2.65 8.93l-1.873.211c.064.61.211 1.22.4 1.79l1.789-.632A5.145 5.145 0 0 1 2.65 8.93M6.838 2.24L6.207.45c-.59.21-1.136.463-1.662.8l1.01 1.599a7.9 7.9 0 0 1 1.283-.61M1.977 3.838l1.6 1.01c.252-.4.547-.778.883-1.116L3.135 2.407a9.315 9.315 0 0 0-1.158 1.431' />
  </SvgIcon>
);
export const Percentage = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M30.6042246,37.4369846 C26.2136225,37.4369846 22.6406331,33.8885692 22.6406331,29.5267239 C22.6406331,25.1648787 26.2136225,21.6164633 30.6042246,21.6164633 C34.9954774,21.6164633 38.5678161,25.1648787 38.5678161,29.5267239 C38.5678161,33.8885692 34.9954774,37.4369846 30.6042246,37.4369846 L30.6042246,37.4369846 Z M9.36798061,18.3205213 C4.97672787,18.3205213 1.40438911,14.7721059 1.40438911,10.4102607 C1.40438911,6.04841541 4.97672787,2.5 9.36798061,2.5 C13.7592334,2.5 17.3315721,6.04841541 17.3315721,10.4102607 C17.3315721,14.7721059 13.7592334,18.3205213 9.36798061,18.3205213 L9.36798061,18.3205213 Z M32.8420329,3.60812584 L36.6718004,7.41353855 L6.9908312,36.8872301 L3.16106371,33.0817097 L32.8420329,3.60812584 Z' />
  </SvgIcon>
);
export const PercentageCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path
      d='M10.9310537 21.921099c-6.03705972 0-10.93105766-4.8983315-10.93105766-10.9407371 0-6.0424055 4.89399794-10.94073707 10.93105766-10.94073707 6.0370597 0 10.9310577 4.89833156 10.9310577 10.94073707 0 6.0424056-4.893998 10.9407371-10.9310577 10.9407371z'
      fill='#278ADA'
    />
    <path
      fill='#FFFFFF'
      d='M12.2759369 14.11158776c-.74950707 0-1.35279434-.60328968-1.35279434-1.35279972 0-.74958472.60328727-1.35283706 1.35279433-1.35283706.74954432 0 1.3527943.60325234 1.3527943 1.35283706 0 .74951004-.60324998 1.35279972-1.3527943 1.35279972zm-3.50998414-.36562558l-.51188125-.5118833 4.6800038-4.67998505.51188125.51184595-4.68000373 4.6800224zm-.69465597-4.2046942c0-.7495474.6032872-1.35283707 1.35275692-1.35283707.7495444 0 1.35283166.6032897 1.35283166 1.3528371s-.60328727 1.3527997-1.35283166 1.3527997c-.74946972.0182962-1.352757-.6032523-1.352757-1.3527997zm7.8060302.25592296l.0731473-1.37109594c0-.1462577-.0731473-.27418184-.2011082-.34732936l-1.2248334-.6215859-.6215461-1.22483824c-.07314724-.12796148-.2011082-.21936788-.34736534-.20107166l-1.3710531.07311018-1.1517235-.74954738c-.1279983-.07311018-.2742181-.07311018-.40217906 0l-1.15172345.74954738-1.35283168-.07311018c-.14625712-.01829622-.2742181.07311018-.347328.20107166l-.6215834 1.22483824-1.22483335.6215859c-.12792365.07314752-.20107088.20107166-.20107088.34732936l.07314722 1.37113328-.7495817 1.15169072c-.07314723.12799882-.07314723.2742192 0 .40218067l.74958173 1.15172806-.07314725 1.37109594c0 .1462577.07314723.27421918.20107087.3473667l1.22483334.62154856.6215834 1.22483827c.0731099.1279615.2010709.2194052.347328.2010716l1.3710905-.0731101 1.15172347.7495473c.05485108.0365551.12796097.054814.2011082.054814.0731099 0 .14625712-.0182589.20107087-.054814l1.15172347-.7495473 1.37109046.0731101c.1462571.0183336.27418075-.0731101.34732798-.2010716l.62158344-1.22483827 1.22483333-.62154856c.127961-.07314752.2010709-.201109.2010709-.3473667l-.0731099-1.37109594.7495444-1.15172806c.0731099-.12796148.0731099-.27418185 0-.40218067l-.7678406-1.15172806z'
    />
  </SvgIcon>
);
export const TapGoods = (props) => (
  <SvgIcon viewBox='0 0 25 13' {...props}>
    <path d='M18.808.005c-3.595 0-5.581 3.077-7.334 5.792-1.61 2.495-3.002 4.649-5.281 4.649-2.075 0-3.763-1.771-3.763-3.949 0-2.176 1.688-3.948 3.763-3.948 1.264 0 2.292.841 2.932 1.547l.009-.01c.222-.334.446-.676.674-1.03.232-.358.47-.723.713-1.087C9.217.684 7.731 0 6.193 0 2.778 0 0 2.915 0 6.497c0 3.583 2.778 6.498 6.193 6.498 3.568 0 5.546-3.065 7.292-5.769 1.619-2.506 3.017-4.672 5.323-4.672 2.074 0 3.763 1.771 3.763 3.949 0 2.177-1.689 3.948-3.763 3.948-.996 0-1.934-.497-2.954-1.566l-.018.02c-.23.342-.46.697-.694 1.06-.221.343-.45.691-.682 1.04C15.844 12.34 17.27 13 18.808 13 22.222 13 25 10.085 25 6.503 25 2.92 22.222.005 18.808.005' />
  </SvgIcon>
);
export const TapGoodsCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path
      d='M0 10.991c0 6.07 4.92 10.991 10.991 10.991 6.07 0 10.991-4.92 10.991-10.991C21.982 4.921 17.062 0 10.991 0 4.921 0 0 4.92 0 10.991z'
      fill='#278ADA'
    />
    <path
      fill='#FFFFFF'
      d='M14.005 7.93c-1.835 0-2.818 1.452-3.686 2.732-.847 1.25-1.426 2.01-2.324 2.01-.862 0-1.562-.701-1.562-1.562 0-.86.7-1.561 1.562-1.561.52 0 .955.342 1.229.63l.003-.003c.143-.197.29-.41.449-.643.156-.23.317-.467.485-.7-.651-.592-1.395-.905-2.166-.905a3.186 3.186 0 0 0-3.183 3.182 3.186 3.186 0 0 0 3.183 3.182c1.822 0 2.802-1.446 3.666-2.72.851-1.258 1.434-2.021 2.344-2.021.862 0 1.562.7 1.562 1.561s-.7 1.562-1.562 1.562c-.414 0-.798-.199-1.243-.644l-.015.014c-.152.208-.31.435-.478.685a29.29 29.29 0 0 1-.446.64c.69.62 1.406.925 2.182.925a3.186 3.186 0 0 0 3.182-3.182 3.186 3.186 0 0 0-3.182-3.182'
    />
  </SvgIcon>
);
export const Storefront = (props) => (
  <SvgIcon viewBox='0 0 17 18' {...props}>
    <path d='M14.087 10.677c-.09 0-.177-.018-.266-.026v5.174l-10.768-.001v-5.168c-.072.006-.14.021-.213.021-.656 0-1.26-.252-1.744-.652v7.8h1.958l10.766.002h1.958v-7.758a2.732 2.732 0 0 1-1.69.608M12.45 0H4.424L0 6.985c0 1.563 1.286 2.877 2.813 2.878 1.529 0 2.815-1.232 2.815-2.877 0 1.559 1.28 2.87 2.803 2.877v.001h.011v-.001c1.523-.006 2.803-1.318 2.803-2.877 0 1.645 1.288 2.877 2.816 2.877 1.527 0 2.813-1.315 2.813-2.878L12.45 0z' />
  </SvgIcon>
);

export const PencilAndRuler = (props) => (
  <SvgIcon viewBox='0 0 19 19' {...props}>
    <path
      d='M18.9951 15.1572L15.1738 18.9785L10.3242 14.1289L11.2285 13.2236L15.1738 17.168L17.1846 15.1572L15.6914 13.6641L14.5205 14.835L13.6162 13.9297L14.7861 12.7588L13.2402 11.2129L14.1455 10.3076L18.9951 15.1572ZM6.24316 16.9248L1.46777 18.0088L2.55176 13.2334L6.24316 16.9248ZM14.8555 8.4248L7.3623 15.918L3.55859 12.1143L11.0518 4.62109L14.8555 8.4248ZM9.16895 5.33105L8.26367 6.23535L6.67578 4.64746L5.50098 5.82324L4.5957 4.91895L5.77148 3.74316L4.31934 2.29102L2.30762 4.30273L6.25195 8.24707L5.34766 9.15234L0.498047 4.30273L4.31934 0.481445L9.16895 5.33105ZM18.0254 5.25488L16.1094 7.1709L12.3057 3.36719L14.2217 1.45117L18.0254 5.25488Z'
      fill='#278ADA'
    />
    <mask
      id='mask0_5257_2368'
      style={{ maskType: 'luminance' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='19'
      height='19'
    >
      <path
        d='M18.9951 15.1572L15.1738 18.9785L10.3242 14.1289L11.2285 13.2236L15.1738 17.168L17.1846 15.1572L15.6914 13.6641L14.5205 14.835L13.6162 13.9297L14.7861 12.7588L13.2402 11.2129L14.1455 10.3076L18.9951 15.1572ZM6.24316 16.9248L1.46777 18.0088L2.55176 13.2334L6.24316 16.9248ZM14.8555 8.4248L7.3623 15.918L3.55859 12.1143L11.0518 4.62109L14.8555 8.4248ZM9.16895 5.33105L8.26367 6.23535L6.67578 4.64746L5.50098 5.82324L4.5957 4.91895L5.77148 3.74316L4.31934 2.29102L2.30762 4.30273L6.25195 8.24707L5.34766 9.15234L0.498047 4.30273L4.31934 0.481445L9.16895 5.33105ZM18.0254 5.25488L16.1094 7.1709L12.3057 3.36719L14.2217 1.45117L18.0254 5.25488Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0_5257_2368)'>
      <rect x='-0.00195312' y='-0.0185547' width='20' height='20' />
    </g>
  </SvgIcon>
);

// Rentals
export const AllRentals = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M1.20343434,13.8130833 L19.1851178,21.7282222 C19.6800673,21.9455833 20.2396633,21.9455833 20.7347475,21.7282222 L38.7228956,13.8130833 C39.7280135,13.3715556 40.1957576,12.1732222 39.7676094,11.1366944 C39.5673401,10.6519722 39.1929293,10.2658611 38.7228956,10.0594722 L20.7412121,2.17141667 C20.2462626,1.95419444 19.6866667,1.95419444 19.1915825,2.17141667 L1.20343434,10.0594722 C0.198316498,10.501 -0.269427609,11.6991944 0.158720539,12.7357222 C0.358989899,13.2204444 0.733400673,13.6065556 1.20343434,13.8130833' />
    <path d='M37.2635671,25.1530436 L20.0000197,32.7417361 L2.73633709,25.1530436 C1.7221535,24.7248442 0.563414626,25.2259435 0.148257281,26.2724674 C-0.258523965,27.2982226 0.199594668,28.4717289 1.18203014,28.9201396 L19.2195563,36.8363935 C19.7160429,37.0545355 20.2773767,37.0545355 20.7738632,36.8363935 L38.8180092,28.9201396 C39.8203041,28.4626687 40.2731539,27.2536185 39.8298961,26.2195 C39.3951495,25.206011 38.2577562,24.7333468 37.2635671,25.1530436' />
    <path d='M20,25.2111816 L2.73631743,17.6259807 C1.72213383,17.1987552 0.563394959,17.6987148 0.148237614,18.7428585 C-0.258543631,19.7662807 0.199575001,20.937118 1.18201048,21.3845088 L19.2195366,29.3101551 C19.7160232,29.5276619 20.277357,29.5276619 20.7738436,29.3101551 L38.8179895,21.3845088 C39.8202845,20.9280784 40.2731343,19.721639 39.8298764,18.6900116 C39.3951298,17.6788277 38.2577365,17.2070994 37.2635475,17.6259807 L20,25.2111816 Z' />
  </SvgIcon>
);

export const NavigationRight = (props) => (
  <SvgIcon xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 13' {...props}>
    <path d='M13 6.5L0 0L3.87129 6.5L0 13L13 6.5Z' fill={props.fillColor} />
  </SvgIcon>
);

export const Pending = (props) => (
  <SvgIcon viewBox='0 0 9 18' {...props}>
    <path
      fill={props.fillColor}
      d='M0 .441h8.78V6.66L5.532 8.94l3.249 2.282v6.218H0v-6.218L3.25 8.94 0 6.66V.44zm1.311 4.204H7.47V1.752H1.31v2.893zm0 7.26v2.376H7.47v-2.377L4.39 9.742l-3.079 2.162z'
    />
  </SvgIcon>
);
export const Quotes = (props) => (
  <SvgIcon viewBox='0 0 38 40' {...props}>
    <path
      fill={props.fillColor}
      d='M29.8304286,23.6040857 C27.693,23.6040857 25.9602857,21.8713714 25.9602857,19.7338714 C25.9602857,17.5964429 27.693,15.8637286 29.8304286,15.8637286 C31.9678571,15.8637286 33.7006429,17.5964429 33.7006429,19.7338714 C33.7006429,21.8713714 31.9678571,23.6040857 29.8304286,23.6040857 M19.7337857,23.6040857 C17.5964286,23.6040857 15.8637143,21.8713714 15.8637143,19.7338714 C15.8637143,17.5964429 17.5964286,15.8637286 19.7337857,15.8637286 C21.8712143,15.8637286 23.6039286,17.5964429 23.6039286,19.7338714 C23.6039286,21.8713714 21.8712143,23.6040857 19.7337857,23.6040857 M9.63714286,23.6040857 C7.49971429,23.6040857 5.767,21.8713714 5.767,19.7338714 C5.767,17.5964429 7.49971429,15.8637286 9.63714286,15.8637286 C11.7745714,15.8637286 13.5073571,17.5964429 13.5073571,19.7338714 C13.5073571,21.8713714 11.7745714,23.6040857 9.63714286,23.6040857 M19.7337857,1.42857143e-05 C8.83507143,1.42857143e-05 0,8.83515714 0,19.7338714 C0,30.6325857 8.83507143,39.4678 19.7337857,39.4678 C30.6325,39.4678 39.4677143,30.6325857 39.4677143,19.7338714 C39.4677143,8.83515714 30.6325,1.42857143e-05 19.7337857,1.42857143e-05'
    />
  </SvgIcon>
);
export const QuotesCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <path
      fill={props.color || '#FFFFFF'}
      d='M17.7 16.5C17.1 16.5 16.6 16 16.6 15.4 16.6 14.8 17.1 14.3 17.7 14.3 18.2 14.3 18.7 14.8 18.7 15.4 18.7 16 18.2 16.5 17.7 16.5M14.9 16.5C14.3 16.5 13.8 16 13.8 15.4 13.8 14.8 14.3 14.3 14.9 14.3 15.5 14.3 16 14.8 16 15.4 16 16 15.5 16.5 14.9 16.5M12.1 16.5C11.6 16.5 11.1 16 11.1 15.4 11.1 14.8 11.6 14.3 12.1 14.3 12.7 14.3 13.2 14.8 13.2 15.4 13.2 16 12.7 16.5 12.1 16.5M14.9 10C11.9 10 9.5 12.4 9.5 15.4 9.5 18.4 11.9 20.8 14.9 20.8 17.9 20.8 20.3 18.4 20.3 15.4 20.3 12.4 17.9 10 14.9 10'
    />
  </SvgIcon>
);
export const Reservations = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path
      fill={props.fillColor}
      d='M34.6713098,11.1522989 C33.058212,12.7653967 30.4429946,12.7653967 28.8300054,11.1523533 C27.2169076,9.53925543 27.216962,6.92403804 28.8300054,5.31104891 L23.5190272,1.63043478e-05 L5.43478262e-06,23.519038 L16.4633207,39.9822989 L39.982288,16.4633315 L34.6713098,11.1522989 Z'
    />
  </SvgIcon>
);
export const ReservationsCircle = (props) => (
  <SvgIcon viewBox='0 0 25 25' {...props}>
    <circle cx='12.5' cy='12.5' r='12.5' />
    <path
      fill='#FFFFFF'
      d='M17.4013929 10.34568967c-.4839293.48392935-1.26849453.48392935-1.75239127.0000163-.48392935-.48392934-.48391304-1.26849456 0-1.7523913L14.05570815 7.0000049l-7.05570652 7.0557065 4.93899457 4.9389783 7.0556902-7.05569024-1.5932935-1.5933098z'
    />
  </SvgIcon>
);
export const CheckedOut = (props) => (
  <SvgIcon viewBox='0 0 20 16' {...props}>
    <path
      fill={props.fillColor}
      d='M.75770957 6.3427955L.7415862 9.64108111l11.8443737.03897624-3.3144469 3.31444689 2.31673885 2.31673885L18.89949494 8 11.46647297.56697803l-2.3396296 2.3396296 3.47520198 3.47520196z'
    />
  </SvgIcon>
);
export const CheckedIn = (props) => (
  <SvgIcon viewBox='0 0 20 16' {...props}>
    <path
      fill={props.fillColor}
      d='M19.14178552 6.2422905l.01612338 3.29828562-11.84437364.03897624 3.31444685 3.31444685-2.31673885 2.31673885L1.0000002 7.899495 8.43302215.46647306l2.33962952 2.33962952L7.2974497 6.28130454z'
    />
  </SvgIcon>
);
export const Closed = (props) => (
  <SvgIcon viewBox='0 0 38 41' {...props}>
    <polygon
      fill={props.fillColor}
      points='0 27.1622147 17.8534694 40.4932094 25.8030389 29.6258796 15.5740131 25.6611675 14.6527888 19.4578168 7.64211466 16.7149895'
    />
    <path
      fill={props.fillColor}
      d='M32.7849626,11.2959162 C31.2468595,12.8498429 28.7532265,12.8498429 27.215227,11.2959162 C25.6771757,9.74198953 25.6771757,7.22256545 27.215227,5.6686911 L22.1511102,0.552356021 L10.8903774,11.9293194 L17.4205142,15.6927225 L17.4205142,21.9655497 L26.9539448,27.4198429 L37.8490276,16.4123037 L32.7849626,11.2959162 Z'
    />
  </SvgIcon>
);
export const Cancelled = (props) => (
  <SvgIcon viewBox='0 0 38 40' {...props}>
    <path
      fill={props.fillColor}
      d='M29.0232359,29.0232359 C26.612952,31.4334475 23.4084579,32.760823 19.9998914,32.760823 C18.0934542,32.760823 16.2508664,32.3452943 14.5754313,31.557527 L31.557527,14.5755037 C32.3452219,16.2510112 32.760823,18.0935989 32.760823,19.9999638 C32.760823,23.4084579 31.4334475,26.6130244 29.0232359,29.0232359 M10.9767641,10.9766917 C13.3869032,8.56655247 16.5913973,7.23917698 19.9998914,7.23917698 C21.9064735,7.23917698 23.7489888,7.65477813 25.4245687,8.44254537 L8.44254537,25.4247135 C7.65477813,23.7491336 7.23917698,21.9065458 7.23917698,19.9999638 C7.23917698,16.5914697 8.56648008,13.3869032 10.9767641,10.9766917 M19.9998914,0 C8.9542104,0 0,8.95428279 0,19.9999638 C0,31.0456448 8.9542104,40 19.9998914,40 C31.0456448,40 40,31.0456448 40,19.9999638 C40,8.95428279 31.0456448,0 19.9998914,0'
    />
  </SvgIcon>
);
export const CancelCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    fill={props.disable ? '#C1CDD7' : '#CA3A3A'}
    {...props}
  >
    <path d='M24.9795615 12.5101989c0 6.8979204-5.5918626 12.489783-12.489783 12.489783-6.89792045 0-12.48978302-5.5918626-12.48978302-12.489783 0-6.89792042 5.59186257-12.489783 12.48978302-12.489783 6.8979204 0 12.489783 5.59186258 12.489783 12.489783' />
    <path
      fill='#FFFFFF'
      d='M14.9723655 14.9723614C14.3096677 15.635042 13.428605 16 12.4914334 16c-.5241672 0-1.0307793-.1142484-1.4914334-.3308427L15.6691586 11C15.8857321 11.4606759 16 11.9672899 16 12.4914393c0 .9371554-.3649565 1.8182416-1.0276345 2.4809221m-4.944731-4.944755C10.6902925 9.36495362 11.5713552 9 12.5085069 9c.524207 0 1.0307992.11426695 1.4914931.33085864L9.33086128 14C9.11426786 13.5393097 9 13.0327017 9 12.5084989c0-.9371443.36493663-1.8182199 1.0276345-2.4808925M12.4999701 7C9.46240786 7 7 9.46242777 7 12.49999 7 15.5375523 9.46240786 18 12.4999701 18 15.5375523 18 18 15.5375523 18 12.49999 18 9.46242777 15.5375523 7 12.4999701 7'
    />
  </SvgIcon>
);
export const SubRental = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M9.41179736,20.6336941 L12.7425472,17.3029443 L16.3149022,20.8751993 L25.4254679,11.7647336 L28.7561177,15.0954834 L19.645552,24.2059491 L16.3149022,27.5366989 L12.9841524,24.2059491 L9.41179736,20.6336941 Z M5.33330051,14.9232197 C4.92302326,16.0000796 4.66661307,17.1283682 4.56406995,18.2565521 L1.04742478e-05,17.7437317 C0.153772794,16.2564898 0.461506918,14.8206765 0.974327296,13.3847585 L5.33330051,14.9232197 Z M8.97426236,9.07710924 C8.1538126,9.897559 7.43580122,10.8206566 6.82043771,11.7949734 L2.92306568,9.33341468 C3.74351544,8.10268767 4.66661307,6.92317985 5.74357777,5.84621516 L8.97426236,9.07710924 Z M4.56406995,21.7436469 C4.66661307,22.8719355 4.92302326,24.0000147 5.33330051,25.0769794 L0.974327296,26.6154405 C0.512830853,25.2308464 0.153772794,23.7437092 1.04742478e-05,22.2564673 L4.56406995,21.7436469 Z M9.23067255,36.9743912 L11.6922313,33.0770192 C12.6666529,33.6923827 13.7435128,34.205203 14.8204775,34.5642611 L13.2820164,38.9232343 C11.8460984,38.4103092 10.5127235,37.7949457 9.23067255,36.9743912 Z M14.7691536,5.43604265 C13.6922936,5.84621516 12.6666529,6.3077116 11.6410121,6.92317985 L9.17945335,3.02570308 C10.4615043,2.20514858 11.7947744,1.58978507 13.2306924,1.07706943 L14.7691536,5.43604265 Z M2.92306568,30.6667843 L6.82043771,28.2052256 C7.43580122,29.1795424 8.1538126,30.10264 8.97426236,30.9231945 L5.74357777,34.1539839 C4.66661307,33.1283431 3.74351544,31.9488353 2.92306568,30.6667843 Z M19.9999005,0 C30.8204524,0 40,8.97446137 40,20.0000995 C40,31.0257376 30.8204524,40.0000943 19.9999005,40.0000943 C19.0255837,40.0000943 18.4614394,40.0000943 17.7435327,39.8975511 L18.2563531,35.3333869 C18.8204974,35.3847109 19.3333178,35.4360348 19.9999005,35.4360348 C28.5640846,35.4360348 35.4358358,28.5128549 35.4358358,20.0000995 C35.4358358,11.4872393 28.5640846,4.56426896 19.9999005,4.56426896 C19.3333178,4.56426896 18.7691735,4.61548815 18.2051339,4.66681208 L17.7435327,0.10264787 C18.4614394,0.0514286777 19.0255837,0 19.9999005,0 Z' />
  </SvgIcon>
);
export const SubRentalCircle = (props) => (
  <SvgIcon viewBox='0 0 25 25' {...props}>
    <path d='M24.979566 12.489783c0 6.8979204-5.5918626 12.489783-12.489783 12.489783C5.59186257 24.979566 0 19.3877034 0 12.489783 0 5.59186257 5.59186257 0 12.489783 0c6.8979204 0 12.489783 5.59186257 12.489783 12.489783' />
    <path
      fill='#FFFFFF'
      d='M8 12.7692993l1.41556534-1.4155653 1.51824726 1.5182048L14.8057939 9l1.4155229 1.4155653-3.8719813 3.8719388-1.4155229 1.4155654-1.41556531-1.4155654L8 12.7692993zm-1.73335707-2.4269459c-.17436743.4576644-.2833415.9371859-.32692223 1.416663L4 11.5410682c.06534883-.6320763.19613553-1.2422955.41408367-1.85255924l1.85255926.65384444zm1.54740513-2.48459107c-.34869033.34869033-.65384444.7410059-.91537331 1.15508957L5.24229554 7.96669189c.34869032-.52305774.74100589-1.02434739 1.19871481-1.4820563l1.37303771 1.37312674zM5.9397207 13.2410282c.04358073.4795215.1525548.958954.32692223 1.4166629l-1.85255926.6538445C4.21794815 14.7230845 4.06534883 14.0910526 4 13.4589763l1.9397207-.2179481zm1.98330143 6.473051L8.96918214 18.0577c.41412819.2615289.87179259.479477 1.32950146.6320763l-.65384439 1.8525593c-.61026372-.2179927-1.17694671-.4795215-1.72181708-.8282564zM10.276871 6.31031268c-.45766437.17432291-.89356067.37045843-1.32945696.63203182L7.90125403 5.28592078c.54487037-.34873484 1.11150884-.61026372 1.72177256-.82816735l.65384441 1.85255925zM5.24229554 17.0333526l1.65637921-1.04616c.26152887.4140837.56668298.8063993.91537331 1.1551341l-1.37303771 1.3730822c-.45770892-.4358963-.85002449-.9371859-1.19871481-1.4820563zM12.4999332 4c4.5987237 0 8.5000223 3.81413709 8.5000223 8.5000223C20.9999555 17.1859074 17.0986569 21 12.4999332 21c-.4140836 0-.6538444 0-.958954-.0435807l.2179481-1.9397652c.2397608.0218126.4577089.0436252.7410059.0436252 3.6397697 0 6.5602571-2.9423445 6.5602571-6.560257 0-3.61795709-2.9204874-6.56021256-6.5602571-6.56021256-.283297 0-.5230577.0217681-.762774.04358072l-.19618-1.93976522C11.8460888 4.02185714 12.0858496 4 12.4999332 4z'
    />
  </SvgIcon>
);
export const CheckingOut = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M3.51318224 0v3.30868236h4.96307704L5.99071205 5.65635891 8.33440664 8l2.48549376-2.34767655v4.68733565h3.3087358V0zm-.45962871 8.37989862l1.62634556-1.62634556L7.01335143 9.0870054l-1.62634556 1.62634556zM.05355296 11.17989904l1.62634556-1.62634556 2.33345234 2.33345234L2.3870053 13.5133514z' />
  </SvgIcon>
);
export const CheckingIn = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M10.615454 14.33966v-3.30868236H5.65237696l2.48554723-2.34767655L5.7942296 6.33966 3.30873587 8.68733655V4.0000009H0V14.33966zm.34434402-8.3062076L9.33345245 7.65979794 7.00000011 5.32634561l1.62634556-1.62634556zm3-3l-1.62634557 1.62634555-2.33345234-2.33345234L11.62634567.70000005z' />
  </SvgIcon>
);
export const Drafts = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M5.10650277,26.50293 L2.93871225,36.0544874 L12.4903427,33.88677 L5.10650277,26.50293 Z M22.1071984,9.27840632 L7.12015099,24.2655269 L14.7277458,31.8731949 L29.7148664,16.8860743 L22.1071984,9.27840632 Z M28.4469217,2.93875613 L24.6150818,6.77052292 L32.2227498,14.3781909 L36.0545166,10.546351 L28.4469217,2.93875613 Z' />
    <polygon points='8.64235 1 1.00002194 8.64240119 10.6986287 18.341081 12.5083381 16.5313715 4.61936779 8.64240119 8.64235 4.61934585 16.5313204 12.5083893 18.3410298 10.6986798' />
    <polygon points='26.4848322 22.4619158 34.3738026 30.3508862 30.3508204 34.3738684 22.4619231 26.4849711 20.6522136 28.2946075 30.3508204 37.9932874 37.9932215 30.3508862 28.2946148 20.6522794' />
    <polygon points='11.0050047 11.6840498 13.3685443 9.32051028 11.5589079 7.51080079 9.19529526 9.87441344' />
    <polygon points='29.0457733 29.7061136 31.4093128 27.3425741 29.5996765 25.5328646 27.2360638 27.8964773' />
  </SvgIcon>
);
export const Templates = (props) => (
  <SvgIcon viewBox='0 0 38 38' {...props}>
    <path d='M36.1000271,0 C37.2400166,0 38.0000095,0.759992952 38.0000095,1.89998238 L38.0000095,9.11991543 C38.0000095,9.30991367 37.8082018,9.49991191 37.620013,9.49991191 L0.380358378,9.49991191 C0.19036014,9.49991191 0.000361901406,9.30991367 0.000361901406,9.11991543 L0.000361901406,1.89998238 C0.000361901406,0.759992952 0.760354854,0 1.90034428,0 L36.1000271,0 Z M37.6196511,13.3000576 C37.8078399,13.3000576 37.9996476,13.4900559 37.9996476,13.6800541 L37.9996476,36.0998462 C37.9996476,37.2398356 37.2396547,37.9998286 36.0996652,37.9998286 L13.6798731,37.9998286 C13.4898749,37.9998286 13.2998767,37.8098303 13.2998767,37.6198321 L13.2998767,13.6800541 C13.2998767,13.4900559 13.4898749,13.3000576 13.6798731,13.3000576 L37.6196511,13.3000576 Z M9.11991543,13.3000576 C9.30810416,13.3000576 9.49991191,13.4900559 9.49991191,13.6800541 L9.49991191,37.6198321 C9.49991191,37.8098303 9.30810416,37.9998286 9.11991543,37.9998286 L1.89998238,37.9998286 C0.759992952,37.9998286 0,37.2398356 0,36.0998462 L0,13.6800541 C0,13.4900559 0.189998238,13.3000576 0.379996476,13.3000576 L9.11991543,13.3000576 Z' />
  </SvgIcon>
);
export const TemplatesCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783' />
    <path
      fill='#FFFFFF'
      d='M17.4501052,7.00007619 C17.7801021,7.00007619 18.0001,7.2200741 18.0001,7.55007095 L18.0001,9.64005105 C18.0001,9.69505052 17.9445767,9.75005 17.890101,9.75005 L7.11020371,9.75005 C7.05520424,9.75005 7.00020476,9.69505052 7.00020476,9.64005105 L7.00020476,7.55007095 C7.00020476,7.2200741 7.22020267,7.00007619 7.55019952,7.00007619 L17.4501052,7.00007619 Z M17.8899963,10.8500919 C17.944472,10.8500919 17.9999952,10.9050914 17.9999952,10.9600909 L17.9999952,17.450029 C17.9999952,17.7800259 17.7799973,18.0000238 17.4500005,18.0000238 L10.9600623,18.0000238 C10.9050628,18.0000238 10.8500633,17.9450243 10.8500633,17.8900249 L10.8500633,10.9600909 C10.8500633,10.9050914 10.9050628,10.8500919 10.9600623,10.8500919 L17.8899963,10.8500919 Z M9.64007486,10.8500919 C9.69455053,10.8500919 9.75007381,10.9050914 9.75007381,10.9600909 L9.75007381,17.8900249 C9.75007381,17.9450243 9.69455053,18.0000238 9.64007486,18.0000238 L7.55009476,18.0000238 C7.2200979,18.0000238 7.0001,17.7800259 7.0001,17.450029 L7.0001,10.9600909 C7.0001,10.9050914 7.05509948,10.8500919 7.11009895,10.8500919 L9.64007486,10.8500919 Z'
    />
  </SvgIcon>
);
export const Summary = (props) => (
  <SvgIcon viewBox='0 0 28 40' {...props}>
    <path d='M0,40 L0,0 L28,0 L28,40 L0,40 Z M5.01895425,11.0777124 L22.9809804,11.0777124 L22.9809804,5.32215686 L5.01895425,5.32215686 L5.01895425,11.0777124 Z M5.01895425,19.609085 L22.9809804,19.609085 L22.9809804,13.8535948 L5.01895425,13.8535948 L5.01895425,19.609085 Z M5.01895425,28.1403268 L22.9809804,28.1403268 L22.9809804,22.3847712 L5.01895425,22.3847712 L5.01895425,28.1403268 Z' />
  </SvgIcon>
);
export const SummaryCircle = (props) => (
  <SvgIcon viewBox='0 0 30 30' {...props}>
    <circle cx='15' cy='15' r='15' />
    <path
      fill='#FFFFFF'
      d='M10.5 21.7142857V8.5h9.25v13.2142857H10.5zm1.6580474-9.5546843h5.9338836v-1.9013889h-5.9338836v1.9013889zm0 2.8183999h5.9338836V13.076634h-5.9338836v1.9013673zm0 2.8183567h5.9338836v-1.9013889h-5.9338836v1.9013889z'
    />
  </SvgIcon>
);
export const InProgress = (props) => (
  <SvgIcon viewBox='0 0 16 16' {...props}>
    <path d='M7.999.02c-.601 0-1.088.488-1.088 1.088V4.26a1.088 1.088 0 1 0 2.176 0V1.108C9.087.508 8.6.02 7.999.02M11.427 6.13l2.228-2.228a1.088 1.088 0 1 0-1.54-1.539L9.889 4.592a1.087 1.087 0 1 0 1.539 1.538M14.91 6.931h-3.152a1.088 1.088 0 1 0 0 2.176h3.151a1.087 1.087 0 1 0 0-2.176M11.427 9.908a1.088 1.088 0 0 0-1.54 1.539l2.23 2.228a1.087 1.087 0 1 0 1.538-1.538l-2.228-2.229zM7.999 10.69c-.601 0-1.088.488-1.088 1.089v3.151a1.087 1.087 0 1 0 2.176 0V11.78c0-.601-.488-1.089-1.088-1.088M4.571 9.908l-2.228 2.229a1.088 1.088 0 1 0 1.538 1.538l2.229-2.228A1.088 1.088 0 1 0 4.57 9.908M5.327 8.02c0-.601-.487-1.088-1.088-1.089H1.09a1.088 1.088 0 1 0-.001 2.176h3.151c.601 0 1.089-.487 1.088-1.088M4.571 6.13A1.087 1.087 0 1 0 6.11 4.592L3.88 2.363a1.088 1.088 0 1 0-1.538 1.539L4.571 6.13z' />
  </SvgIcon>
);

// Settings
export const User = (props) => (
  <SvgIcon viewBox='0 0 34 40' {...props}>
    <path d='M16.5753399,19.7096218 C21.274435,19.7096218 25.0825586,15.0272293 25.0825586,9.25196222 C25.0825586,3.47549674 21.2737352,0.0997998263 16.5753399,0.0997998263 C11.8775445,0.0997998263 8.06962087,3.47489752 8.06962087,9.25196222 C8.06962087,15.0272293 11.8775445,19.7096218 16.5753399,19.7096218' />
    <path d='M33.0927847,30.9943226 C32.2636973,23.4044225 25.2941843,20.7041446 16.8158582,20.7041446 C16.7356788,20.7041446 16.6553994,20.7090382 16.5753199,20.7102366 C16.4939408,20.7090382 16.4161607,20.7041446 16.3336819,20.7041446 C7.85665547,20.7041446 0.885942835,23.4044225 0.0575552422,30.9943226 C0.036160728,31.1899674 0.0171655986,32.8517998 -2.99923096e-05,33.747132 L0.000469879518,33.747132 C4.56569931,37.2468671 10.1106775,39.1202236 16.5753199,39.1191251 C22.9697803,39.1191251 28.6054353,37.1791554 33.1502699,33.747132 C33.1348739,32.8517998 33.1129795,31.1899674 33.0927847,30.9943226' />
  </SvgIcon>
);
export const UserCircle = (props) => (
  <SvgIcon
    viewBox='0 0 22 22'
    style={{ height: '22px', width: '23px' }}
    {...props}
  >
    <path
      fill={props.color || '#000000'}
      d='M21.8621114,10.9586209 C21.8621114,17.0010265 16.9681134,21.899358 10.9310537,21.899358 C4.89399398,21.899358 -3.9566002e-06,17.0010265 -3.9566002e-06,10.9586209 C-3.9566002e-06,4.91621539 4.89399398,0.0178838286 10.9310537,0.0178838286 C16.9681134,0.0178838286 21.8621114,4.91621539 21.8621114,10.9586209'
    />
    <path
      fill='#FFFFFF'
      d='M10.9311131,11.0065025 C12.1547708,11.0065025 13.1464926,9.78477092 13.1464926,8.27795144 C13.1464926,6.77081515 12.1546521,5.89004847 10.9311131,5.89004847 C9.70777184,5.89004847 8.71616869,6.77065674 8.71616869,8.27795144 C8.71616869,9.78477092 9.70777184,11.0065025 10.9311131,11.0065025'
    />
    <path
      fill='#FFFFFF'
      d='M15.2324281,13.9508278 C15.0165164,11.9705383 13.2015843,11.2659963 10.9937619,11.2659963 C10.972871,11.2659963 10.9519802,11.2672239 10.9311289,11.2675803 C10.9099215,11.2672239 10.8896637,11.2659963 10.8681794,11.2659963 C8.66067342,11.2659963 6.84538524,11.9705383 6.62971096,13.9508278 C6.62409259,14.0018736 6.61918641,14.4354653 6.61471545,14.6691114 L6.61487371,14.6691114 C7.80371338,15.5821926 9.24767463,16.0709882 10.9311289,16.070711 C12.5963036,16.070711 14.0638858,15.5645305 15.2473841,14.6691114 C15.2433879,14.4354653 15.2376508,14.0018736 15.2324281,13.9508278'
    />
  </SvgIcon>
);
export const UserAdd = (props) => (
  <SvgIcon viewBox='0 0 38 40' {...props}>
    <path d='M16.4927859,19.4164769 C21.168477,19.4164769 24.957634,14.8037265 24.957634,9.11435605 C24.957634,3.42380503 21.1677806,0.0983154847 16.4927859,0.0983154847 C11.818388,0.0983154847 8.02942984,3.42321472 8.02942984,9.11435605 C8.02942984,14.8037265 11.818388,19.4164769 16.4927859,19.4164769' />
    <path d='M30.1839073,33.1821697 C24.6843524,33.1821697 20.2260173,28.7728781 20.2260173,23.3336007 C20.2260173,22.3871432 20.3614047,21.4720704 20.6133785,20.6056978 C19.3695251,20.4633356 18.0698654,20.3962375 16.7321063,20.3962375 C16.6523262,20.3962375 16.5724466,20.4009599 16.492766,20.4022389 C16.4117921,20.4009599 16.3343995,20.3962375 16.2523314,20.3962375 C7.81752513,20.3962375 0.881530366,23.0563536 0.0571691099,30.5333677 C0.0359806283,30.7261027 0.0170801047,32.3632183 -2.98429322e-05,33.2452341 L0.000467539267,33.2452341 C4.54315864,36.6931137 10.0600225,38.5384107 16.492766,38.5372301 C22.8553785,38.5372301 28.4629649,36.626114 32.9851639,33.2452341 C32.9828759,33.1084798 32.9802895,32.9535245 32.9776037,32.7886323 C32.0911691,33.04453 31.1538026,33.1821697 30.1839073,33.1821697' />
    <path d='M34.9502314,24.3787377 L31.251399,24.3787377 L31.251399,24.3788361 L31.230111,24.3788361 L31.230111,28.0584109 L29.1163361,28.0584109 L29.1163361,24.3787377 L25.4175037,24.3787377 L25.4175037,22.2883654 L29.1163361,22.2883654 L29.1379225,22.2883654 L29.1379225,18.6088889 L31.251399,18.6088889 L31.251399,22.2883654 L31.251399,22.2885621 L34.9502314,22.2885621 L34.9502314,24.3787377 Z M30.1840168,15.6813641 C25.9108073,15.6813641 22.4466398,19.1074024 22.4466398,23.3336007 C22.4466398,27.5598974 25.9108073,30.9859358 30.1840168,30.9859358 C34.4572262,30.9859358 37.9210953,27.5598974 37.9210953,23.3336007 C37.9210953,19.1074024 34.4572262,15.6813641 30.1840168,15.6813641 L30.1840168,15.6813641 Z' />
  </SvgIcon>
);
export const Team = (props) => (
  <SvgIcon viewBox='0 0 43 40' {...props}>
    <path d='M15.2238576,1.59868431 C14.3965484,1.22343269 13.4695464,1.02760575 12.4904782,1.02760575 C8.99709229,1.02760575 6.16563449,3.5177483 6.16563449,7.78023467 C6.16563449,12.0413208 8.99709229,15.4960961 12.4904782,15.4960961 C13.3260614,15.4960961 14.1228977,15.2966687 14.8530366,14.9378193 C13.8092891,12.987351 13.2490719,10.7215393 13.2490719,8.36031446 C13.2490719,5.75335584 13.9273464,3.44813873 15.2238576,1.59868431' />
    <path d='M17.5062817,18.6522961 C16.9766384,18.2102353 16.4776697,17.707066 16.0161364,17.1441886 C15.8772929,16.9747653 15.7434947,16.8007414 15.6138334,16.623617 C14.621345,16.4998 13.5792119,16.441692 12.504386,16.441692 C12.4446511,16.441692 12.3849161,16.4452925 12.3253829,16.4461926 C12.2649416,16.4452925 12.2071238,16.441692 12.1457744,16.441692 C5.84212052,16.441692 0.658598235,18.433966 0.0427831549,24.0340364 C0.0268403755,24.1783563 0.0127138621,25.4044249 0,26.0651158 L0.000201807334,26.0651158 C1.57994962,27.2666811 3.31761167,28.2080106 5.20824368,28.8715019 C6.32343101,23.3709452 10.5914543,19.8530613 17.5062817,18.6522961' />
    <path d='M26.0540808,19.6381015 C30.7968559,19.6381015 34.6403775,14.9489564 34.6403775,9.16536082 C34.6403775,3.38056504 30.7961496,0 26.0540808,0 C21.3126175,0 17.4692977,3.37996496 17.4692977,9.16536082 C17.4692977,14.9489564 21.3126175,19.6381015 26.0540808,19.6381015' />
    <path d='M42.6488773,30.8571326 C41.8120832,23.256287 34.7777858,20.552115 26.2206504,20.552115 C26.1397256,20.552115 26.0587,20.5570156 25.9778761,20.5582158 C25.8957405,20.5570156 25.8172375,20.552115 25.733992,20.552115 C17.1781682,20.552115 10.14266,23.256287 9.30657225,30.8571326 C9.28497887,31.0530595 9.26580717,32.7172885 9.24845174,33.6139118 L9.24895626,33.6139118 C13.8566213,37.1186939 19.4531423,38.994752 25.9778761,38.9936519 C32.4317756,38.9936519 38.1198162,37.0508846 42.7068969,33.6139118 C42.6913577,32.7172885 42.6692598,31.0530595 42.6488773,30.8571326' />
  </SvgIcon>
);
export const Roles = (props) => (
  <SvgIcon viewBox='0 0 16 16' {...props} fill={props.fill}>
    <path d='M8 0L6.3 1.653 4 1.073l-.646 2.28L1.072 4l.58 2.3L0 8l1.653 1.7-.581 2.3 2.282.647.646 2.28 2.3-.58L8 16l1.701-1.653L12 14.93l.646-2.281L14.93 12l-.581-2.299L16 8.001 14.348 6.3l.58-2.3-2.282-.647L12 1.073l-2.299.58L8.001 0zM6.307 8.808l-2.74-1.99h3.386L8 3.595l1.047 3.221h3.387l-2.74 1.99 1.046 3.222L8 10.038l-2.74 1.99 1.047-3.22z' />
  </SvgIcon>
);
export const ServiceIcon = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '25px', ...props.style }}
  >
    <polygon
      fill={props.fill}
      id='path-1'
      points='12.500463 0 9.84388311 2.5815771 6.25023149 1.67506204 5.24000889 5.23908293 1.67506204 6.24930553 2.58250306 9.84295715 0 12.5013889 2.58250306 15.1579688 1.67506204 18.7497685 5.24000889 19.761843 6.25023149 23.3258639 9.84388311 22.4174969 12.500463 24.999074 15.1579688 22.4174969 18.7497685 23.3258639 19.7599911 19.761843 23.3258639 18.7497685 22.4184229 15.1579688 25 12.5013889 22.4184229 9.84295715 23.3258639 6.24930553 19.7599911 5.23908293 18.7497685 1.67506204 15.1579688 2.5815771'
    ></polygon>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <mask id='mask-2' fill='white'>
        <use></use>
      </mask>
      <use id='Mask' fill='#278ADA'></use>
      <text
        style={{
          fontSize: '10px',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        fill='#FFFFFF'
        textAnchor='middle'
        x='50%'
        y='16px'
      >
        {props.number}
      </text>
    </g>
  </SvgIcon>
);
export const Business = (props) => (
  <SvgIcon viewBox='0 0 55 37' {...props}>
    <path d='M48.77646,12.8952864 L27.60126,12.8952864 C26.56086,12.8952864 25.70406,12.0314826 25.70406,10.9824771 C25.70406,9.9336733 26.56086,9.06986948 27.60126,9.06986948 L48.77646,9.06986948 C49.81676,9.06986948 50.67366,9.9336733 50.67366,10.9824771 C50.67366,12.0314826 49.81676,12.8952864 48.77646,12.8952864 M48.77646,20.5461202 L27.60126,20.5461202 C26.56086,20.5461202 25.70406,19.6823163 25.70406,18.6334117 C25.70406,17.5845071 26.56086,16.7206025 27.60126,16.7206025 L48.77646,16.7206025 C49.81676,16.7206025 50.67366,17.5845071 50.67366,18.6334117 C50.67366,19.6823163 49.81676,20.5461202 48.77646,20.5461202 M48.77646,28.0117523 L27.60126,28.0117523 C26.56086,28.0117523 25.70406,27.1480493 25.70406,26.0991447 C25.70406,25.0502401 26.56086,24.1864362 27.60126,24.1864362 L48.77646,24.1864362 C49.81676,24.1864362 50.67366,25.0502401 50.67366,26.0991447 C50.67366,27.086349 49.81676,28.0117523 48.77646,28.0117523 M20.86926,27.3331501 L5.69156,27.3331501 C4.46756,27.3331501 4.16166,26.592646 5.01846,25.6672428 L7.83356,22.4587278 C8.62926,21.5333245 10.28166,20.7929213 11.50566,20.7929213 L15.05526,20.7929213 C16.27926,20.7929213 17.93166,21.5333245 18.72726,22.4587278 L21.54236,25.6672428 C22.33806,26.592646 22.03206,27.3331501 20.86926,27.3331501 M13.21926,8.69966785 C16.09566,8.69966785 18.48246,11.0442782 18.48246,14.0058913 C18.48246,16.9057033 16.15686,19.3121147 13.21926,19.3121147 C10.34276,19.3121147 7.95606,16.9676052 7.95606,14.0058913 C7.95606,11.1059785 10.34276,8.69966785 13.21926,8.69966785 M48.53166,3.02452316e-05 L6.42596,3.02452316e-05 C2.87636,3.02452316e-05 -3.99999999e-05,2.96154251 -3.99999999e-05,6.47845804 L-3.99999999e-05,30.479864 C-3.99999999e-05,34.0584798 2.87636,36.9583926 6.42596,36.9583926 L39.29046,36.9583926 L49.14366,36.9583926 C52.38716,36.6498913 54.95766,33.873379 54.95766,30.5415643 L54.95766,6.47845804 C54.95766,2.96154251 52.08126,3.02452316e-05 48.53166,3.02452316e-05' />
  </SvgIcon>
);
export const BusinessCircle = (props) => (
  <SvgIcon viewBox='0 0 22 22' {...props}>
    <path d='M19.948 10.01c0 5.508-4.466 9.974-9.974 9.974C4.465 19.984 0 15.518 0 10.01S4.465.036 9.974.036c5.508 0 9.974 4.466 9.974 9.974' />
    <path
      fill='#FFFFFF'
      d='M14.067 6c.454 0 .825.371.825.824v5.772a.826.826 0 0 1-.825.823H5.824A.826.826 0 0 1 5 12.596V6.824C5 6.371 5.371 6 5.824 6h8.243zM9.534 8.474h4.122v-.825H9.534v.825zm.824 1.647h3.298v-.823h-3.298v.823zm0 1.649h3.298v-.825h-3.298v.825zm-2.553.171c.708 0 1.33-.213 1.833-.591-.002-.099-.004-.283-.006-.304-.091-.837-.863-1.134-1.801-1.134h-.053c-.938 0-1.708.297-1.8 1.134-.003.021-.004.205-.006.304.505.386 1.118.591 1.833.591zm-.012-4.392c-.519 0-.941.37-.941 1.008 0 .637.422 1.152.941 1.152.52 0 .94-.515.94-1.152 0-.638-.42-1.008-.94-1.008z'
    />
  </SvgIcon>
);
export const RentalSettings = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M19.9885586,30.2326538 C13.956036,30.2326538 9.06630631,25.4533499 9.06630631,19.5586345 C9.06630631,13.6639191 13.956036,8.88461527 19.9885586,8.88461527 C26.0210811,8.88461527 30.9108108,13.6632148 30.9108108,19.5586345 C30.9108108,25.4540543 26.0210811,30.2326538 19.9885586,30.2326538 L19.9885586,30.2326538 Z M39.9744144,22.0998077 L39.9756757,17.016757 L35.9584685,16.057621 C35.64,14.6654916 35.1363063,13.3419474 34.4732432,12.1121685 L36.8984685,8.84217875 L33.5303604,4.96874509 L29.8316216,6.78251044 C28.0017117,5.43413821 25.8735135,4.45272748 23.5606306,3.94894779 L22.581982,0.0263863636 L17.3807207,0.0263863636 L16.4006306,3.95299775 C14.2048649,4.43327007 12.1758559,5.34389455 10.4115315,6.5905776 L6.7527027,4.70540971 L3.30531532,8.51149079 L5.66108108,11.8265584 C4.91873874,13.1372484 4.35918919,14.5610731 4.01585586,16.0644003 L0.0296396396,16.9911366 L0,22.073571 L4.01657658,23.0548937 C4.33504505,24.4497525 4.83954955,25.775938 5.50387387,27.0071255 L3.08063063,30.2374081 L6.42738739,34.1283622 L10.1400901,32.3320293 C11.9712613,33.6825145 14.1015315,34.6651579 16.4171171,35.1689376 L17.3668468,39.0645579 L22.5681982,39.0908827 L23.570991,35.1655039 C25.7805405,34.6833827 27.8211712,33.7646583 29.5937838,32.5064416 L33.2092793,34.3944269 L36.6772973,30.6064826 L34.3298198,27.2657946 C35.0645946,25.9625002 35.6186486,24.5488004 35.9590991,23.0562144 L39.9744144,22.0998077 Z' />
    <path d='M21.4339538,20.2701053 C21.0186572,20.9488765 20.0798409,21.1064438 19.4562328,20.6016082 C18.8325363,20.0967727 18.8183011,19.1688574 19.4264361,18.646189 L25.2610138,14.54832 L21.4339538,20.2701053 Z M26.5461611,19.4871795 C26.5461611,19.1121711 26.8580093,18.8083221 27.242802,18.8083221 L28.4210526,18.8083221 C28.0855969,14.8027192 24.807786,11.6082991 20.6967293,11.2820513 L20.6967293,12.4301645 C20.6967293,12.8051728 20.3848811,13.1089357 20,13.1089357 C19.6151189,13.1089357 19.3033591,12.8051728 19.3033591,12.4301645 L19.3033591,11.2820513 C15.192214,11.6089883 11.9137842,14.8027192 11.5789474,18.8083221 L12.757198,18.8083221 C13.1420791,18.8083221 13.4538389,19.1121711 13.4538389,19.4871795 C13.4538389,19.8621879 13.1420791,20.1660368 12.757198,20.1660368 L11.5789474,20.1660368 C11.9144031,24.1716398 15.192214,27.3660599 19.3033591,27.6923077 L19.3033591,26.5441945 C19.3033591,26.1691861 19.6151189,25.8654233 20,25.8654233 C20.3848811,25.8654233 20.6967293,26.1691861 20.6967293,26.5441945 L20.6967293,27.6923077 C24.807786,27.3653707 28.0863043,24.1716398 28.4210526,20.1660368 L27.242802,20.1660368 C26.8580093,20.1660368 26.5461611,19.8621879 26.5461611,19.4871795 L26.5461611,19.4871795 Z' />
  </SvgIcon>
);

export const Payment = (props) => (
  <SvgIcon viewBox='0 0 52 36' {...props}>
    <path d='M4.62979588,35.9332327 L47.3259505,35.9332327 C49.8828629,35.9332327 51.9557598,33.8632996 51.9557598,31.3099762 L51.9557598,14.8288684 L-1.34020621e-05,14.8288684 L-1.34020621e-05,31.3232922 C-0.00363195876,33.8766825 2.06624948,35.9494929 4.62322887,35.9532401 L4.62979588,35.9532401 L4.62979588,35.9332327 Z M51.9290897,4.62320297 C51.9290897,2.06987955 49.8561928,1.33828996e-05 47.2992804,1.33828996e-05 L4.60319278,1.33828996e-05 C2.05673402,0.014533829 -1.3402062e-05,2.08011747 -1.3402062e-05,4.62320297 L-1.3402062e-05,8.89997621 L51.9290897,8.89997621 L51.9290897,4.62320297 Z' />
  </SvgIcon>
);
export const Discounts = (props) => (
  <SvgIcon viewBox='0 0 40 40' {...props}>
    <path d='M24.253123,30.3719592 C21.7547661,30.3719592 19.7438085,28.3609936 19.7438085,25.8626268 C19.7438085,23.3640111 21.7547661,21.3531699 24.253123,21.3531699 C26.7516043,21.3531699 28.7624374,23.3640111 28.7624374,25.8626268 C28.7624374,28.3609936 26.7516043,30.3719592 24.253123,30.3719592 L24.253123,30.3719592 Z M12.5531759,29.1532073 L10.846905,27.4469296 L26.4469175,11.8469794 L28.1531883,13.5531326 L12.5531759,29.1532073 Z M10.237656,15.1375599 C10.237656,12.6390686 12.2486135,10.628103 14.7468459,10.628103 C17.2453272,10.628103 19.2562848,12.6390686 19.2562848,15.1375599 C19.2562848,17.6360512 17.2453272,19.6468923 14.7468459,19.6468923 C12.2486135,19.7078797 10.237656,17.6360512 10.237656,15.1375599 L10.237656,15.1375599 Z M36.2577568,15.9906365 L36.5015809,11.4203167 C36.5015809,10.932791 36.2577568,10.5063772 35.8312202,10.2625521 L31.7484424,8.19059913 L29.6766222,4.10780501 C29.4327981,3.68126672 29.0062615,3.37657874 28.5187377,3.43756612 L23.9485607,3.68126672 L20.1094824,1.18277545 C19.6828214,0.939074849 19.1954221,0.939074849 18.7688855,1.18277545 L14.9298073,3.68126672 L10.4203685,3.43756612 C9.93284473,3.37657874 9.50630815,3.68126672 9.26260852,4.10780501 L7.1906638,8.19059913 L3.10788596,10.2625521 C2.68147384,10.5063772 2.43764975,10.932791 2.43764975,11.4203167 L2.68147384,15.9907609 L0.182868071,19.82973 C-0.0609560237,20.2563927 -0.0609560237,20.743794 0.182868071,21.1703322 L2.68147384,25.0094258 L2.43764975,29.5797456 C2.43764975,30.0672712 2.68147384,30.4938095 3.10788596,30.7376346 L7.1906638,32.8094631 L9.26260852,36.8922572 C9.50630815,37.3187955 9.93284473,37.623608 10.4203685,37.5624961 L14.99067,37.3187955 L18.8297482,39.8172868 C19.0125852,39.9391371 19.2562848,40 19.5001089,40 C19.7438085,40 19.9876326,39.9391371 20.1703451,39.8172868 L24.0094233,37.3187955 L28.5797249,37.5624961 C29.0672486,37.623608 29.4936607,37.3187955 29.7374848,36.8922572 L31.8094296,32.8094631 L35.8922074,30.7376346 C36.318744,30.4938095 36.5624436,30.0672712 36.5624436,29.5797456 L36.318744,25.0094258 L38.8172253,21.1703322 C39.0609249,20.743794 39.0609249,20.2563927 38.8172253,19.82973 L36.2577568,15.9906365 Z' />
  </SvgIcon>
);
export const LegalDocument = (props) => (
  <SvgIcon viewBox='0 0 39 37' {...props}>
    <path d='M16.7196784,30.2242394 C16.7632866,31.6942003 17.4996784,36.2334907 24.3433537,36.3629468 L16.7196784,36.3629468 L12.648059,36.3629468 L6.02082388,36.3629468 C2.68554776,36.3629468 -1.94029851e-05,33.6825666 -1.94029851e-05,30.3536955 L-1.94029851e-05,29.792009 L16.7196784,29.792009 L16.7196784,30.2242394 Z M35.3886582,3.07516574 C37.3813448,3.07516574 38.9840313,4.71786388 38.9840313,6.66323947 L38.9840313,9.99211053 L31.8802104,9.99211053 L31.8802104,6.57672562 C31.8802104,4.63135002 33.4398224,3.07516574 35.3886582,3.07516574 Z M35.4320821,1.04323272 C30.4506082,1.56226743 30.2343619,6.53378822 30.1908507,6.53378822 L30.1908507,29.7487908 L30.1908507,29.7920236 C28.934847,34.8933393 24.2566903,34.7633023 24.2566903,34.7633023 C19.1887761,34.6773694 18.2793097,31.8236709 18.1924813,30.1377401 L18.1924813,29.7487908 L18.1924813,28.2358393 L16.6764776,28.2358393 L8.0131903,28.2358393 L8.0131903,7.18198855 C8.0131903,3.76689411 10.7854888,1 14.2075448,1 L29.4979216,1 L30.2343619,1 L35.4320821,1 L35.4320821,1.04323272 Z M13.2110075,18.1198184 L24.8196194,18.1198184 L24.8196194,16.6063343 L13.2110075,16.6063343 L13.2110075,18.1198184 Z M13.2110075,23.7394911 L24.8196194,23.7394911 L24.8196194,22.226588 L13.2110075,22.226588 L13.2110075,23.7394911 Z M13.2110075,12.1534609 L24.8196194,12.1534609 L24.8196194,7.74391709 L13.2110075,7.74391709 L13.2110075,12.1534609 Z' />
  </SvgIcon>
);

export const Zapier = (props) => (
  <SvgIcon
    viewBox='0 0 18 18'
    style={{ height: '18px', width: '18px' }}
    {...props}
  >
    <path
      d='M11,9.51710624 C11,10.3326978 10.3326978,11 9.51710624,11 L8.48289376,11 C7.66730219,11 7,10.3326978 7,9.51710624 L7,8.48289376 C7,7.66730219 7.66730219,7 8.48289376,7 L9.51710624,7 C10.3326978,7 11,7.66730219 11,8.48289376 L11,9.51710624 Z M18,9.00021607 C18,8.45874247 17.9438216,7.9310974 17.8522075,7.41598444 L12.8562168,7.41598444 L16.3950256,3.87760786 C15.7796557,2.99042086 15.0095791,2.22034427 14.1228243,1.60497443 L10.6025977,5.12520107 L10.6025977,0.150817468 C10.0814347,0.05704271 9.54773966,0 9.00021607,0 C8.44923535,0 7.91251531,0.0574748518 7.38875951,0.152113893 L7.38875951,5.12520107 L3.87242215,1.60886371 C2.98609944,2.22509783 2.21602286,2.99517442 1.60108516,3.88236141 L5.13470818,7.41598444 L0.147792476,7.41598444 C0.0561784265,7.9310974 0,8.45874247 0,9.00021607 C0,9.55724678 0.0579069935,10.1004489 0.155138886,10.6298226 L5.09797614,10.6298226 L1.60497443,14.1228243 C2.22034427,15.0095791 2.99042086,15.7796557 3.87760786,16.3950256 L7.38875951,12.8838739 L7.38875951,17.8478861 C7.91251531,17.9429573 8.44923535,18 9.00021607,18 C9.54773966,18 10.0814347,17.9429573 10.6025977,17.8491825 L10.6025977,12.8834418 L14.1176386,16.3989148 C15.0048256,15.7839771 15.7753343,15.0139006 16.3911363,14.1275778 L12.893381,10.6298226 L17.8452933,10.6298226 C17.942093,10.1004489 18,9.55724678 18,9.00021607 L18,9.00021607 Z'
      id='path-1'
    ></path>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='SubNav/Settings/Zapier'
        transform='translate(-181.000000, -412.000000)'
      >
        <g id='Color/Blue' transform='translate(181.000000, 412.000000)'>
          <mask id='mask-2' fill='white'>
            <use></use>
          </mask>
          <use id='Mask' fill='#278ADA'></use>
          <g id='Group' mask='url(#mask-2)' fill='#000000'>
            <g id='Color/Blue'>
              <rect id='Rectangle-11' x='0' y='0' width='18' height='18'></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Attachment = (props) => (
  <SvgIcon viewBox='0 0 17 18' {...props}>
    <path d='M5.61415185 18c-1.4996274 0-2.90944698-.5868829-3.96978113-1.6525236C.58396042 15.2817591 0 13.864884 0 12.3577515c0-1.5070559.58396042-2.9239693 1.64437072-3.98964828L8.7816013 1.19511537C9.54845145.42442742 10.5680123 0 11.6524831 0c1.0845088 0 2.1040315.42442742 2.8708817 1.19511537.7668121.7706497 1.1891641 1.79531305 1.1891641 2.88521112 0 1.0899363-.422352 2.1145997-1.1891641 2.8852493l-7.14541568 7.1733705c-.97673177.9815434-2.5664716.9815434-3.54350792-.0003826-.97699826-.9819642-.97699826-2.5796601 0-3.5615861l6.5940435-6.61923884c.3719088-.37331094.9745617-.3729666 1.3459756.00080348.371452.37377008.3711094.9794008-.0007995 1.35271174l-6.59362464 6.618818c-.23447502.2356484-.23447502.6197489.0003807.8558183.11379214.1142851.26504547.1772624.42596865.1772624.1608852 0 .3121766-.0629773.4259306-.1773007l7.1454157-7.17337048c.4069335-.40897004.6312818-.95323038.6312818-1.53215504 0-.5788864-.2243483-1.1231468-.6316625-1.5324994-.4073142-.4093527-.9488643-.6347855-1.524868-.6347855-.5760418 0-1.1175539.2254328-1.5248681.63478543L2.9903464 9.7208149c-.70083622.70434364-1.0868311 1.64085404-1.0868311 2.63693654 0 .9961208.38599488 1.9326312 1.0868311 2.6369749.7008363.7043436 1.6326451 1.092232 2.6238055 1.092232s1.9229692-.3878884 2.6238055-1.092232L15.375226 7.8217385c.3717184-.3735405.9742952-.3735405 1.3460137 0 .3716804.3735405.3716804.97917123 0 1.35271174L9.583933 16.3474764C8.52359882 17.4131171 7.11377926 18 5.61415184 18' />
  </SvgIcon>
);
export const StatusCircle = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <path
      fill='currentColor'
      d='M10,0 C6.755,0 3.878,1.547 2.045,3.938 L17.955,3.938 C16.122,1.547 13.245,0 10,0'
    />
    <path
      fill='currentColor'
      d='M18.8408,5.2915 L1.1588,5.2915 C0.5118,6.4975 0.1118,7.8535 0.0058,9.2915 L19.9938,9.2915 C19.8888,7.8535 19.4878,6.4975 18.8408,5.2915'
    />
    <path d='M0,10.646 C0.087,12.082 0.471,13.436 1.1,14.646 L18.9,14.646 C19.529,13.436 19.913,12.082 20,10.646 L0,10.646 Z' />
    <path d='M8.9043,20 C9.2643,20.039 9.6293,20.062 10.0003,20.062 C10.3713,20.062 10.7353,20.039 11.0953,20 C13.9433,19.69 16.4253,18.185 18.0493,16 L1.9513,16 C3.5743,18.185 6.0563,19.69 8.9043,20' />
  </SvgIcon>
);
export const Inbox = (props) => (
  <SvgIcon viewBox='0 0 23 15' {...props}>
    <path d='M4.72697 2.2299068C4.80793 2.1021692 4.94285 2 5.10472 2h12.79056c.16187 0 .29684.0766008.37775.2299068L20 5.5255162h-4.10159c-.51268 0-.94439.3321282-1.05236.8175624C14.79209 6.6240701 14.17144 9 11.50003 9 8.82856 9 8.23492 6.6240701 8.15395 6.3430786c-.10791-.4854342-.53968-.8175624-1.05236-.8175624H3l1.72697-3.2956094zM2.7381 15h17.52385C21.76785 15 23 13.7682491 23 12.2627758V7.0346551c0-.1915945-.05475-.3558503-.13691-.4926556L20.3167 1.45074C19.87859.5748395 18.97506 0 17.96197 0H5.01068C4.025 0 3.12141.5474448 2.65595 1.45074L.13691 6.5146049C.05475 6.6788048 0 6.8430606 0 7.0346551v5.2281207C0 13.7956437 1.23215 15 2.7381 15z' />
  </SvgIcon>
);

// Reports
export const Export = (props) => (
  <SvgIcon viewBox='0 0 17 17' {...props}>
    <path d='M9.94937095,0.124381035 C13.9460758,0.815024277 16.9860895,4.29904712 16.9860895,8.49308318 C16.9860895,13.1836691 13.183623,16.9861356 8.49303707,16.9861356 C3.80245118,16.9861356 -1.53707053e-05,13.1836691 -1.53707053e-05,8.49308318 C-1.53707053e-05,4.20996302 3.17051365,0.667338711 7.29265607,0.0841726732 L7.21896212,9.08178347 L4.5619158,6.42473714 L2.68639829,8.30025466 L8.54750045,14.1613568 L14.5649084,8.14394889 L12.6893302,6.26837073 L9.87597812,9.08172281 L9.94937095,0.124381035 Z' />
  </SvgIcon>
);
export const PriceTag = (props) => (
  <SvgIcon viewBox='0 0 32 44' {...props}>
    <path d='M14.6299283,20.776057 L14.6299283,19.9186654 C14.6299283,19.18642 15.2235959,18.5928967 15.9558414,18.5928967 C16.6880869,18.5928967 17.2816823,19.18642 17.2816823,19.9186654 L17.2816823,20.5860631 C17.9201946,20.6206534 18.5538685,20.7182861 19.173172,20.8777337 C19.9836248,21.1063618 20.4551793,21.9488052 20.226479,22.7592579 C20.0432009,23.4087466 19.4547327,23.8605146 18.779897,23.8696858 C18.6302705,23.8714911 18.4812217,23.8506936 18.33795,23.8077987 C17.722185,23.6271926 17.0836727,23.5364202 16.4419831,23.5382255 C15.3547358,23.5382255 14.7272722,23.9183577 14.7272722,24.5768731 C14.7272722,25.151332 15.3724281,25.5844689 17.2816823,26.3048713 C20.0173485,27.2726774 21.1884357,28.5897083 21.1884357,30.724341 C21.1884357,32.8589016 19.623929,34.5780897 17.1844107,35.0686364 L17.1844107,36.0763044 C17.1844107,36.8085498 16.5908152,37.4020731 15.8585697,37.4020731 C15.1263965,37.4020731 14.5327288,36.8085498 14.5327288,36.0763044 L14.5327288,35.2454152 C13.67086,35.1901718 12.8189567,35.0299299 11.9959388,34.7681558 C11.2330748,34.5185135 10.7930776,33.7214925 10.988343,32.9428137 L11.0148454,32.8368042 C11.1876525,32.1779277 11.7832699,31.7185051 12.4644604,31.7186495 C12.6358953,31.7187217 12.8061027,31.7471016 12.9682221,31.8026339 C13.7272588,32.0668633 14.5245687,32.2042134 15.3282334,32.2091962 C16.5435876,32.2091962 17.268395,31.7673214 17.268395,31.0336317 C17.268395,30.3000142 16.6408592,29.8271598 15.0321578,29.2658438 C13.0743038,28.6073284 10.8292566,27.5202255 10.8292566,24.9391685 C10.8292566,22.8885924 12.2787993,21.2975833 14.6299283,20.776057 M16.0000361,7.66785212 C17.6670861,7.66785212 19.0184906,9.01932884 19.0184906,10.686451 C19.0184906,12.3534288 17.6670861,13.7049055 16.0000361,13.7049055 C14.3329139,13.7049055 12.9815094,12.3534288 12.9815094,10.686451 C12.9815094,9.01932884 14.3329139,7.66785212 16.0000361,7.66785212 M4.26193906,43.3153524 L27.7381332,43.3153524 C29.9836137,43.3153524 31.8040453,41.494993 31.8040453,39.2494403 L31.8040453,13.4354045 C31.8040453,12.1987473 31.241285,11.0292488 30.274851,10.2577191 L18.5368262,0.888443392 C17.0530542,-0.296147797 14.947018,-0.296147797 13.4632461,0.888443392 L1.72514902,10.2577191 C0.758714982,11.0292488 0.195954733,12.1987473 0.195954733,13.4354045 L0.195954733,39.2494403 C0.195954733,41.494993 2.01638629,43.3153524 4.26193906,43.3153524' />
  </SvgIcon>
);
export const Profit = (props) => (
  <SvgIcon viewBox='0 0 40 36' {...props}>
    <polygon points='21.5023494 5.53403755 27.0308591 11.0624839 18.253116 19.8401638 13.6921018 15.2792763 0 28.9713147 4.92756273 33.8989408 13.6921651 25.1343384 18.253116 29.6953526 31.9583585 15.99011 37.4659624 21.4977139 40 3' />
  </SvgIcon>
);
export const Revenue = (props) => (
  <SvgIcon viewBox='0 0 38 44' {...props}>
    <path d='M20.2885011,34.9860171 L20.2885011,36.1012996 C20.2885011,36.9117457 19.619636,37.5686546 18.7945396,37.5686546 C17.9695246,37.5686546 17.3005782,36.9117457 17.3005782,36.1012996 L17.3005782,35.1816751 C16.3294218,35.1206119 15.3694946,34.943177 14.4421156,34.6534465 C13.5825182,34.3771435 13.0867281,33.4950041 13.3067537,32.6332457 L13.3366167,32.5158349 C13.5313362,31.7865933 14.2024797,31.2781063 14.9700471,31.2782662 C15.1632206,31.2783461 15.3550107,31.3097569 15.5376874,31.3712197 C16.3929722,31.6636677 17.2913833,31.8156862 18.196955,31.8212011 C19.5664197,31.8212011 20.3831349,31.3321361 20.3831349,30.5200914 C20.3831349,29.7081268 19.6760257,29.1847736 17.8633362,28.5635914 C15.6572206,27.8346695 13.1274946,26.6314688 13.1274946,23.7747662 C13.1274946,21.5051974 14.7608437,19.7442755 17.4101028,19.1670524 L17.4101028,18.2180952 C17.4101028,17.4076491 18.0790493,16.7507401 18.9041456,16.7507401 C19.729242,16.7507401 20.3981071,17.4076491 20.3981071,18.2180952 L20.3981071,18.956768 C21.1175846,18.9950524 21.8316103,19.1031119 22.5294433,19.2795877 C23.4426638,19.5326323 23.9740128,20.465045 23.7163126,21.3620506 C23.5097944,22.0809019 22.8466253,22.5809167 22.0862998,22.5910673 C21.9176188,22.5930654 21.7497516,22.5700468 21.5883126,22.5226509 C20.8944668,22.3227569 20.1749079,22.2222104 19.4519315,22.2242086 C18.226818,22.2242086 17.5197901,22.6449372 17.5197901,23.3737792 C17.5197901,24.0095877 18.2467537,24.4889818 20.3981071,25.2863201 C23.4805824,26.3574836 24.8002484,27.8151677 24.8002484,30.1777699 C24.8002484,32.5402922 23.0373576,34.4430822 20.2885011,34.9860171 M32.6274347,16.7614502 C29.8071349,12.7968981 26.4033276,10.2175375 22.9026081,9.1673145 C23.9721413,8.68959888 24.9933405,8.16408773 25.7227452,7.39999851 L25.7713233,7.35204312 L28.5428009,4.24749108 C29.1264711,3.72229963 29.320621,2.95797063 29.0779743,2.2415171 C28.7860985,1.47750781 28.0566938,0.999952045 27.2300514,0.999952045 L27.0842355,0.999952045 L18.3802827,2.14624572 C17.3105054,2.28947249 16.1432463,2.2415171 15.0738758,2.00269926 L10.8924111,1.04742788 C10.7461071,0.999952045 10.6002912,0.999952045 10.4541499,0.999952045 C9.7252334,1.04742788 9.19014133,1.33420112 8.89850964,1.81191673 C8.50915203,2.57600595 8.849606,3.43552639 9.14156317,4.00875316 C9.19014133,4.00875316 9.19014133,4.05670855 9.23904497,4.10426431 L9.7252334,4.77300223 C11.0381456,6.58803383 12.7396831,8.0683368 14.6845996,9.21487026 C11.2808737,10.3133684 8.0229636,12.8924093 5.30022698,16.7134948 C2.04231692,21.2987494 0,27.1731249 0,32.044913 L0,32.5224688 C0,40.0690487 9.04432548,43.9856454 17.9914133,43.9856454 L19.9364111,43.9856454 C28.8834176,43.9856454 37.927743,40.0690487 37.927743,32.5224688 L37.927743,32.044913 C37.927743,27.1731249 35.8853448,21.2987494 32.6274347,16.7614502' />
  </SvgIcon>
);
export const ExcelCircle = (props) => (
  <SvgIcon
    viewBox='0 0 25 25'
    style={{ height: '25px', width: '26px' }}
    {...props}
  >
    <path d='M24.979566 12.489783c0 6.8979204-5.5918626 12.489783-12.489783 12.489783C5.59186257 24.979566 0 19.3877034 0 12.489783 0 5.59186257 5.59186257 0 12.489783 0c6.8979204 0 12.489783 5.59186257 12.489783 12.489783' />
    <path
      fill='#FFFFFF'
      d='M17.1747933 3.69418202L7.15720673 5.2405644v13.5521905l10.01758657 1.725107V3.69418202zM12.8340332 8.7350611l1.2909595-.07378638-1.5676447 3.16814448 1.5676447 3.176056-1.3647459-.0922468-.9220825-2.4209955-.9221375 2.3287488-1.2540938-.1106521 1.4568827-2.8053659-1.34623058-3.00392444 1.29095948-.07378638.8114305 2.23150242.9590581-2.3236942z'
    />
  </SvgIcon>
);
export const QuickbooksCircle = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <path d='M9.992 0c5.518 0 9.992 4.473 9.992 9.992 0 5.518-4.474 9.992-9.992 9.992C4.473 19.984 0 15.51 0 9.992 0 4.473 4.473 0 9.992 0zM9.83 6.076H7.067a3.868 3.868 0 0 0 0 7.734h.552v-1.436h-.552c-1.34 0-2.43-1.09-2.43-2.43s1.09-2.431 2.43-2.431h1.328v7.512c0 .794.642 1.437 1.435 1.437V6.076zm1.104-2.65V13.81h2.764a3.867 3.867 0 1 0 0-7.735h-.553v1.437h.553c1.34 0 2.43 1.09 2.43 2.431 0 1.34-1.09 2.43-2.43 2.43h-1.327V4.863c0-.793-.644-1.437-1.437-1.437z' />
  </SvgIcon>
);
export const WordPress = (props) => (
  <SvgIcon
    viewBox='0 0 15 15'
    style={{ height: '15px', width: '15px' }}
    {...props}
  >
    <path d='M7.63117855,8.15599525 L5.37898683,14.6993433 C6.05143279,14.8971959 6.76371575,15 7.49998292,15 C8.37356135,15 9.21287175,14.8534299 9.99269997,14.579149 C9.97295229,14.5469651 9.95299962,14.5123212 9.93810345,14.4752516 L7.63117855,8.15599525 Z M0.644942704,4.44418377 C0.228772387,5.37724439 0,6.41232328 0,7.50001708 C0,10.4697533 1.72269434,13.0352429 4.22549022,14.2511599 L0.644942704,4.44418377 Z M14.0816306,3.8975353 C14.1138145,4.13652318 14.1361929,4.39747949 14.1361929,4.67387863 C14.1361929,5.43498414 13.9903403,6.28758493 13.5622803,7.35799098 L11.2717891,13.9831997 C13.5021148,12.6827571 15,10.2678691 15,7.50001708 C15,6.19557716 14.6672619,4.9661989 14.0816306,3.8975353 Z M7.49998292,0 C4.87870098,0 2.57140026,1.34150952 1.22989074,3.37818508 C1.40604821,3.38378823 1.5757484,3.38904972 1.71633955,3.38904972 C2.50091678,3.38904972 3.71157232,3.29072133 3.71157232,3.29072133 C4.11581887,3.26711294 4.16481224,3.86063653 3.76073652,3.90839994 C3.76073652,3.90839994 3.35454253,3.96121985 2.90253258,3.98499905 L5.63577495,12.1082979 L7.27572038,7.1830293 L6.10582431,3.98520405 C5.7015436,3.96142484 5.31865051,3.90857076 5.31865051,3.90857076 C4.91423313,3.88458656 4.96336316,3.26711294 5.36778054,3.29092632 C5.36778054,3.29092632 6.60402607,3.38922055 7.34118154,3.38922055 C8.1255196,3.38922055 9.34198329,3.29092632 9.34198329,3.29092632 C9.74640066,3.26728377 9.79573569,3.86080735 9.39114748,3.90857076 C9.39114748,3.90857076 8.98457768,3.96142484 8.53294354,3.98520405 L11.2444908,12.0481324 L11.9933651,9.54458488 C12.3173226,8.50619193 12.566936,7.76486827 12.566936,7.1228638 C12.566936,6.1952355 12.2349153,5.55080528 11.949599,5.05103191 C11.5693367,4.43266999 11.2112477,3.90908325 11.2112477,3.29092632 C11.2112477,2.60132927 11.7319988,1.96250219 12.4686417,1.96250219 C12.501714,1.96250219 12.534752,1.96619207 12.566936,1.96793451 C11.2326012,0.744842713 9.45322625,0 7.49998292,0 Z' />
  </SvgIcon>
);
export const PickUp = (props) => (
  <SvgIcon
    viewBox='0 0 220 234'
    style={{ height: '17px', width: '17px' }}
    {...props}
  >
    <path d='M80.2844286 175.183527c-11.3920397-11.421968-11.3939018-29.94206 0-41.365895l65.2109554-65.3822734C144.273877 64.7089369 140.816045 62 136.689735 62H11.3102646C6.16727442 62 2 66.1800894 2 71.3347239V197.665276C2 202.819911 6.16727442 207 11.3102646 207H136.689735C141.832726 207 146 202.819911 146 197.665276v-47.005935l-24.459927 24.524186c-11.393902 11.423835-29.8636047 11.421968-41.2556444 0M188.500924 55C203.13615 55 215 43.1361496 215 28.5009244 215 13.8638504 203.13615 2 188.500924 2 173.86385 2 162 13.8638504 162 28.5009244 162 43.1361496 173.86385 55 188.500924 55' />
    <path d='M188.768792 62c-8.666558 0-16.428211 3.7840649-21.78114 9.7607656L91.6417735 146.924617c-4.8566308 4.846879-4.8547651 12.705374 0 17.550392 4.8584965 4.845018 12.7358285 4.846879 17.5943255 0l50.301485-50.181205v88.546747c0 16.104146 13.088461 29.159449 29.231208 29.159449S218 218.944697 218 202.840551V91.1613108C218 75.0553031 204.911539 62 188.768792 62' />
  </SvgIcon>
);
export const TruckDropOff = (props) => {
  return (
    <SvgIcon
      viewBox='0 0 27 20'
      style={{ height: '20px', width: '27px' }}
      {...props}
    >
      <path
        fill={props.color ?? null}
        d='M.094.758v9.622c0 .419.346.758.773.758h12.955a.765.765 0 0 0 .761-.758V.758A.765.765 0 0 0 13.811 0H.867a.765.765 0 0 0-.773.758m20.502 13.98c-.98.016-1.77.792-1.787 1.753.003.967.802 1.75 1.787 1.753.98-.016 1.771-.791 1.788-1.753-.003-.967-.802-1.75-1.788-1.753m-9.463-.002c-.98.015-1.771.791-1.787 1.753 0 .968.8 1.753 1.787 1.753.987 0 1.787-.785 1.787-1.753 0-.969-.8-1.753-1.787-1.753m14.536 2.737h-1.65c-.442 1.494-1.836 2.523-3.423 2.527-1.594.012-3-1.023-3.434-2.527h-2.579c-.444 1.499-1.845 2.529-3.436 2.527-1.596.013-3.003-1.022-3.437-2.527H1.323A1.307 1.307 0 0 1 0 16.18v-2.489a1.321 1.321 0 0 1 1.004-1.265v-.024h13.854c.562 0 1.018-.447 1.018-.998V2.967a.76.76 0 0 1 .764-.756h.486c.749.005 1.451.356 1.895.947.036.035.071.105.107.14l2.75 4.07 1.938.27c1.15.155 2.007 1.12 2.004 2.26v3.338A1.334 1.334 0 0 1 27 14.533v1.643a1.307 1.307 0 0 1-1.317 1.297h-.014'
      />
    </SvgIcon>
  );
};

export const TruckPickUp = (props) => (
  <SvgIcon
    viewBox='0 0 27 20'
    style={{ height: '20px', width: '27px', fill: props.fill }}
    {...props}
  >
    <path d='M26.906.758v9.622a.765.765 0 0 1-.773.758H13.178a.765.765 0 0 1-.761-.758V.758c0-.419.346-.758.772-.758h12.944c.427 0 .773.34.773.758M6.404 14.738c.98.016 1.77.792 1.787 1.753-.003.967-.802 1.75-1.787 1.753-.98-.016-1.771-.791-1.788-1.753.003-.967.802-1.75 1.788-1.753m9.463-.002c.98.015 1.771.791 1.787 1.753 0 .968-.8 1.753-1.787 1.753-.987 0-1.787-.785-1.787-1.753 0-.969.8-1.753 1.787-1.753M1.331 17.473h1.65c.442 1.494 1.836 2.523 3.423 2.527 1.594.012 3-1.023 3.434-2.527h2.579c.444 1.499 1.845 2.529 3.436 2.527 1.596.013 3.003-1.022 3.437-2.527h6.387A1.307 1.307 0 0 0 27 16.18v-2.489a1.321 1.321 0 0 0-1.004-1.265v-.024H12.142a1.008 1.008 0 0 1-1.018-.998V2.967a.76.76 0 0 0-.764-.756h-.486a2.385 2.385 0 0 0-1.895.947c-.036.035-.071.105-.107.14l-2.75 4.07-1.938.27c-1.15.155-2.007 1.12-2.004 2.26v3.338A1.334 1.334 0 0 0 0 14.533v1.643a1.307 1.307 0 0 0 1.317 1.297h.014' />
  </SvgIcon>
);
export const TruckPickUpIcon = (props) => (
  <SvgIcon
    viewBox='0 0 20 15.5'
    style={{ height: '15.5px', width: '20px' }}
    {...props}
  >
    <path d='M26.906.758v9.622a.765.765 0 0 1-.773.758H13.178a.765.765 0 0 1-.761-.758V.758c0-.419.346-.758.772-.758h12.944c.427 0 .773.34.773.758M6.404 14.738c.98.016 1.77.792 1.787 1.753-.003.967-.802 1.75-1.787 1.753-.98-.016-1.771-.791-1.788-1.753.003-.967.802-1.75 1.788-1.753m9.463-.002c.98.015 1.771.791 1.787 1.753 0 .968-.8 1.753-1.787 1.753-.987 0-1.787-.785-1.787-1.753 0-.969.8-1.753 1.787-1.753M1.331 17.473h1.65c.442 1.494 1.836 2.523 3.423 2.527 1.594.012 3-1.023 3.434-2.527h2.579c.444 1.499 1.845 2.529 3.436 2.527 1.596.013 3.003-1.022 3.437-2.527h6.387A1.307 1.307 0 0 0 27 16.18v-2.489a1.321 1.321 0 0 0-1.004-1.265v-.024H12.142a1.008 1.008 0 0 1-1.018-.998V2.967a.76.76 0 0 0-.764-.756h-.486a2.385 2.385 0 0 0-1.895.947c-.036.035-.071.105-.107.14l-2.75 4.07-1.938.27c-1.15.155-2.007 1.12-2.004 2.26v3.338A1.334 1.334 0 0 0 0 14.533v1.643a1.307 1.307 0 0 0 1.317 1.297h.014' />
  </SvgIcon>
);

export const MessageBubble = (props) => (
  <SvgIcon viewBox='0 0 22 22' {...props}>
    <path d='M22 3.994a3.431 3.431 0 0 0-3.43-3.43H3.43A3.431 3.431 0 0 0 0 3.993v10.121a3.431 3.431 0 0 0 3.43 3.43h13.312L22 21.364v-7.22h-.001l.001-.028V3.995z' />
  </SvgIcon>
);

export const ArrowUpMarker = (props) => {
  return (
    <SvgIcon viewBox='0 0 18 25' width='18px' height='25px' {...props}>
      <defs>
        <mask
          id='mask'
          x='0'
          y='0'
          width='18'
          height='25'
          maskUnits='userSpaceOnUse'
        >
          <g id='mask-2'>
            <path
              id='path-1'
              fill='#fff'
              fillRule='evenodd'
              d='M2,0H16a2,2,0,0,1,2,2V16.89a2,2,0,0,1-.76,1.57L9,25H9L.76,18.46A2,2,0,0,1,0,16.89V2A2,2,0,0,1,2,0Z'
            />
          </g>
        </mask>
      </defs>
      <g id='Layer_2' data-name='Layer 2'>
        <g id='Layer_1-2' data-name='Layer 1'>
          <g id='Color_Blue' data-name='Color/Blue'>
            <g id='Mask-2-2' data-name='Mask'>
              <path
                id='path-1-2'
                data-name='path-1'
                fill={props.color || '#278ada'}
                fillRule='evenodd'
                d='M2,0H16a2,2,0,0,1,2,2V16.89a2,2,0,0,1-.76,1.57L9,25H9L.76,18.46A2,2,0,0,1,0,16.89V2A2,2,0,0,1,2,0Z'
              />
            </g>
            <g style={{ mask: 'url(#mask)' }}>
              <g id='Group'>
                <g id='Color_Blue-2' data-name='Color/Blue'>
                  <rect
                    id='Rectangle-11'
                    className='cls-4'
                    fill={props.color || '#278ada'}
                    width='18'
                    height='25'
                  />
                </g>
              </g>
            </g>
          </g>
          <g id='mask-4'>
            <polygon
              id='path-3'
              fill='#fff'
              fillRule='evenodd'
              points='9 7 14 15 4 15 9 7'
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
export const ArrowDownMarker = (props) => {
  return (
    <SvgIcon viewBox='0 0 18 25' width='18px' height='25px' {...props}>
      <defs></defs>
      <g id='Layer_2' data-name='Layer 2'>
        <g id='Layer_1-2' data-name='Layer 1'>
          <g id='Mask'>
            <path
              id='path-1'
              fill={props.color || '#278ada'}
              fillRule='evenodd'
              d='M2,0H16a2,2,0,0,1,2,2V16.89a2,2,0,0,1-.76,1.57L9,25H9L.76,18.46A2,2,0,0,1,0,16.89V2A2,2,0,0,1,2,0Z'
            />
          </g>

          <g id='mask-4'>
            <polygon
              id='path-3'
              fillRule='evenodd'
              fill='#fff'
              points='9 14 14 6 4 6 9 14'
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
export const NumberedOrangeUpBlank = (props) => {
  return (
    <SvgIcon width='18px' height='25px' viewBox='0 0 25 35' {...props}>
      <defs></defs>
      <rect
        id='Rectangle'
        style={{ fill: 'none', stroke: '#ff886d', strokeWidth: '3px' }}
        x='1.5'
        y='1.5'
        width='22'
        height='32'
        rx='2'
      />

      <polygon
        fill='#ff886d'
        fillRule='evenodd'
        points='13 6 8 14 18 14 13 6'
      />
      <text
        className='cls-3'
        style={{
          fontSize: '12px',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        fill='#ff886d'
        textAnchor='middle'
        x='50%'
        y='80%'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};

export const NumberedOrangeDownBlank = (props) => {
  return (
    <SvgIcon viewBox='0 0 25 35' width='18px' height='25px' {...props}>
      <defs></defs>
      <rect
        id='Rectangle-Copy'
        style={{ fill: 'none', stroke: '#ff886d', strokeWidth: '3px' }}
        x='1.5'
        y='1.5'
        width='22'
        height='32'
        rx='2'
      />
      <g id='Mask'>
        <polygon
          id='path-1'
          fill='#ff886d'
          fillRule='evenodd'
          points='13 28 8 20 18 20 13 28'
        />
      </g>
      <text
        style={{
          fontSize: '12px',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        fill='#ff886d'
        textAnchor='middle'
        x='50%'
        y='14px'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};
export const BlankMarker = (props) => {
  return (
    <SvgIcon viewBox='0 0 18 35' width='18px' height='25px' {...props}>
      <defs>
        <mask
          id='mask'
          x='0'
          y='0'
          width='18'
          height='35'
          maskUnits='userSpaceOnUse'
        >
          <g id='mask-2'>
            <path
              id='path-1'
              className='cls-1'
              fill='#fff'
              d='M2,0H16a2,2,0,0,1,2,2V26.89a2,2,0,0,1-.76,1.57L9,35H9L.76,28.46A2,2,0,0,1,0,26.89V2A2,2,0,0,1,2,0Z'
            />
          </g>
        </mask>
      </defs>
      <g id='Mask-2-2' data-name='Mask'>
        <path
          data-name='path-1'
          fillRule='evenodd'
          fill='#0e2c44'
          d='M2,0H16a2,2,0,0,1,2,2V26.89a2,2,0,0,1-.76,1.57L9,35H9L.76,28.46A2,2,0,0,1,0,26.89V2A2,2,0,0,1,2,0Z'
        />
      </g>
      <g className='cls-3' mask='url(#mask)'>
        <g id='Color_Navy' data-name='Color/Navy'>
          <rect id='Rectangle-11' fill='#278ada' width='18' height='35' />
        </g>
      </g>
    </SvgIcon>
  );
};

export const NumberedStopIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 18 35'
      width='25px'
      height='33px'
      id='customStop'
    >
      <defs></defs>
      <g id='Layer_2' data-name='Layer 2'>
        <g id='Layer_1-2' data-name='Layer 1'>
          <g id='Symbols'>
            <g id='Med_Navy_Up_Export' data-name='Med Navy Up Export'>
              <g id='Mask'>
                <path
                  id='path-1'
                  style={{
                    fill: `${props.color ? `${props.color}` : '#0e2c44'}`,
                    fillRule: 'evenodd',
                  }}
                  d='M2,0H16a2,2,0,0,1,2,2V26.89a2,2,0,0,1-.76,1.57L9,35H9L.76,28.46A2,2,0,0,1,0,26.89V2A2,2,0,0,1,2,0Z'
                />
              </g>
            </g>
          </g>
          <text
            style={{
              fontSize: '12px',
              fill: '#fff',
              fontFamily: 'Heebo-Regular, Heebo',
            }}
            textAnchor='middle'
            x='50%'
            y='14px'
          >
            {props.number}
          </text>
        </g>
      </g>
    </svg>
  );
};
export const NumberedDownArrowPin = (props) => {
  return (
    <SvgIcon viewBox='0 0 18 35' width='25px' height='33px' {...props}>
      <defs></defs>
      <path
        id='Mask'
        fill={props.color || '#278ada'}
        d='M31.58,0h14a2,2,0,0,1,2,2V26.89a2,2,0,0,1-.76,1.57L38.58,35h0l-8.25-6.54a2,2,0,0,1-.75-1.57V2A2,2,0,0,1,31.58,0Z'
        transform='translate(-29.58)'
      />
      <polygon
        id='Mask-2'
        data-name='Mask'
        style={{ fillRule: 'evenodd', fill: '#fff' }}
        points='9 24 14 16 4 16 9 24'
      />
      <text
        style={{
          fontSize: '12px',
          fill: '#fff',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        textAnchor='middle'
        x='50%'
        y='14px'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};

export const NumberedUpArrowPin = (props) => {
  return (
    <SvgIcon width='25px' height='33px' viewBox='0 0 18 35' {...props}>
      <defs></defs>
      <path
        id='Mask'
        fill={props.color || '#278ada'}
        d='M31.58,0h14a2,2,0,0,1,2,2V26.89a2,2,0,0,1-.76,1.57L38.58,35h0l-8.25-6.54a2,2,0,0,1-.75-1.57V2A2,2,0,0,1,31.58,0Z'
        transform='translate(-29.58)'
      />
      <polygon
        id='Mask-2'
        data-name='Mask'
        style={{ fill: '#fff', fillRule: 'evenodd' }}
        points='9 16 4 24 14 24 9 16'
      />
      <text
        style={{
          fontSize: '12px',
          fill: '#fff',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        textAnchor='middle'
        x='50%'
        y='14px'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};

export const NumberedUpBlueRectangle = (props) => {
  return (
    <SvgIcon
      fill='#278ada'
      width='18px'
      height='25px'
      viewBox='0 0 25 35'
      {...props}
    >
      <defs></defs>
      <path
        fill={props.color || '#278ada'}
        d='M23,0H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V2A2,2,0,0,0,23,0ZM8,14l5-8,5,8Z'
      />
      <text
        style={{
          fontSize: '12px',
          fill: '#fff',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        textAnchor='middle'
        x='50%'
        y='80%'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};

export const NonNumberedDownBlueRectangle = (props) => {
  return (
    <SvgIcon
      fill='#278ada'
      viewBox='0 0 25 35'
      width='18px'
      height='25px'
      {...props}
    >
      <defs></defs>
      <path
        fill={props.color || '#278ada'}
        d='M23,0H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V2A2,2,0,0,0,23,0ZM13,28,8,20H18Z'
      />
    </SvgIcon>
  );
};
export const NonNumberedUpBlueRectangle = (props) => {
  return (
    <SvgIcon
      fill='#278ada'
      width='18px'
      height='25px'
      viewBox='0 0 25 35'
      {...props}
    >
      <defs></defs>
      <path
        fill={props.color || '#278ada'}
        d='M23,0H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V2A2,2,0,0,0,23,0ZM8,14l5-8,5,8Z'
      />
    </SvgIcon>
  );
};

export const NumberedDownBlueRectangle = (props) => {
  return (
    <SvgIcon
      fill='#278ada'
      viewBox='0 0 25 35'
      width='18px'
      height='25px'
      {...props}
    >
      <defs></defs>
      <path
        fill={props.color || '#278ada'}
        d='M23,0H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V2A2,2,0,0,0,23,0ZM13,28,8,20H18Z'
      />
      <text
        style={{
          fontSize: '12px',
          fill: '#fff',
          fontFamily: 'Heebo-Regular, Heebo',
        }}
        textAnchor='middle'
        x='50%'
        y='14px'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};
export const NumberedUpArrow = (props) => {
  return (
    <SvgIcon
      fill='#278ada'
      width='18px'
      height='25px'
      viewBox='0 0 25 35'
      {...props}
    >
      <defs></defs>
      <path d='M23,0H2A2,2,0,0,0,0,2V33a2,2,0,0,0,2,2H23a2,2,0,0,0,2-2V2A2,2,0,0,0,23,0ZM8,14l5-8,5,8Z' />
      <text
        style={{
          fontSize: '12px',
          fill: '#fff',
          fontFamily: 'Heebo-Regular, Heebo',
          transform: 'translate(8px, 12px)',
        }}
        textAnchor='middle'
      >
        {props.number}
      </text>
    </SvgIcon>
  );
};

export const ChangeRequest = (props) => (
  <SvgIcon
    viewBox='0 0 15 12'
    style={{ height: '12px', width: '15px' }}
    {...props}
  >
    <path d='M15 9.14574149l-1.1037385-1.11954477-.0003866.00041398-1.695551-1.71981059-.9578636.97158088 1.1763215 1.193189h-2.100568c-.2718157.00067543-.53235406-.10994343-.72262936-.30680011L7.54541002 5.99997821l2.05017442-2.16476988c.1902753-.19687847.45081366-.30751912.72262936-.30682189h2.100568l-1.1763215 1.19318899.9506032.9789671c.0024273-.00244029.0048761-.00488057.0072604-.00736443l2.3190688-2.36933959c.0109336-.01089412.0212014-.02218043.0312328-.03364104l.4457872-.45214941-.4445198-.45088569c-.0081412-.00934715-.0165186-.01854178-.0252398-.02754032-.0023628-.00246207-.0048331-.00492414-.0072604-.00736443L12.2003239 0l-.9578636.9715591 1.1763215 1.19318899h-2.100568c-.64016527.00174306-1.2523843.26612148-1.6973123.73295616L6.60432276 5.01135893 4.58774402 2.89770425c-.44488504-.46683468-1.05710407-.73123489-1.69726938-.73295616H0v1.36363835h2.90727248c.27179423-.00069723.53233262.10994342.72260792.30682189l2.0501959 2.16476988-2.0501959 2.16479167c-.1902753.19685668-.45081369.30747554-.72260792.30680011H0v1.36363834h2.90727248c.64014383-.00172127 1.25238435-.26612147 1.69726938-.73295615l2.01657874-2.1136329 2.01660022 2.1136329c.44488504.46683468 1.05712555.73123488 1.69726938.73295615h2.0837916l-1.1763215 1.19321077L12.2003239 12l1.9704169-2.01312378L15 9.14574149z' />
  </SvgIcon>
);

export const Circle = (props) => (
  <SvgIcon
    viewBox='0 0 10 10'
    style={{ height: '10px', width: '10px' }}
    {...props}
  >
    <circle cx='5' cy='5' r='5' />
  </SvgIcon>
);

export const Spinner = (props) => (
  <SvgIcon viewBox='0 0 38 38' {...props}>
    <g transform='translate(1 1)'>
      <circle cx='18' cy='18' r='18' />
      <path d='M36 18c0-9.94-8.06-18-18-18'>
        <animateTransform
          attributeName='transform'
          type='rotate'
          from='0 18 18'
          to='360 18 18'
          dur='1s'
          repeatCount='indefinite'
        />
      </path>
    </g>
  </SvgIcon>
);

export const TutorialArrow = (props) => (
  <SvgIcon viewBox='0 0 21 21' {...props}>
    <path d='M15.805 9.785a.47.47 0 0 1-.001.847l-8.12 3.933a.469.469 0 0 1-.546-.1.47.47 0 0 1-.07-.55c.008-.017.899-1.66.899-3.724 0-2.062-.891-3.706-.9-3.722a.472.472 0 0 1 .619-.65l8.119 3.966zM10.5 21C4.7 21 0 16.3 0 10.5 0 4.701 4.7 0 10.5 0 16.299 0 21 4.701 21 10.5 21 16.3 16.299 21 10.5 21zm0-2a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z' />
  </SvgIcon>
);

export const Layout = (props) => (
  <SvgIcon viewBox='0 0 14 14' {...props}>
    <path d='M13.3 0c.42 0 .7.28.7.7v2.66c0 .07-.07.14-.14.14H.14A.15.15 0 0 1 0 3.36V.7C0 .28.28 0 .7 0h12.6zm.56 4.9c.07 0 .14.07.14.14v8.26c0 .42-.28.7-.7.7H5.04a.15.15 0 0 1-.14-.14V5.04c0-.07.07-.14.14-.14h8.82zm-10.5 0c.07 0 .14.07.14.14v8.82c0 .07-.07.14-.14.14H.7c-.42 0-.7-.28-.7-.7V5.04c0-.07.07-.14.14-.14h3.22z' />
  </SvgIcon>
);
export const Styling = (props) => (
  <SvgIcon viewBox='0 0 13 18' {...props}>
    <path d='M6.424 3.247S9.905 6.69 10.9 9.148c.995 2.46.498 6.885-4.475 6.885V3.247zm5.967 11.31C15.375 9.149 6.424.298 6.424.298s-8.452 8.36-5.966 14.26C1 15.848 2.447 18 6.424 18c3.978 0 5.511-2.615 5.967-3.442z' />
  </SvgIcon>
);
export const Pages = (props) => (
  <SvgIcon viewBox='0 0 16 16' {...props}>
    <path d='M0 0h12.069v3.912H16V16H3.931v-3.912H0V0zm2.667 4.333h6.666V3H2.667v1.333zm0 2.334h6.666V5.333H2.667v1.334zm0 2.333h6.666V7.667H2.667V9zm2.444 3.088v2.738h9.73v-9.74h-2.772v7.002H5.11z' />
  </SvgIcon>
);
export const ThumbsUp = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M13.047 5.871c1.47.095 2.196.648 1.88 2.322-.3 1.564-.695 3.586-1.01 4.96-.3 1.311-1.122 1.422-2.528 1.422-2.164 0-5.229-.774-6.46-1.106a.744.744 0 0 1-.538-.71c.016-1.233.016-4.17.016-5.356a.72.72 0 0 1 .41-.663c2.196-1.01 3.334-4.644 3.744-5.67.427-1.075 2.401-.838 2.18.552-.11.774-.268 1.722-.379 3.065-.079.774.063 1.279.427 1.247.868-.079 1.532-.11 2.258-.063zm-9.777.954a.35.35 0 0 1 .347.348v6.04a.35.35 0 0 1-.347.347H.348A.35.35 0 0 1 0 13.212v-6.04a.35.35 0 0 1 .348-.347H3.27z' />
  </SvgIcon>
);
export const Footer = (props) => (
  <SvgIcon viewBox='0 0 15 15' {...props}>
    <path d='M0 15h15V0H0v15zM3.144 3.127h8.733v4.577H3.144V3.127zm0 7.704h8.733v1.042H3.144V10.83z' />
  </SvgIcon>
);
export const Links = (props) => (
  <SvgIcon viewBox='0 0 17 18' {...props}>
    <path d='M15.673 1.844a4.518 4.518 0 0 1 0 6.397l-2.805 2.8A4.541 4.541 0 0 1 5.67 9.987l.747-.746c.228-.228.527-.36.846-.378.129.302.316.58.555.818a2.59 2.59 0 0 0 1.844.762 2.59 2.59 0 0 0 1.843-.762l2.805-2.799a2.58 2.58 0 0 0 .763-1.839c0-.696-.27-1.348-.763-1.839a2.59 2.59 0 0 0-1.843-.762 2.59 2.59 0 0 0-1.844.762L9.19 4.634a5.865 5.865 0 0 0-2.458-.266l2.53-2.524a4.54 4.54 0 0 1 6.41 0zm-5.98 11.857c.192 0 .383-.01.57-.027l-2.524 2.52a4.54 4.54 0 0 1-6.41 0 4.516 4.516 0 0 1 0-6.398l2.804-2.8a4.54 4.54 0 0 1 7.199 1.056l-.746.745a1.29 1.29 0 0 1-.849.378 2.599 2.599 0 0 0-.556-.819 2.592 2.592 0 0 0-1.843-.76c-.696 0-1.35.27-1.843.76l-2.804 2.799a2.582 2.582 0 0 0-.764 1.84c0 .695.27 1.348.764 1.839a2.59 2.59 0 0 0 1.842.762c.697 0 1.351-.27 1.843-.762l1.443-1.44a5.824 5.824 0 0 0 1.873.307z' />
  </SvgIcon>
);
export const Swatches = (props) => (
  <SvgIcon viewBox='0 0 20 20' {...props}>
    <path d='M16.657 6.27c.65.613.65 1.7-.02 2.313l-7.59 7.607V5.737l2.386-2.39c.63-.653 1.696-.653 2.307 0l2.917 2.924zm1.707 6.111c.907 0 1.636.752 1.636 1.686v4.247c0 .934-.73 1.686-1.636 1.686H8.095l7.391-7.619h2.878zM0 0h7.61v20H0V0zm3.805 17.92c.91 0 1.68-.74 1.68-1.66 0-.92-.75-1.66-1.68-1.66-.931 0-1.68.74-1.68 1.66 0 .92.749 1.66 1.68 1.66z' />
  </SvgIcon>
);
export const Barcode = (props) => (
  <SvgIcon viewBox='0 0 25 15' {...props}>
    <path d='M0 0h4v15H0V0zm5 0h2v15H5V0zm3 0h2v15H8V0zm3 0h3v15h-3V0zm4 0h1v15h-1V0zm2 0h1v15h-1V0zm2 0h2v15h-2V0zm3 0h3v15h-3V0z' />
  </SvgIcon>
);
export const PriceLock = (props) => (
  <SvgIcon viewBox='0 0 15 18' {...props}>
    <path d='M10.2 6.574H4.8v-1.31C4.8 3.74 6 2.519 7.5 2.519c1.5 0 2.7 1.22 2.7 2.747v1.309zm-3.305 4.519a.94.94 0 0 0 .301.324c.14.1.338.2.593.304.484.2.875.394 1.174.586.299.19.535.428.708.71.173.283.26.633.26 1.052 0 .386-.08.721-.24 1.007-.16.286-.387.514-.682.686a2.591 2.591 0 0 1-1.034.321v.992h-.779v-.992a2.837 2.837 0 0 1-1.068-.329 1.997 1.997 0 0 1-.775-.775c-.196-.34-.294-.767-.294-1.279h1.48c0 .426.098.732.294.92.197.188.445.282.745.282.285 0 .502-.076.652-.227a.808.808 0 0 0 .226-.596c0-.183-.032-.337-.096-.461a.916.916 0 0 0-.304-.332 2.887 2.887 0 0 0-.576-.289 7.368 7.368 0 0 1-1.186-.57 2.157 2.157 0 0 1-.71-.706c-.173-.283-.26-.635-.26-1.057 0-.373.082-.703.245-.992.163-.29.394-.522.691-.698a2.499 2.499 0 0 1 1.034-.324V7.588h.78v1.076c.378.057.708.185.99.384.28.2.497.464.649.793.152.33.228.71.228 1.142H8.465c0-.38-.076-.665-.23-.858a.76.76 0 0 0-.627-.289c-.268 0-.47.077-.603.232-.134.154-.2.356-.2.606 0 .163.03.302.09.419zm5.78-4.52V5.266C12.675 2.365 10.35 0 7.5 0 4.65 0 2.325 2.365 2.325 5.265v1.309H0V18h15V6.574h-2.325z' />
  </SvgIcon>
);

export const Multilocation = (props) => (
  <SvgIcon viewBox='0 0 16 16' {...props}>
    <path d='M5.943 16L0 0l16 5.943-6.788 2.545c-.334.126-.598.39-.724.724L5.943 16z' />
  </SvgIcon>
);

export const Burst = (props) => (
  <SvgIcon viewBox='0 0 483 514' {...props}>
    <path d='M165.335 462.672c-3.061-1.225-6.732 0-7.957 3.06l-14.076 33.66c-1.836 3.06 0 6.732 3.06 7.956.612.612 1.836.612 2.448.612 2.449 0 4.896-1.225 5.508-3.673l14.076-33.659c1.224-3.06 0-6.732-3.059-7.956M209.398 356.184c-3.06-1.224-6.732 0-7.956 3.06l-33.049 79.56c-1.836 3.06 0 6.732 3.061 7.956.612.612 1.836.612 2.448.612 2.448 0 4.895-1.224 5.508-3.672l33.048-79.56c1.224-3.06 0-6.732-3.06-7.956M233.878 295.596c-3.06-1.224-6.731 0-7.955 3.06l-14.076 33.66c-1.225 3.06 0 6.732 3.059 7.956.613.612 1.836.612 2.449.612 2.447 0 4.895-1.225 5.507-3.672l14.077-33.66c1.835-3.06.61-6.732-3.061-7.956M276.718 191.556c.612.612 1.836.612 2.448.612 2.448 0 4.897-1.224 5.508-3.672l14.076-33.66c1.225-3.06 0-6.732-3.06-7.956-3.06-1.224-6.732 0-7.955 3.06l-14.077 33.66c-1.223 3.06 0 6.732 3.06 7.956M298.139 139.536c.61.612 1.836.612 2.447.612 2.449 0 4.897-1.224 5.509-3.672l23.867-55.692c1.225-3.06 0-6.732-3.06-7.956-3.671-1.224-7.343 0-8.568 3.06l-23.256 55.692c-1.223 3.06 0 6.732 3.06 7.956M329.35 64.872c.612.612 1.837.612 2.448.612 2.449 0 4.897-1.224 5.509-3.672l14.075-33.66c1.225-3.06 0-6.732-3.06-7.956-3.06-1.224-6.732 0-7.955 3.06l-14.077 33.66c-1.223 3.06 0 6.732 3.06 7.956M161.662 355.572c-2.448-2.448-6.12-1.837-8.567.612l-24.48 26.928c-2.449 2.447-1.837 6.12.61 8.567 1.225.614 2.45 1.225 4.286 1.225 1.836 0 3.06-.611 4.283-1.837l24.48-26.928c2.448-2.447 1.836-6.12-.612-8.567M169.007 347.004c1.223 1.224 2.447 1.836 4.283 1.836 1.836 0 3.06-.612 4.284-1.836l24.48-26.929c2.449-2.447 1.836-6.119-.611-8.568-2.45-2.447-6.121-2.447-8.57 0l-24.48 26.93c-2.447 2.447-1.835 6.12.614 8.567M109.03 401.472l-21.42 22.032c-2.448 2.447-2.448 6.12 0 8.568 1.224 1.224 2.447 1.836 4.283 1.836 1.837 0 3.061-.612 4.285-1.836l21.42-22.032c2.448-2.448 2.448-6.12 0-8.568-2.448-2.448-6.12-2.448-8.568 0M300.586 190.332l-24.48 26.928c-2.448 2.448-1.835 6.12.612 8.568 1.224 1.224 2.448 1.836 4.284 1.836 1.836 0 3.06-.612 4.284-1.836l24.48-26.928c2.448-2.448 1.837-6.12-.612-8.568-2.448-3.06-6.12-3.06-8.568 0M336.694 159.732c1.224 1.224 2.448 1.836 4.284 1.836 1.836 0 3.06-.612 4.283-1.836l24.481-26.928c2.448-2.448 1.836-6.12-.612-8.568-2.448-3.06-6.12-3.06-8.568 0l-24.48 26.928c-2.449 2.448-1.836 6.12.612 8.568M63.13 350.064L30.694 367.2c-3.06 1.836-4.284 5.509-2.448 8.568 1.224 1.836 3.06 3.06 5.509 3.06 1.223 0 1.836 0 3.06-.612L69.25 361.08c3.06-1.836 4.284-5.508 2.448-8.568-1.836-3.06-5.507-4.284-8.568-2.448M91.894 347.615c1.225 0 1.836 0 3.06-.61L172.068 306c3.059-1.837 4.284-5.508 2.448-8.568-1.836-3.06-5.508-4.284-8.568-2.449l-77.113 41.005c-3.06 1.836-4.284 5.507-2.448 8.567 1.225 1.837 3.06 3.06 5.508 3.06M232.654 266.22c-1.836-3.061-5.509-4.284-8.567-2.448l-32.437 17.136c-2.448 1.835-3.673 5.507-2.448 8.568 1.224 1.836 3.06 3.06 5.508 3.06 1.224 0 1.836 0 3.06-.613l32.436-17.135c3.06-1.836 4.284-5.508 2.448-8.568M318.334 221.544c1.225 0 1.836 0 3.061-.612l32.435-17.136c3.061-1.836 4.284-5.508 2.448-8.568-1.836-3.06-5.507-4.284-8.568-2.448l-32.436 17.136c-3.06 1.836-4.284 5.508-2.448 8.568 1.224 1.836 3.06 3.06 5.508 3.06M363.01 192.168c1.225 1.836 3.06 3.06 5.509 3.06 1.223 0 1.836 0 3.059-.612l51.409-27.54c3.059-1.836 4.284-5.508 2.448-8.568-1.836-3.06-5.51-4.284-8.57-2.448l-51.407 27.54c-3.06 1.836-4.284 5.508-2.448 8.568M437.063 157.896c1.224 0 1.836 0 3.06-.612l32.435-17.136c3.06-1.836 4.284-5.508 2.447-8.568-1.836-3.06-5.507-4.284-8.567-2.448l-32.437 17.136c-3.058 1.836-4.284 5.508-2.447 8.568 1.225 1.836 3.06 3.06 5.509 3.06M85.774 281.52c-.612-3.06-3.672-5.508-6.732-4.896l-36.108 5.508c-3.06 0-5.508 3.06-4.896 6.119.612 3.06 3.06 5.509 6.12 5.509h.612l36.108-5.51c3.06-.61 5.507-3.67 4.896-6.73M165.946 263.772l-36.107 5.509c-3.06-.001-5.509 3.058-4.897 6.119.611 3.06 3.061 5.508 6.12 5.508h.613l36.107-5.508c3.06-.611 5.508-3.672 4.896-6.732-.612-3.06-3.67-5.508-6.732-4.896M260.194 253.368c.612 3.06 3.06 5.508 6.12 5.508h.611l36.11-5.508c3.058-.613 5.507-3.673 4.895-6.732-.612-3.06-3.673-5.509-6.732-4.896l-36.108 5.507c-3.06 0-5.508 3.06-4.896 6.121M410.134 231.336c-.611-3.672-3.672-5.508-6.731-5.508l-76.5 11.016c-3.061.612-5.508 3.672-4.897 6.732.612 3.06 3.06 5.508 6.12 5.508h.612l76.5-11.016c3.06-.612 5.508-3.672 4.896-6.732M423.599 229.5c.61 3.06 3.06 5.508 6.119 5.508h.612l36.109-5.508c3.059-.612 5.508-3.672 4.895-6.732-.611-3.06-3.672-5.508-6.731-4.896l-36.108 5.508c-3.06-.612-5.508 2.448-4.896 6.12M42.322 220.932c3.06 0 5.508-1.836 6.12-4.896.611-3.06-1.224-6.732-4.896-7.344l-36.108-7.344c-3.06-.612-6.732 1.224-7.344 4.896-.612 3.672 1.836 6.732 4.896 7.344l36.108 7.344h1.224zM56.398 217.872c-.612 3.06 1.224 6.732 4.896 7.344l60.587 12.24h1.225c3.06 0 5.508-1.836 6.12-4.896.612-3.06-1.224-6.732-4.896-7.344l-60.588-12.24c-3.672-.612-6.732 1.224-7.344 4.896M179.41 248.472c3.06 0 5.51-1.836 6.12-4.896.611-3.06-1.224-6.732-4.896-7.344l-36.108-7.344c-3.672-.612-6.732 1.836-7.344 4.896-.612 3.06 1.224 6.732 4.896 7.344l36.108 7.344h1.224zM363.622 283.356c3.061 0 5.508-1.836 6.12-4.896.612-3.06-1.224-6.732-4.895-7.343l-36.109-6.733c-3.059-.612-6.732 1.224-7.344 4.896-.612 3.673 1.224 6.732 4.896 7.345l36.108 7.343c.612-.612.612-.612 1.224-.612M431.554 291.312c.612-3.061-1.224-6.732-4.896-7.344l-46.511-9.18c-3.061-.612-6.733 1.224-7.345 4.896-.611 3.06 1.225 6.732 4.897 7.344l46.51 9.18c.614-.612 1.226 0 1.226 0 3.059 0 5.508-1.835 6.119-4.896M478.066 293.76l-36.108-7.345c-3.06-.611-6.732 1.225-7.344 4.897-.612 3.06 1.223 6.732 4.895 7.344l36.11 7.343h1.222c3.061 0 5.51-1.836 6.121-4.895.612-3.06-1.224-6.732-4.896-7.344M285.286 278.46c-1.836 3.06-.612 6.731 1.836 8.567L318.334 306c1.224.612 1.836.612 3.06.612 1.836 0 4.285-1.223 5.508-3.059 1.836-3.06.613-6.733-1.836-8.569l-31.212-18.97c-3.06-1.225-6.732-.614-8.568 2.447M414.418 348.228l-66.708-39.78c-3.06-1.836-6.731-.613-8.567 1.837-1.837 3.059-.613 6.73 1.836 8.567l66.708 39.78c1.223.612 1.835.612 3.059.612 1.836.612 4.284 0 5.508-2.448 1.836-3.06.612-6.732-1.836-8.568M467.662 380.663l-31.212-18.972c-3.059-1.836-6.732-.612-8.568 1.836-1.836 3.061-.612 6.733 1.836 8.57l31.213 18.97c1.223.613 1.835.613 3.06.613 2.447.612 4.283-.613 5.507-2.449 1.836-3.059.612-6.73-1.836-8.568M17.843 124.848l31.21 18.972c1.226.612 1.837.612 3.06.612 1.837 0 4.286-1.224 5.509-3.06 1.836-2.448 1.225-6.12-1.836-7.956l-31.212-18.972c-3.06-1.836-6.731-.612-8.567 1.836-1.836 3.06-.613 6.732 1.836 8.568M75.982 160.344l79.56 47.736c1.224.612 1.836.612 3.06.612 1.836 0 4.283-1.224 5.508-3.06 1.836-3.06.611-6.732-1.836-8.568l-79.56-47.736c-3.06-1.836-7.344-.612-8.569 2.448-1.836 3.06-.61 6.732 1.837 8.568M180.022 214.812c-1.835 3.06-.612 6.732 1.837 8.568l31.211 18.972c1.224.612 1.837.612 3.06.612 1.835 0 4.284-1.224 5.507-3.06 1.837-2.448 1.225-6.12-1.836-7.956l-31.21-18.972c-3.06-1.836-6.733-.612-8.569 1.836M320.17 351.9c1.225 1.225 3.06 2.448 4.896 2.448 1.224 0 2.449-.612 3.672-1.223 2.449-1.837 3.06-6.121.613-8.57l-23.257-28.151c-2.447-3.06-6.12-3.672-8.568-1.224-2.448 1.836-3.06 6.12-.612 8.568L320.17 351.9zM374.638 400.86l-34.271-42.228c-1.836-2.448-6.121-3.06-8.57-.612-2.446 1.836-3.058 6.12-.61 8.569l34.27 42.227c1.226 1.225 3.062 1.836 4.898 1.836 1.223 0 2.447-.611 3.672-1.224 2.448-1.836 3.059-6.12.61-8.568M386.267 415.548c-1.836-2.448-6.12-3.06-8.568-.612-2.45 1.836-3.061 6.12-.613 8.568l23.256 27.54c1.225 1.224 3.06 2.447 4.897 2.447 1.223 0 2.448-.61 3.672-1.223 2.448-1.836 3.059-6.12.612-8.569l-23.256-28.15zM119.435 104.04c1.224 1.224 3.06 2.448 4.896 2.448 1.223 0 2.448-.612 3.672-1.224 2.448-1.836 3.059-6.12.612-8.568l-23.256-28.764c-2.448-2.448-6.12-3.06-8.57-.612-2.446 1.836-3.058 6.12-.61 8.568l23.256 28.152zM131.061 118.116l34.272 42.228c1.224 1.224 3.06 2.448 4.897 2.448 1.225 0 2.448-.612 3.672-1.224 2.448-1.836 3.06-6.12.613-8.568l-34.273-42.84c-2.448-2.448-6.12-3.06-8.567-.612-2.45 1.836-3.06 6.12-.614 8.568M186.142 166.464c-1.836-2.448-6.12-3.06-8.567-.612-2.45 1.836-3.06 6.12-.613 8.568l23.256 28.152c1.225 1.224 3.06 2.448 4.897 2.448 1.224 0 2.447-.612 3.672-1.224 2.448-1.836 3.06-6.12.612-8.568l-23.257-28.764zM276.106 312.12l-12.24-34.885c-1.224-3.059-4.897-4.896-7.956-3.672-3.06 1.225-4.896 4.897-3.672 7.956l12.24 34.884c1.224 3.061 3.672 4.284 6.12 4.284.612 0 1.224 0 1.836-.612 3.06-1.224 4.896-4.895 3.672-7.955M306.706 399.024l-23.256-64.872c-.612-3.06-4.284-4.284-7.344-3.672-3.06 1.224-4.896 4.897-3.67 7.956l23.254 64.872c.612 2.448 3.06 4.284 5.508 4.284.612 0 1.224 0 1.836-.612 3.061-1.224 4.897-4.896 3.672-7.956M326.902 455.327l-12.24-34.884c-1.224-3.059-4.896-4.895-7.956-3.672-3.06 1.224-4.896 4.897-3.672 7.956l12.24 34.884c1.224 2.448 3.672 4.284 6.12 4.284.612 0 1.224 0 1.836-.612 3.06-1.224 4.896-4.895 3.672-7.956M175.126 65.484l12.24 34.884c.612 2.448 3.061 4.284 5.508 4.284.612 0 1.225 0 1.836-.612 3.061-1.224 4.896-4.896 3.672-7.956L186.755 61.2c-1.225-3.06-4.897-4.896-7.957-3.672-3.06 1.224-4.896 4.896-3.672 7.956M194.71 121.788l23.256 64.872c.612 2.448 3.06 4.284 5.508 4.284.613 0 1.224 0 1.836-.612 3.06-1.224 4.896-4.896 3.672-7.956l-22.643-64.872c-1.225-3.06-4.897-4.896-7.957-3.672-3.06 1.224-4.896 4.896-3.672 7.956M245.506 246.636c3.06-1.225 4.896-4.896 3.673-7.956l-12.24-34.884c-.613-3.06-4.285-4.896-7.344-3.672-3.061 1.224-4.897 4.896-3.672 7.956l12.239 34.884c.613 2.447 3.06 4.283 5.509 4.283.61 0 1.224 0 1.835-.611M167.782 42.228c.611 2.448 3.061 4.284 5.508 4.284.612 0 1.224 0 1.836-.612 3.06-1.224 4.896-4.896 3.672-7.956l-6.732-20.196c-1.223-3.06-4.895-4.896-7.956-3.672-3.06 1.224-4.896 4.896-3.672 7.956l7.344 20.196zM336.082 484.703c-1.224-3.06-4.896-4.896-7.956-3.672-3.06 1.225-4.896 4.897-3.672 7.956l7.956 20.196c.612 2.45 3.06 4.285 5.508 4.285.612 0 1.225 0 1.836-.613 3.06-1.223 4.896-4.895 3.672-7.956l-7.344-20.196zM249.79 310.284c-3.672 0-6.119 2.447-6.119 6.12v36.72c0 3.672 2.447 6.12 6.119 6.12 3.672 0 6.12-2.448 6.12-6.12v-36.72c0-3.673-2.448-6.12-6.12-6.12M249.79 369.648c-3.672 0-6.119 2.448-6.119 6.12v67.32c0 3.672 2.447 6.12 6.119 6.12 3.672 0 6.12-2.448 6.12-6.12v-67.32c0-3.672-2.448-6.12-6.12-6.12M249.179 459.612c-3.673 0-6.121 2.448-6.121 6.12v36.72c0 3.673 2.448 6.12 6.12 6.12 3.673 0 6.12-2.447 6.12-6.12v-36.72c0-3.672-2.447-6.12-6.12-6.12M254.686 48.96c3.672 0 6.12-2.448 6.12-6.12V6.12c0-3.06-2.447-6.12-6.12-6.12-3.06 0-6.12 2.448-6.12 6.12v36.72c0 3.672 2.448 6.12 6.12 6.12M254.686 146.88c3.672 0 6.12-2.448 6.12-6.12V67.32c0-3.672-2.447-6.12-6.12-6.12-3.672 0-6.12 2.448-6.12 6.12v73.44c0 3.672 2.448 6.12 6.12 6.12M254.074 208.08c3.672 0 6.12-2.448 6.12-6.12v-36.72c0-3.672-2.448-6.12-6.12-6.12s-6.12 2.448-6.12 6.12v36.72c0 3.672 2.448 6.12 6.12 6.12' />
  </SvgIcon>
);
export const Invitations = (props) => (
  <SvgIcon viewBox='0 0 185 189' {...props}>
    <path d='M59.782 26.132l88.913-20.268 30.649 134.008-45.848 10.635 8.357-21.274 15.962-3.55c1.265-.254 2.278-1.773 2.024-3.038-.25-1.268-1.77-2.278-3.038-2.024l-12.666 2.784 6.33-15.708 3.044-.76c1.268-.25 2.275-1.77 2.024-3.037-.25-1.268-1.773-2.282-3.04-2.027l-4.812 1.013-22.797-9.12 24.316-5.574c1.265-.25 2.282-1.773 2.028-3.037-.255-1.268-1.77-2.282-3.038-2.028l-31.415 7.093L93.98 81.1l51.168-11.653c1.268-.25 2.278-1.773 2.024-3.038-.251-1.268-1.77-2.281-3.038-2.027L85.87 77.808l-15.45-6.08-10.639-45.596zm55.474 156.041L10.893 140.628l49.9-11.65a17.801 17.801 0 0 0 8.615 8.612c2.024.76 3.8 1.268 5.824 1.268 2.028 0 4.306-.508 6.334-1.268l62.064-26.852-22.546 56.49-5.828 14.945zm26.346-75.995l-61.81 26.594c-2.786 1.268-5.573 1.268-8.36 0-2.787-1.007-4.811-3.037-5.828-5.82l-26.598-61.81 102.596 41.036zM34.2 67.168l24.566 57.247-52.18 12.161L34.198 67.17zM0 140.378v1.014c0 .25.25.25.25.505l.252.254c.257.251.257.251.512.251h.25l114.243 45.6c.254 0 .512.251 1.017.251.25 0 .76 0 1.017-.25a3.091 3.091 0 0 0 1.261-1.268l12.158-30.653 51.93-11.903c1.268-.255 2.282-1.777 2.028-3.042L153 2.066C152.75.8 151.228-.213 149.963.04L55.982 21.572c-.76.254-1.268.508-1.52 1.013-.253.509-.508 1.265-.253 2.024l10.384 45.092L35.206 58.05c-.251 0-.756-.255-1.007-.255-.763 0-1.268.255-1.78.763-.251.251-.502.505-.502.756L0 139.11v1.268z' />
    <path d='M117.03 54.502l1.014-3.04v-.252h-.255l-2.783 1.01-2.536-1.77h-.251l-.258.252v3.04l-2.529 1.774s-.258.25 0 .25c0 0 0 .259.254.259l3.038.759 1.014 2.787.25.25s.255 0 .255-.25l1.773-2.536h3.038s.254 0 .254-.251v-.254l-2.278-2.028zM113.482 37.025l2.79 3.797h.25s.252 0 .252-.251l1.268-4.56 4.56-1.52.257-.253s0-.255-.257-.255l-4.052-2.532V26.64s0-.254-.254-.254h-.254l-3.798 3.04-4.56-1.522h-.254v.255l1.773 4.56-2.787 3.8v.251l.255.255h4.81zM89.925 47.41l-1.519 6.332v.255h.251l5.828-2.787 5.57 3.292h.509l.254-.254-.508-6.334 4.814-4.305s.251-.251 0-.251c-.254 0-.254-.255-.254-.255l-6.333-1.267-2.533-5.825-.254-.254s-.254 0-.254.254l-3.038 5.574-6.588.505s-.25 0-.25.254v.251l4.305 4.814zM81.313 111.498s0-.254-.25-.254h-.255l-1.777 1.268-2.024-.76h-.254v.255l.76 2.027-1.269 1.77v.255l.258.254h2.275l1.268 1.773.254.254s.251 0 .251-.254l.512-2.027 2.024-.757.251-.254s0-.257-.25-.257l-1.774-1.265v-2.028zM89.419 106.688l-1.014 3.292v.254h.251l3.296-1.268 2.787 2.027h.504l.252-.254v-3.292l2.79-2.027s.254-.255 0-.255 0-.254-.254-.254l-3.292-1.01-1.268-3.296-.251-.25s-.251 0-.251.25l-2.031 2.787h-3.289s-.257 0-.257.254v.255l2.027 2.787zM73.207 101.873l.505 4.56s0 .255.255.255h.254l3.546-3.042 4.56 1.014h.251v-.254l-2.027-4.306 2.282-4.055v-.25l-.255-.255-4.56.505L74.98 92.5h-.254s-.25 0-.25.254l-1.018 4.56-4.306 1.773-.254.251s0 .255.254.255l4.055 2.281z' />
  </SvgIcon>
);
export const ThreeDots = (props) => (
  <SvgIcon viewBox='0 0 12 8' {...props}>
    <circle cx='1.5' cy='1.5' r='1.5' />
    <circle cx='6' cy='1.5' r='1.5' />
    <circle cx='10.5' cy='1.5' r='1.5' />
  </SvgIcon>
);

export const MapPickup = (props) => {
  const color = props.color || '#0E2C44';

  return (
    <SvgIcon viewBox='0 0 28 25' {...props}>
      <title>Routing/Map_DropOff-Assigned Copy 14</title>
      <g
        id='Routing/Map_DropOff-Assigned-Copy-14'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,16.8911081 C26,17.5013996 25.7213502,18.0782935 25.2433157,18.4576859 L17,25 L16,24.206 L23.2433157,18.4576859 C23.6778925,18.1127837 23.9476886,17.6046571 23.9931509,17.0565999 L24,16.8911081 L24,2 C24,0.945638205 23.1841222,0.0818348781 22.1492623,0.00548573643 L22,0 L24,0 Z M20,0 C21.1045695,-2.02906125e-16 22,0.8954305 22,2 L22,16.8911081 C22,17.5013996 21.7213502,18.0782935 21.2433157,18.4576859 L13,25 L12,24.206 L19.2433157,18.4576859 C19.6778925,18.1127837 19.9476886,17.6046571 19.9931509,17.0565999 L20,16.8911081 L20,2 C20,0.945638205 19.1841222,0.0818348781 18.1492623,0.00548573643 L18,0 L20,0 Z M16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L16,0 Z'
          id='Mask'
          fill={color}
        ></path>
        <polygon
          id='Mask'
          fill={'#FFFFFF'}
          transform='translate(9.000000, 10.000000) scale(1, -1) rotate(180.000000) translate(-9.000000, -10.000000) '
          points='9 6 14 14 4 14'
        ></polygon>
      </g>
    </SvgIcon>
  );
};

export const MapPickupOutline = (props) => {
  const color = props.color || '#0E2C44';

  return (
    <SvgIcon viewBox='0 0 28 25' {...props}>
      <title>Routing/Map_DropOff-Assigned Copy 12</title>
      <defs>
        <polygon id='path-1' points='9 8 13 14 5 14'></polygon>
      </defs>
      <g
        id='Routing/Map_DropOff-Assigned-Copy-12'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,16.8911081 C26,17.5013996 25.7213502,18.0782935 25.2433157,18.4576859 L17,25 L16,24.206 L23.2433157,18.4576859 C23.6778925,18.1127837 23.9476886,17.6046571 23.9931509,17.0565999 L24,16.8911081 L24,2 C24,0.945638205 23.1841222,0.0818348781 22.1492623,0.00548573643 L22,0 L24,0 Z M20,0 C21.1045695,-2.02906125e-16 22,0.8954305 22,2 L22,16.8911081 C22,17.5013996 21.7213502,18.0782935 21.2433157,18.4576859 L13,25 L12,24.206 L19.2433157,18.4576859 C19.6778925,18.1127837 19.9476886,17.6046571 19.9931509,17.0565999 L20,16.8911081 L20,2 C20,0.945638205 19.1841222,0.0818348781 18.1492623,0.00548573643 L18,0 L20,0 Z M16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L16,0 Z M15,3.5 L3,3.5 L3,15.3760298 C3,15.9386204 3.23676114,16.4724028 3.64749566,16.8493842 L3.77587243,16.9576466 L9,21.0009766 L14.2241276,16.9576466 C14.6690289,16.6133053 14.9462356,16.0993637 14.99296,15.5438147 L15,15.3760298 L15,3.5 Z'
          id='Mask'
          fill={color}
        ></path>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-1'></use>
        </mask>
        <use
          id='Mask'
          fill='#0E2C44'
          transform='translate(9.000000, 11.000000) scale(1, -1) rotate(180.000000) translate(-9.000000, -11.000000) '
          xlinkHref='#path-1'
        ></use>
      </g>
    </SvgIcon>
  );
};

export const MapDropoff = (props) => {
  const color = props.color || '#0E2C44';

  return (
    <SvgIcon viewBox='0 0 26 25' {...props}>
      <title>Routing/Map_DropOff-Assigned Copy 15</title>
      <defs>
        <polygon id='path-1' points='9 7 14 15 4 15'></polygon>
      </defs>
      <g
        id='Routing/Map_DropOff-Assigned-Copy-15'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,16.8911081 C26,17.5013996 25.7213502,18.0782935 25.2433157,18.4576859 L17,25 L16,24.206 L23.2433157,18.4576859 C23.6778925,18.1127837 23.9476886,17.6046571 23.9931509,17.0565999 L24,16.8911081 L24,2 C24,0.945638205 23.1841222,0.0818348781 22.1492623,0.00548573643 L22,0 L24,0 Z M20,0 C21.1045695,-2.02906125e-16 22,0.8954305 22,2 L22,16.8911081 C22,17.5013996 21.7213502,18.0782935 21.2433157,18.4576859 L13,25 L12,24.206 L19.2433157,18.4576859 C19.6778925,18.1127837 19.9476886,17.6046571 19.9931509,17.0565999 L20,16.8911081 L20,2 C20,0.945638205 19.1841222,0.0818348781 18.1492623,0.00548573643 L18,0 L20,0 Z M16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L16,0 Z'
          id='Mask'
          fill={color}
        ></path>
        <polygon
          id='Mask'
          fill={'#FFFFFF'}
          transform='translate(9.000000, 10.000000) scale(1, -1) rotate(0.000000) translate(-9.000000, -10.000000) '
          points='9 6 14 14 4 14'
        ></polygon>
      </g>
    </SvgIcon>
  );
};

export const MapDropoffOutline = (props) => {
  const color = props.color || '#0E2C44';

  return (
    <SvgIcon viewBox='0 0 26 25' {...props}>
      <title>Routing/Map_DropOff-Assigned Copy 13</title>
      <defs>
        <polygon id='path-1' points='9 8 13 14 5 14'></polygon>
      </defs>
      <g
        id='Routing/Map_DropOff-Assigned-Copy-13'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,16.8911081 C26,17.5013996 25.7213502,18.0782935 25.2433157,18.4576859 L17,25 L16,24.206 L23.2433157,18.4576859 C23.6778925,18.1127837 23.9476886,17.6046571 23.9931509,17.0565999 L24,16.8911081 L24,2 C24,0.945638205 23.1841222,0.0818348781 22.1492623,0.00548573643 L22,0 L24,0 Z M20,0 C21.1045695,-2.02906125e-16 22,0.8954305 22,2 L22,16.8911081 C22,17.5013996 21.7213502,18.0782935 21.2433157,18.4576859 L13,25 L12,24.206 L19.2433157,18.4576859 C19.6778925,18.1127837 19.9476886,17.6046571 19.9931509,17.0565999 L20,16.8911081 L20,2 C20,0.945638205 19.1841222,0.0818348781 18.1492623,0.00548573643 L18,0 L20,0 Z M16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L16,0 Z M15,3.5 L3,3.5 L3,15.3760298 C3,15.9386204 3.23676114,16.4724028 3.64749566,16.8493842 L3.77587243,16.9576466 L9,21.0009766 L14.2241276,16.9576466 C14.6690289,16.6133053 14.9462356,16.0993637 14.99296,15.5438147 L15,15.3760298 L15,3.5 Z'
          id='Mask'
          fill={color}
        ></path>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-1'></use>
        </mask>
        <use
          id='Mask'
          fill='#0E2C44'
          transform='translate(9.000000, 11.000000) rotate(180.000000) translate(-9.000000, -11.000000) '
          xlinkHref='#path-1'
        ></use>
      </g>
    </SvgIcon>
  );
};

export const TickMark = (props) => {
  return (
    <SvgIcon viewBox='0 0 14 11' {...props}>
      <path
        id='path-1'
        d='M 0.00,6.19 C 0.00,6.19 1.96,4.22 1.96,4.22 1.96,4.22 5.09,7.22 5.09,7.22 5.09,7.22 12.13,0.51 12.13,0.51 12.13,0.51 14.00,2.32 14.00,2.32 14.00,2.32 5.00,11.00 5.00,11.00 5.00,11.00 2.59,8.68 2.59,8.68 2.59,8.68 0.00,6.19 0.00,6.19 Z'
      />
    </SvgIcon>
  );
};

export const LoadingDots = (props) => {
  const color = props.color || '#278ADA';
  return (
    <SvgIcon
      viewBox='0 0 10 10'
      {...props}
      style={{ height: '16px', width: '30px' }}
    >
      <title>dots</title>
      <defs></defs>
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        sketchType='MSPage'
      >
        <g className='loadingDots' sketchType='MSArtboardGroup' fill={color}>
          <circle
            className='dot1'
            sketchType='MSShapeGroup'
            cx='0'
            cy='2'
            r='2'
          ></circle>
          <circle
            className='dot2'
            sketchType='MSShapeGroup'
            cx='6'
            cy='2'
            r='2'
          ></circle>
          <circle
            className='dot3'
            sketchType='MSShapeGroup'
            cx='12'
            cy='2'
            r='2'
          ></circle>
        </g>
      </g>
    </SvgIcon>
  );
};

export const RecurringPayment = (props) => {
  const color = props.color || '#278ADA';
  return (
    <SvgIcon
      {...props}
      style={{ height: '16px', width: '21px' }}
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 1000 1000'
      enable-background='new 0 0 1000 1000'
      xmlSpace='preserve'
      fill={color}
    >
      <g>
        <g transform='translate(0.000000,511.000000) scale(0.100000,-0.100000)'>
          <path d='M4698.1,4904.7c-1439.3-92-2761.6-806.8-3631.7-1964.4C466.5,2141.2,106.2,1102.4,100.5,151.9c-1.9-262.6,0-281.7,46-362.2C248-390.5,441.6-472.9,658.2-426.9C800-398.2,895.8-329.2,961-208.4c46,84.3,55.6,128.4,69,339.2c26.8,410.1,63.2,634.3,151.4,950.6c299,1061.7,1069.4,1972,2079.4,2455c551.9,264.5,1119.2,391,1749.7,391c668.9,0,1220.8-124.6,1749.7-394.8c249.1-128.4,576.9-360.3,726.3-513.6l84.3-88.2h-429.3c-461.9-1.9-519.3-11.5-640.1-103.5c-155.2-116.9-203.1-379.5-101.6-553.9c57.5-97.7,141.8-168.7,241.5-203.1c88.2-28.8,2159.8-30.7,2238.4,0c107.3,40.2,195.5,116.9,245.3,214.6l47.9,97.7v1079c0,1178.6,1.9,1157.5-111.2,1276.4c-88.2,93.9-191.6,136.1-331.5,138c-107.3,0-139.9-7.7-220.4-57.5c-57.5-36.4-115-93.9-151.4-151.4l-57.5-93.9l-5.7-448.5c-3.8-245.3-9.6-446.5-15.3-446.5c-5.8,0-76.7,57.5-161,126.5c-553.9,458-1389.4,860.5-2079.4,1002.3C5608.4,4895.1,5110.1,4931.5,4698.1,4904.7z' />
          <path d='M9197.9,602.2c-97.7-49.8-174.4-138-216.6-249.1c-11.5-30.7-30.7-182.1-40.2-335.4c-36.4-596-143.7-1013.8-391-1523.6C7996.3-2650,6930.8-3447.2,5656.3-3671.5c-544.3-95.8-1224.6-65.2-1780.4,80.5c-515.5,134.2-1038.7,419.7-1377.9,749.3l-92,90.1l469.5,9.6l467.6,9.6l82.4,57.5c174.4,122.6,243.4,306.6,187.8,502.1c-32.6,122.6-166.7,256.8-285.6,289.4c-65.2,19.2-346.9,23-1159.5,19.2l-1073.2-5.8l-72.8-44.1c-38.3-24.9-95.8-86.2-124.6-134.2l-51.7-90.1l-5.8-1034.9c-3.8-718.7,0-1065.5,15.3-1134.6c63.2-287.5,366-433.1,630.5-300.9c122.6,61.3,201.2,164.8,230,297.1c11.5,51.7,21.1,268.3,21.1,481v383.3l101.6-84.3c505.9-431.2,1178.6-791.5,1814.9-973.6c1163.3-335.4,2439.7-218.5,3512.9,318.1c1552.3,778.1,2554.6,2248,2715.6,3984.3c38.3,408.2,17.3,574.9-84.3,707.2C9684.7,654,9395.3,700,9197.9,602.2z' />
        </g>
      </g>
    </SvgIcon>
  );
};

export const OrderBag = (props) => {
  return (
    <SvgIcon
      viewBox='0 0 20 15'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g id='600s-Settings' stroke='none' strokeWidth='1'>
        <g
          id='D20635_Storefrondot-Site-UpgradeUpsell_Basics'
          transform='translate(-181.000000, -451.000000)'
        >
          <g id='SubNav/Storefront/DomainSettings_Locked'>
            <g id='Group' transform='translate(181.000000, 451.700000)'>
              <path
                d='M8.36871328,12.3874923 C7.44844609,12.3673216 6.68658963,13.1210753 6.66704917,14.0710269 C6.64752718,15.0209786 7.37770887,15.8074097 8.29797607,15.8275614 C9.21822479,15.8477322 9.98009972,15.0939975 9.99964018,14.1440459 C10,14.1259151 10.0001019,14.1077461 9.99989875,14.0896153 C10.0097059,13.1597201 9.28737365,12.3977112 8.38653611,12.3876067 C8.38060748,12.3875305 8.37464191,12.3874923 8.36871328,12.3874923'
                id='Fill-1'
              ></path>
              <path
                d='M14.386435,12.3879874 C13.4664311,12.3577125 12.6968585,13.1030315 12.6675295,14.0527061 C12.6382004,15.0023806 13.3602335,15.7967915 14.2802374,15.8270664 C15.2002413,15.8573413 15.9697955,15.1120222 15.999143,14.1623286 C15.9998817,14.1382689 16.0001403,14.11419 15.9999002,14.0900921 C16.0097627,13.1602068 15.2874526,12.3981489 14.3866382,12.3879874 L14.386435,12.3879874 Z'
                id='Fill-3'
              ></path>
              <path
                d='M4.69062349,2.6531023 L4.0521093,0.555888102 C3.9661043,0.235541791 3.68734272,0.0101596973 3.36447863,0 L0,0 L0,1.51605846 L2.79963915,1.51605846 L5.72206949,11.1682973 C5.81001868,11.4835901 6.09090353,11.7003391 6.40970016,11.6989247 L17.0434173,11.6989247 C17.3661279,11.6952592 17.6515151,11.4825899 17.7556062,11.1682973 L19.9658476,3.6385403 C20.0879481,3.23917997 19.8722961,2.81360447 19.484148,2.68797691 C19.4096035,2.66384105 19.3318102,2.65207581 19.2536587,2.6531023 L4.69062349,2.6531023 Z'
                id='Fill-5'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const CartIconCircle = (props) => {
  return (
    <SvgIcon
      viewBox="0 0 25 25"
      style={{ height: '25px', width: '25px' }}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24.979566 12.489783c0 6.8979204-5.5918626 12.489783-12.489783 12.489783C5.59186257 24.979566 0 19.3877034 0 12.489783 0 5.59186257 5.59186257 0 12.489783 0c6.8979204 0 12.489783 5.59186257 12.489783 12.489783" />

      <g fill="#FFFFFF" transform="translate(6.5 7.7) scale(0.60)">
        <path d="M4.69062349,2.6531023 L4.0521093,0.555888102 C3.9661043,0.235541791 3.68734272,0.0101596973 3.36447863,0 L0,0 L0,1.51605846 L2.79963915,1.51605846 L5.72206949,11.1682973 C5.81001868,11.4835901 6.09090353,11.7003391 6.40970016,11.6989247 L17.0434173,11.6989247 C17.3661279,11.6952592 17.6515151,11.4825899 17.7556062,11.1682973 L19.9658476,3.6385403 C20.0879481,3.23917997 19.8722961,2.81360447 19.484148,2.68797691 C19.4096035,2.66384105 19.3318102,2.65207581 19.2536587,2.6531023 L4.69062349,2.6531023 Z" />
        <path d="M8.36871328,12.3874923 C7.44844609,12.3673216 6.68658963,13.1210753 6.66704917,14.0710269 C6.64752718,15.0209786 7.37770887,15.8074097 8.29797607,15.8275614 C9.21822479,15.8477322 9.98009972,15.0939975 9.99964018,14.1440459 C10,14.1259151 10.0001019,14.1077461 9.99989875,14.0896153 C10.0097059,13.1597201 9.28737365,12.3977112 8.38653611,12.3876067 C8.38060748,12.3875305 8.37464191,12.3874923 8.36871328,12.3874923" />
        <path d="M14.386435,12.3879874 C13.4664311,12.3577125 12.6968585,13.1030315 12.6675295,14.0527061 C12.6382004,15.0023806 13.3602335,15.7967915 14.2802374,15.8270664 C15.2002413,15.8573413 15.9697955,15.1120222 15.999143,14.1623286 C15.9998817,14.1382689 16.0001403,14.11419 15.9999002,14.0900921 C16.0097627,13.1602068 15.2874526,12.3981489 14.3866382,12.3879874 L14.386435,12.3879874 Z" />
      </g>
    </SvgIcon>
  );
};

export const CartIcon = (props) => {
  return (
    <SvgIcon
      viewBox='0 0 17 17'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g id='600s-Settings' stroke='none' strokeWidth='1'>
        <g
          id='D20635_Storefrondot-Site-UpgradeUpsell_Basics'
          transform='translate(-181.000000, -451.000000)'
        >
          <g id='SubNav/Storefront/DomainSettings_Locked'>
            <g id='Group' transform='translate(181.000000, 451.700000)'>
              <path
                d='M8.36871328,12.3874923 C7.44844609,12.3673216 6.68658963,13.1210753 6.66704917,14.0710269 C6.64752718,15.0209786 7.37770887,15.8074097 8.29797607,15.8275614 C9.21822479,15.8477322 9.98009972,15.0939975 9.99964018,14.1440459 C10,14.1259151 10.0001019,14.1077461 9.99989875,14.0896153 C10.0097059,13.1597201 9.28737365,12.3977112 8.38653611,12.3876067 C8.38060748,12.3875305 8.37464191,12.3874923 8.36871328,12.3874923'
                id='Fill-1'
              ></path>
              <path
                d='M14.386435,12.3879874 C13.4664311,12.3577125 12.6968585,13.1030315 12.6675295,14.0527061 C12.6382004,15.0023806 13.3602335,15.7967915 14.2802374,15.8270664 C15.2002413,15.8573413 15.9697955,15.1120222 15.999143,14.1623286 C15.9998817,14.1382689 16.0001403,14.11419 15.9999002,14.0900921 C16.0097627,13.1602068 15.2874526,12.3981489 14.3866382,12.3879874 L14.386435,12.3879874 Z'
                id='Fill-3'
              ></path>
              <path
                d='M4.69062349,2.6531023 L4.0521093,0.555888102 C3.9661043,0.235541791 3.68734272,0.0101596973 3.36447863,0 L0,0 L0,1.51605846 L2.79963915,1.51605846 L5.72206949,11.1682973 C5.81001868,11.4835901 6.09090353,11.7003391 6.40970016,11.6989247 L17.0434173,11.6989247 C17.3661279,11.6952592 17.6515151,11.4825899 17.7556062,11.1682973 L19.9658476,3.6385403 C20.0879481,3.23917997 19.8722961,2.81360447 19.484148,2.68797691 C19.4096035,2.66384105 19.3318102,2.65207581 19.2536587,2.6531023 L4.69062349,2.6531023 Z'
                id='Fill-5'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const MostPopularOptionStar = (props) => {
  return (
    <SvgIcon
      width={props.width || '13px'}
      height={props.height || '13px'}
      viewBox='0 0 13 13'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='1300s-SignUp'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='D21312c2_SignUp3-NewPricing-Storefront'
          transform='translate(-866.000000, -246.000000)'
          fill='#278ADA'
          {...props}
        >
          <g id='Group-2' transform='translate(866.000000, 245.000000)'>
            <path
              d='M5.8265143,1.27194422 C6.15239448,0.909351928 6.71725345,0.909351928 7.04313363,1.27194422 L7.04313363,1.27194422 L7.32556311,1.57054963 C7.56454191,1.82649713 7.93387277,1.890484 8.25975295,1.76251025 L8.25975295,1.76251025 L8.65080916,1.59187859 C9.10704141,1.39991797 9.62844969,1.63453651 9.75880176,2.10377358 L9.75880176,2.10377358 L9.88915383,2.50902379 C9.97605521,2.82895816 10.28021,3.0635767 10.6278156,3.08490566 L10.6278156,3.08490566 L11.0623225,3.10623462 C11.5402801,3.12756358 11.9096109,3.5754717 11.8227095,4.04470878 L11.8227095,4.04470878 L11.7575335,4.44995898 C11.6923575,4.79122231 11.8661602,5.11115669 12.1703151,5.28178835 L12.1703151,5.28178835 L12.5396459,5.47374897 C12.9741528,5.70836751 13.1045049,6.26292043 12.8220754,6.64684167 L12.8220754,6.64684167 L12.5830966,6.988105 C12.3658432,7.26538146 12.3658432,7.64930271 12.5830966,7.92657916 L12.5830966,7.92657916 L12.8438008,8.24651354 C13.1262302,8.63043478 13.0176035,9.18498769 12.5830966,9.41960623 L12.5830966,9.41960623 L12.1920404,9.5902379 C11.8878856,9.76086957 11.7140828,10.1021329 11.7792588,10.4433962 L11.7792588,10.4433962 L11.8661602,10.8486464 C11.9530616,11.3178835 11.6054561,11.7657916 11.1057732,11.7869073 L11.1057732,11.7869073 L10.6929916,11.8084495 C10.3453861,11.8297785 10.0412312,12.064397 9.95432986,12.4056604 L9.95432986,12.4056604 L9.84570314,12.8109106 C9.71535107,13.2799344 9.19394279,13.5360952 8.73771054,13.3441345 L8.73771054,13.3441345 L8.34665433,13.1948318 C8.02077415,13.0666448 7.65144329,13.1521739 7.41246449,13.4081214 L7.41246449,13.4081214 L7.13003501,13.7280558 C6.80415483,14.0906481 6.23929586,14.0906481 5.91341568,13.7280558 L5.91341568,13.7280558 L5.6309862,13.4294504 C5.3920074,13.1732896 5.02267654,13.109516 4.69679636,13.2374897 L4.69679636,13.2374897 L4.30574015,13.4081214 C3.8495079,13.5998687 3.32809962,13.3654635 3.19774755,12.8962264 L3.19774755,12.8962264 L3.08912083,12.4909762 C3.00221945,12.1710418 2.69806461,11.9364233 2.35045909,11.9150943 L2.35045909,11.9150943 L1.93767754,11.8935521 C1.45971995,11.8724364 1.09038908,11.4245283 1.17729046,10.9552912 L1.17729046,10.9552912 L1.2424665,10.550041 C1.30764253,10.2087777 1.13383977,9.88884331 0.829684939,9.71821165 L0.829684939,9.71821165 L0.460354073,9.52625103 C0.0258471721,9.29163249 -0.104504898,8.73707957 0.177924588,8.35315833 L0.177924588,8.35315833 L0.416903383,8.011895 C0.634156834,7.73461854 0.634156834,7.35069729 0.416903383,7.07342084 L0.416903383,7.07342084 L0.156199243,6.75348646 C-0.126230243,6.36956522 -0.017603518,5.81501231 0.416903383,5.58039377 L0.416903383,5.58039377 L0.786234249,5.36710418 C1.09038908,5.19647252 1.26419184,4.85520919 1.17729046,4.55660377 L1.17729046,4.55660377 L1.09038908,4.15135357 C1.0034877,3.68211649 1.35109322,3.23420837 1.85077616,3.21287941 L1.85077616,3.21287941 L2.26355771,3.19155045 C2.61116323,3.17022149 2.91531807,2.93560295 3.00221945,2.59433962 L3.00221945,2.59433962 L3.11084617,2.18908942 C3.24119824,1.71985234 3.76260652,1.46390484 4.21883877,1.65586546 L4.21883877,1.65586546 L4.60989498,1.80516817 C4.93577516,1.93314192 5.30510602,1.84782609 5.54408482,1.59187859 L5.54408482,1.59187859 Z M6.88028704,4.27454499 C6.7560669,3.908485 6.25918637,3.908485 6.11426288,4.27454499 L6.11426288,4.27454499 L5.36894207,6.19097672 L3.38141992,6.3417073 C3.00875952,6.36324024 2.86383603,6.85849788 3.15368301,7.11689317 L3.15368301,7.11689317 L4.66502798,8.45193549 L4.18885079,10.454499 C4.08533401,10.8418766 4.49940113,11.1435531 4.80995147,10.9282237 L4.80995147,10.9282237 L6.50762664,9.8300437 L8.20530181,10.9282237 C8.51585214,11.1220201 8.9092159,10.8418766 8.82640248,10.454499 L8.82640248,10.454499 L8.3502253,8.45193549 L9.86157026,7.11689317 C10.1307139,6.85849788 9.9857904,6.36324024 9.61313,6.3417073 L9.61313,6.3417073 L7.62560785,6.19097672 Z'
              id='Fill-1'
            ></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const MostPopularOptionStarGreen = (props) => {
  return (
    <SvgIcon
      width='13px'
      height='13px'
      viewBox='0 0 13 13'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <g
        id='1300s-SignUp'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='D21312c2_SignUp3-NewPricing-Storefront'
          transform='translate(-866.000000, -246.000000)'
          fill={props.fill}
        >
          <g id='Group-2' transform='translate(866.000000, 245.000000)'>
            <path
              d='M5.8265143,1.27194422 C6.15239448,0.909351928 6.71725345,0.909351928 7.04313363,1.27194422 L7.04313363,1.27194422 L7.32556311,1.57054963 C7.56454191,1.82649713 7.93387277,1.890484 8.25975295,1.76251025 L8.25975295,1.76251025 L8.65080916,1.59187859 C9.10704141,1.39991797 9.62844969,1.63453651 9.75880176,2.10377358 L9.75880176,2.10377358 L9.88915383,2.50902379 C9.97605521,2.82895816 10.28021,3.0635767 10.6278156,3.08490566 L10.6278156,3.08490566 L11.0623225,3.10623462 C11.5402801,3.12756358 11.9096109,3.5754717 11.8227095,4.04470878 L11.8227095,4.04470878 L11.7575335,4.44995898 C11.6923575,4.79122231 11.8661602,5.11115669 12.1703151,5.28178835 L12.1703151,5.28178835 L12.5396459,5.47374897 C12.9741528,5.70836751 13.1045049,6.26292043 12.8220754,6.64684167 L12.8220754,6.64684167 L12.5830966,6.988105 C12.3658432,7.26538146 12.3658432,7.64930271 12.5830966,7.92657916 L12.5830966,7.92657916 L12.8438008,8.24651354 C13.1262302,8.63043478 13.0176035,9.18498769 12.5830966,9.41960623 L12.5830966,9.41960623 L12.1920404,9.5902379 C11.8878856,9.76086957 11.7140828,10.1021329 11.7792588,10.4433962 L11.7792588,10.4433962 L11.8661602,10.8486464 C11.9530616,11.3178835 11.6054561,11.7657916 11.1057732,11.7869073 L11.1057732,11.7869073 L10.6929916,11.8084495 C10.3453861,11.8297785 10.0412312,12.064397 9.95432986,12.4056604 L9.95432986,12.4056604 L9.84570314,12.8109106 C9.71535107,13.2799344 9.19394279,13.5360952 8.73771054,13.3441345 L8.73771054,13.3441345 L8.34665433,13.1948318 C8.02077415,13.0666448 7.65144329,13.1521739 7.41246449,13.4081214 L7.41246449,13.4081214 L7.13003501,13.7280558 C6.80415483,14.0906481 6.23929586,14.0906481 5.91341568,13.7280558 L5.91341568,13.7280558 L5.6309862,13.4294504 C5.3920074,13.1732896 5.02267654,13.109516 4.69679636,13.2374897 L4.69679636,13.2374897 L4.30574015,13.4081214 C3.8495079,13.5998687 3.32809962,13.3654635 3.19774755,12.8962264 L3.19774755,12.8962264 L3.08912083,12.4909762 C3.00221945,12.1710418 2.69806461,11.9364233 2.35045909,11.9150943 L2.35045909,11.9150943 L1.93767754,11.8935521 C1.45971995,11.8724364 1.09038908,11.4245283 1.17729046,10.9552912 L1.17729046,10.9552912 L1.2424665,10.550041 C1.30764253,10.2087777 1.13383977,9.88884331 0.829684939,9.71821165 L0.829684939,9.71821165 L0.460354073,9.52625103 C0.0258471721,9.29163249 -0.104504898,8.73707957 0.177924588,8.35315833 L0.177924588,8.35315833 L0.416903383,8.011895 C0.634156834,7.73461854 0.634156834,7.35069729 0.416903383,7.07342084 L0.416903383,7.07342084 L0.156199243,6.75348646 C-0.126230243,6.36956522 -0.017603518,5.81501231 0.416903383,5.58039377 L0.416903383,5.58039377 L0.786234249,5.36710418 C1.09038908,5.19647252 1.26419184,4.85520919 1.17729046,4.55660377 L1.17729046,4.55660377 L1.09038908,4.15135357 C1.0034877,3.68211649 1.35109322,3.23420837 1.85077616,3.21287941 L1.85077616,3.21287941 L2.26355771,3.19155045 C2.61116323,3.17022149 2.91531807,2.93560295 3.00221945,2.59433962 L3.00221945,2.59433962 L3.11084617,2.18908942 C3.24119824,1.71985234 3.76260652,1.46390484 4.21883877,1.65586546 L4.21883877,1.65586546 L4.60989498,1.80516817 C4.93577516,1.93314192 5.30510602,1.84782609 5.54408482,1.59187859 L5.54408482,1.59187859 Z M6.88028704,4.27454499 C6.7560669,3.908485 6.25918637,3.908485 6.11426288,4.27454499 L6.11426288,4.27454499 L5.36894207,6.19097672 L3.38141992,6.3417073 C3.00875952,6.36324024 2.86383603,6.85849788 3.15368301,7.11689317 L3.15368301,7.11689317 L4.66502798,8.45193549 L4.18885079,10.454499 C4.08533401,10.8418766 4.49940113,11.1435531 4.80995147,10.9282237 L4.80995147,10.9282237 L6.50762664,9.8300437 L8.20530181,10.9282237 C8.51585214,11.1220201 8.9092159,10.8418766 8.82640248,10.454499 L8.82640248,10.454499 L8.3502253,8.45193549 L9.86157026,7.11689317 C10.1307139,6.85849788 9.9857904,6.36324024 9.61313,6.3417073 L9.61313,6.3417073 L7.62560785,6.19097672 Z'
              id='Fill-1'
            ></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const Morning = (props) => {
  return (
    <SvgIcon
      viewBox='0 0 22 13'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      style={{ height: '20px', width: '27px' }}
      {...props}
    >
      <title>Icons/Morning</title>
      <defs>
        <path
          d='M10.9865854,7 C13.2134146,7 15.0109756,8.81900452 15.0109756,11.0723982 C15.0109756,11.1451312 15.0084,11.2175113 15.004161,11.2895928 L15.004161,11.2895928 L21.154878,11.2895928 C22.2817073,11.2895928 22.2817073,13 21.154878,13 L21.154878,13 L0.845121951,13 C-0.281707317,13 -0.281707317,11.2895928 0.845121951,11.2895928 L0.845121951,11.2895928 L6.99495366,11.2895928 C6.99125122,11.2175113 6.98902439,11.1451312 6.98902439,11.0723982 C6.98902439,8.81900452 8.78658537,7 10.9865854,7 Z M18.252344,3.31953193 C19.2147754,2.3571005 20.6428995,3.78522456 19.6804681,4.74765599 L19.6804681,4.74765599 L16.7310814,7.69704264 C15.7996962,8.6284279 14.3715721,7.20030384 15.3029574,6.26891858 L15.3029574,6.26891858 Z M2.30295736,4.74765599 C1.3715721,3.78522456 2.79969616,2.3571005 3.73108142,3.31953193 L3.73108142,3.31953193 L6.68046807,6.26891858 C7.6428995,7.20030384 6.21477544,8.6284279 5.25234401,7.69704264 L5.25234401,7.69704264 Z M10,0.974811083 C10,-0.324937028 12,-0.324937028 12,0.974811083 L12,0.974811083 L12,5.02518892 C12,6.32493703 10,6.32493703 10,5.02518892 L10,5.02518892 Z'
          id='path-1'
        ></path>
      </defs>
      <g
        id='7000s-Operations'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='PRO_D7125_RoutingList-Truck'
          transform='translate(-632.000000, -368.000000)'
        >
          <g id='Color/Blue' transform='translate(632.000000, 368.000000)'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <use id='Mask' fill='#278ADA' xlinkHref='#path-1'></use>
            <g id='Group' mask='url(#mask-2)' fill='#466B88'>
              <g id='Color/Blue'>
                <rect
                  id='Rectangle-11'
                  x='0'
                  y='0'
                  width='22'
                  height='13'
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const StarIcon = (props) => {
  return (
    <SvgIcon
      width='18px'
      height='18px'
      viewBox='0 0 18 18'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <title>Color/Blue</title>
      <defs>
        <polygon
          id='path-1'
          points='9 -6.7239992e-15 6.87540697 6.87541022 2.39808173e-14 6.8753806 5.5623106 11.1246194 3.43771757 18 9 13.7507908 14.5622824 18 12.4376894 11.1246194 18 6.87541022 11.124593 6.87541022'
        ></polygon>
      </defs>
      <g
        id='1300s-SignUp'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='D21312c2_SignUp3-NewPricing-Yearly'
          transform='translate(-953.000000, -427.000000)'
        >
          <g id='Color/Blue' transform='translate(953.000000, 427.000000)'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <use id='Mask' fill='#278ADA' xlinkHref='#path-1'></use>
            <g id='Group' mask='url(#mask-2)' fill='#278ADA'>
              <g id='Color/Blue'>
                <rect
                  id='Rectangle-11'
                  x='0'
                  y='0'
                  width='18'
                  height='18'
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const PickListSubRentalArrow = (props) => {
  return (
    <SvgIcon
      width='30px'
      height='23px'
      viewBox='0 0 30 23'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='400s-Events'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='D20452_PickList_Update-ThumbView-Partial'
          transform='translate(-232.000000, -774.000000)'
        >
          <g id='Group-3' transform='translate(232.000000, 774.000000)'>
            <path
              id='Line'
              d='M19,13 L28,17.5 L19,22 L19,18 L0,18 L0,17 L19,17 L19,13 Z'
              fill='#8FA9BE'
              fillRule='nonzero'
            ></path>
            <line
              x1='0.5'
              y1='0.5'
              x2='0.5'
              y2='17.5'
              id='Line-2'
              stroke='#8FA9BE'
              stroke-linecap='square'
            ></line>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const CsvExport = (props) => {
  return (
    <SvgIcon
      viewBox='0 0 17 17'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g id='_x32_000s-Contacts'>
        <g
          id='PRO-D2050_Companies'
          transform='translate(-1276.000000, -204.000000)'
        >
          <g id='Group-3' transform='translate(1276.000000, 204.363636)'>
            <path
              id='Fill-1'
              class='st0'
              d='M14.3,5.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.1-0.1-0.1l-2.5-2.6c-0.1-0.1-0.2-0.1-0.3,0
            c0,0-0.1,0.1-0.1,0.1v2.2c0,0.3,0.3,0.6,0.6,0.6H14.3z'
            />
            <path
              id='Combined-Shape'
              class='st0'
              d='M9.9,1.8c0.2,0,0.4,0.2,0.4,0.4l0,0v2.4c0,1,0.8,1.8,1.8,1.8l0,0h2.4
            c0.2,0,0.4,0.2,0.4,0.4l0,0v9.8c0,0.4-0.4,0.8-0.8,0.8l0,0H5.8c-0.4,0-0.8-0.4-0.8-0.8l0,0v-1.2l7,0c0.5,0,0.9-0.4,1-0.9l0-0.1
            v-5c0-0.6-0.4-1-1-1l0,0l-7,0V2.6c0-0.4,0.3-0.8,0.7-0.8l0.1,0H9.9z'
            />
            <g class='st1'>
              <path
                class='st2'
                d='M3.5,13.3c-0.1,0.2-0.3,0.4-0.6,0.5S2.4,14,2,14c-0.4,0-0.7-0.1-0.9-0.2c-0.3-0.2-0.5-0.4-0.6-0.7
              s-0.2-0.7-0.2-1.1v-0.3c0-0.4,0.1-0.8,0.2-1.1S0.8,10,1.1,9.8S1.7,9.6,2,9.6c0.3,0,0.6,0.1,0.9,0.2s0.4,0.3,0.6,0.5
              c0.1,0.2,0.2,0.5,0.2,0.8H2.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.6-0.2c-0.3,0-0.5,0.1-0.6,0.3s-0.2,0.5-0.2,1v0.3
              c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.1,0.3,0.3,0.4s0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6h0.9
              C3.7,12.8,3.6,13,3.5,13.3z'
              />
              <path
                class='st2'
                d='M4.9,11.8c-0.2-0.1-0.4-0.3-0.5-0.4S4.3,11,4.3,10.8s0.1-0.4,0.2-0.6C4.6,10,4.8,9.8,5,9.7s0.5-0.1,0.8-0.1
              c0.3,0,0.6,0.1,0.8,0.2s0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.4,0.2,0.7H6.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2
              c-0.1,0-0.3,0-0.4,0.1s-0.2,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.3,0.2,0.6,0.3
              c0.5,0.1,0.8,0.3,1.1,0.5c0.2,0.2,0.4,0.5,0.4,0.8c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.4S6.2,14,5.9,14
              c-0.3,0-0.6-0.1-0.8-0.2s-0.5-0.3-0.6-0.5c-0.2-0.2-0.2-0.5-0.2-0.8h0.9c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2
              c0.2,0,0.4,0,0.5-0.1s0.2-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3s-0.1-0.1-0.2-0.2s-0.3-0.1-0.5-0.2C5.4,12,5.2,11.9,4.9,11.8z'
              />
              <path
                class='st2'
                d='M11.6,9.6l-1.5,4.3H9.4H9.1L7.7,9.6h1l0.9,3.2l0.9-3.2H11.6z'
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const Contacts = (props) => {
  return (
    <SvgIcon
      {...props}
      width='14px'
      height='17px'
      viewBox='0 0 14 17'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='PRO-D20056_NAV-Admin-DropDown'
        transform='translate(-774.000000, -537.000000)'
        fillRule='nonzero'
      >
        <g id='Group' transform='translate(774.000000, 537.000000)'>
          <g
            id='Shape'
            transform='translate(7.000000, 8.500000) scale(-1, 1) rotate(-180.000000) translate(-7.000000, -8.500000) '
          >
            <path d='M1.26139781,16.9593701 C0.968362805,16.8962361 0.732587514,16.7633227 0.493444003,16.5274012 C0.250932275,16.2881569 0.119571755,16.0588811 0.0555756045,15.756503 C-0.0185252015,15.4142507 -0.0185252015,2.01989356 0.0555756045,1.67764132 C0.186936124,1.0695621 0.628172741,0.508002593 1.187297,0.235529934 C1.71273908,-0.0203285375 1.26476603,-0.00371435098 7.81595092,0.00293132362 C13.6732828,0.0128998355 13.676651,0.0128998355 13.7675929,0.0826794188 C13.8181162,0.119230629 13.892217,0.19233305 13.9292674,0.242175609 L14,0.331892216 L14,7.4394412 L14,14.5469902 L13.9292674,14.6367068 C13.892217,14.6865493 13.8181162,14.7596518 13.7675929,14.796203 C13.6800192,14.8626597 13.6227595,14.8659826 12.7706003,14.8759511 L11.8645495,14.8859196 L11.8544448,15.7797628 C11.8443402,16.6204406 11.840972,16.6769289 11.7736076,16.7633227 C11.7365572,16.8131652 11.6624564,16.8862676 11.6119331,16.9228188 C11.5209912,16.9925984 11.5108866,16.9925984 6.49560929,16.9992441 C2.36280524,17.0025669 1.43317695,16.9959213 1.26139781,16.9593701 Z M10.7833514,15.4142507 L10.7833514,14.8825967 L6.152051,14.8825967 C1.08625045,14.8825967 1.38602189,14.8693054 1.20750632,15.0786441 C0.985203898,15.3411483 1.08625045,15.7631486 1.40286299,15.899385 C1.48370023,15.9359362 2.36280524,15.9425818 6.14531457,15.9459047 L10.7833514,15.9459047 L10.7833514,15.4142507 Z M7.46228798,12.7061383 C8.26729219,12.5399964 8.94767232,11.8687833 9.11608324,11.0746252 C9.43943221,9.57602558 8.07867196,8.23359931 6.55960544,8.55259169 C5.94322146,8.68218234 5.37399254,9.11747403 5.09779863,9.66906502 C4.77781788,10.3103726 4.77781788,10.9483574 5.09779863,11.589665 C5.52219415,12.4403113 6.51245038,12.9055086 7.46228798,12.7061383 Z M8.74221099,7.36301594 C9.74930831,7.07060626 10.4296884,6.39274745 10.7058824,5.40918761 C10.7564056,5.23307723 10.7665103,5.05696685 10.7665103,4.35917102 C10.7665103,3.56833574 10.7631421,3.51849318 10.6957777,3.43209941 C10.6587273,3.38225686 10.5846265,3.30915443 10.5341032,3.27260322 C10.4431613,3.20282364 10.422952,3.20282364 7.01094671,3.20282364 C3.59894142,3.20282364 3.57873211,3.20282364 3.48779021,3.27260322 C3.26211957,3.43874509 3.25538313,3.45535928 3.24527848,4.22625753 C3.23180561,4.99051011 3.26211957,5.27295128 3.39011187,5.64843189 C3.64272826,6.37281042 4.30289907,7.03737788 5.01022495,7.27329933 C5.47840731,7.42947268 5.56261278,7.43611836 7.09515217,7.42614985 C8.35486587,7.41950417 8.57043185,7.4128585 8.74221099,7.36301594 Z'></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const CsvDocument = (props) => {
  return (
    <SvgIcon
      {...props}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 15 20'
      style={{ enableBackground: 'new 0 0 15 20' }}
      xmlSpace='preserve'
    >
      <g>
        <g transform='translate(-1276.000000, -204.000000)'>
          <g transform='translate(1276.000000, 204.363636)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M14.3,5.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.1-0.1-0.1l-2.5-2.6c-0.1-0.1-0.2-0.1-0.3,0
				c0,0-0.1,0.1-0.1,0.1v2.2c0,0.3,0.3,0.6,0.6,0.6H14.3z'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M9.9,1.8c0.2,0,0.4,0.2,0.4,0.4l0,0v2.4c0,1,0.8,1.8,1.8,1.8l0,0h2.4
				c0.2,0,0.4,0.2,0.4,0.4l0,0v9.8c0,0.4-0.4,0.8-0.8,0.8l0,0H5.8c-0.4,0-0.8-0.4-0.8-0.8l0,0v-1.2l7,0c0.5,0,0.9-0.4,1-0.9l0-0.1
				v-5c0-0.6-0.4-1-1-1l0,0l-7,0V2.6c0-0.4,0.3-0.8,0.7-0.8l0.1,0H9.9z'
            />
            <g enableBackground='new'>
              <path
                d='M3.5,13.3c-0.1,0.2-0.3,0.4-0.6,0.5S2.4,14,2,14c-0.4,0-0.7-0.1-0.9-0.2c-0.3-0.2-0.5-0.4-0.6-0.7
					s-0.2-0.7-0.2-1.1v-0.3c0-0.4,0.1-0.8,0.2-1.1S0.8,10,1.1,9.8S1.7,9.6,2,9.6c0.3,0,0.6,0.1,0.9,0.2s0.4,0.3,0.6,0.5
					c0.1,0.2,0.2,0.5,0.2,0.8H2.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.6-0.2c-0.3,0-0.5,0.1-0.6,0.3s-0.2,0.5-0.2,1v0.3
					c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.1,0.3,0.3,0.4s0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6h0.9
					C3.7,12.8,3.6,13,3.5,13.3z'
              />
              <path
                d='M4.9,11.8c-0.2-0.1-0.4-0.3-0.5-0.4S4.3,11,4.3,10.8s0.1-0.4,0.2-0.6C4.6,10,4.8,9.8,5,9.7s0.5-0.1,0.8-0.1
					c0.3,0,0.6,0.1,0.8,0.2s0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.4,0.2,0.7H6.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2
					c-0.1,0-0.3,0-0.4,0.1s-0.2,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.3,0.2,0.6,0.3
					c0.5,0.1,0.8,0.3,1.1,0.5c0.2,0.2,0.4,0.5,0.4,0.8c0,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.4S6.2,14,5.9,14
					c-0.3,0-0.6-0.1-0.8-0.2s-0.5-0.3-0.6-0.5c-0.2-0.2-0.2-0.5-0.2-0.8h0.9c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2
					c0.2,0,0.4,0,0.5-0.1s0.2-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3s-0.1-0.1-0.2-0.2s-0.3-0.1-0.5-0.2C5.4,12,5.2,11.9,4.9,11.8z'
              />
              <path d='M11.6,9.6l-1.5,4.3H9.4H9.1L7.7,9.6h1l0.9,3.2l0.9-3.2H11.6z' />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const MapArrowsIn = (props) => {
  return (
    <SvgIcon
      {...props}
      version='1.1'
      width='30px'
      height='30px'
      viewBox='0 0 30 30'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Buttons/btn_SizeDOWN'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <rect
          id='Rectangle-4'
          fill='#5F829C'
          x='0'
          y='0'
          width='30'
          height='30'
          rx='2'
        ></rect>
        <path
          d='M23.5928826,14 L23.5928826,11.6366555 L20.0478276,11.6366555 L26.1089328,5.67402935 L24.4348652,4 L18.3737983,9.96262611 L18.3737983,6.6145292 L16.0104155,6.6145292 L16.0104155,14 L23.5928826,14 Z M6.52646564,16 L6.52646564,18.3633445 L10.0715207,18.3633445 L4.0104155,24.3259707 L5.68448307,26 L11.74555,20.0373739 L11.74555,23.3854708 L14.1089328,23.3854708 L14.1089328,16 L6.52646564,16 Z'
          id='Combined-Shape'
          fill='#FFFFFF'
        ></path>
      </g>
    </SvgIcon>
  );
};

export const MapArrowsOut = (props) => {
  return (
    <SvgIcon
      {...props}
      version='1.1'
      width='30px'
      height='30px'
      viewBox='0 0 30 30'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Buttons/btn_SizeUP'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <rect
          id='Rectangle-4'
          fill='#5F829C'
          x='0'
          y='0'
          width='30'
          height='30'
          rx='2'
        ></rect>
        <path
          d='M18.5264656,4 L18.5264656,6.36334454 L22.0715207,6.36334454 L16.0104155,12.3259707 L17.6844831,14 L23.74555,8.03737389 L23.74555,11.3854708 L26.1089328,11.3854708 L26.1089328,4 L18.5264656,4 Z M11.5928826,26 L11.5928826,23.6366555 L8.04782761,23.6366555 L14.1089328,17.6740293 L12.4348652,16 L6.37379826,21.9626261 L6.37379826,18.6145292 L4.0104155,18.6145292 L4.0104155,26 L11.5928826,26 Z'
          id='Combined-Shape'
          fill='#FFFFFF'
        ></path>
      </g>
    </SvgIcon>
  );
};

export const PaperClip = (props) => {
  return (
    <SvgIcon {...props} width='17px' height='18px' fill='#466B88'>
      <path
        d='M5.61415185,18 C4.11452444,18 2.70470487,17.4131171 1.64437072,16.3474764 C0.58396042,15.2817591 0,13.864884 0,12.3577515 C0,10.8506956 0.58396042,9.43378219 1.64437072,8.36810322 L8.78160129,1.19511537 C9.54845146,0.424427416 10.5680123,0 11.6524831,0 C12.7369919,0 13.7565146,0.424427416 14.5233648,1.19511537 C15.2901769,1.96576506 15.7125289,2.99042842 15.7125289,4.08032649 C15.7125289,5.17026283 15.2901769,6.19492619 14.5233648,6.96557588 L7.37794912,14.1389463 C6.40121735,15.1204897 4.81147753,15.1204897 3.8344412,14.1385637 C2.85744294,13.1565995 2.85744294,11.5589036 3.8344412,10.5769776 L10.4284847,3.95773878 C10.8003935,3.58442784 11.4030464,3.58477219 11.7744603,3.95854226 C12.1459123,4.33231234 12.1455697,4.93794306 11.7736608,5.311254 L5.18003616,11.930072 C4.94556114,12.1657204 4.94556114,12.5498209 5.18041686,12.7858903 C5.294209,12.9001754 5.44546233,12.9631527 5.60638551,12.9631527 C5.76727062,12.9631527 5.91856202,12.9001754 6.03231609,12.785852 L13.1777318,5.61248153 C13.5846653,5.20351149 13.8090136,4.65925115 13.8090136,4.08032649 C13.8090136,3.5014401 13.5846653,2.95717975 13.1773511,2.5478271 C12.7700369,2.13847446 12.2284868,1.91304163 11.6524831,1.91304163 C11.0764413,1.91304163 10.5349292,2.13847446 10.127615,2.5478271 L2.99034638,9.72081496 C2.28951012,10.4251586 1.90351529,11.361669 1.90351529,12.3577515 C1.90351529,13.3538723 2.28951012,14.2903827 2.99034638,14.9947264 C3.69118264,15.69907 4.62299144,16.0869584 5.61415185,16.0869584 C6.60531226,16.0869584 7.53712107,15.69907 8.23795733,14.9947264 L15.375226,7.82173853 C15.7469444,7.44819802 16.3495212,7.44819802 16.7212397,7.82173853 C17.0929201,8.19527904 17.0929201,8.80090976 16.7212397,9.17445027 L9.58393299,16.3474764 C8.52359883,17.4131171 7.11377927,18 5.61415185,18'
        id='path-1'
      ></path>
    </SvgIcon>
  );
};

export const PaintBucket = (props) => {
  return (
    <SvgIcon
      version='1.0'
      width='44px'
      height='42px'
      viewBox='0 0 44 42'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g
        transform='translate(0,42) scale(0.1,-0.1)'
        fill={props.color || '#000000'}
        stroke='none'
      >
        <path
          d='M56 402 c-3 -5 19 -33 49 -62 30 -30 55 -60 55 -66 0 -18 26 -35 44
        -28 25 10 19 43 -9 54 -29 11 -31 22 -10 40 13 10 26 3 80 -45 36 -31 65 -60
        65 -63 0 -4 -14 -15 -31 -24 -22 -13 -53 -18 -114 -18 -122 0 -137 10 -90 60
        23 24 24 28 10 40 -14 11 -22 7 -61 -31 l-44 -43 87 -88 c48 -48 92 -88 98
        -88 6 0 42 32 80 71 39 39 87 78 108 86 l39 16 -98 98 c-54 55 -104 99 -110
        99 -6 0 -21 -11 -34 -25 -29 -31 -41 -31 -70 0 -25 26 -35 30 -44 17z'
        />
        <path
          d='M390 139 c-11 -26 -11 -33 4 -47 15 -15 17 -15 32 0 15 14 15 21 4
        47 -7 17 -16 31 -20 31 -4 0 -13 -14 -20 -31z'
        />
      </g>
    </SvgIcon>
  );
};

export const Info = (props) => {
  return (
    <SvgIcon version='1.0' style={{ height: '25px', width: '27px' }} {...props}>
      <path
        d='M7.53322222,5.51988889 C6.76144444,5.51988889 6.12388889,4.88233333 6.12388889,4.09377778 C6.12388889,3.30522222 6.76144444,2.66766667 7.53322222,2.66766667 C8.32177778,2.66766667 8.95933333,3.30522222 8.95933333,4.09377778 C8.95933333,4.88233333 8.32177778,5.51988889 7.53322222,5.51988889 L7.53322222,5.51988889 Z M8.74122222,11.7444444 C8.74122222,12.1135556 8.42244444,12.4323333 8.05333333,12.4323333 L7.01311111,12.4323333 C6.644,12.4323333 6.32522222,12.1135556 6.32522222,11.7444444 L6.32522222,7.34866667 C6.32522222,6.96277778 6.644,6.66077778 7.01311111,6.66077778 L8.05333333,6.66077778 C8.42244444,6.66077778 8.74122222,6.97955556 8.74122222,7.34866667 L8.74122222,11.7444444 Z M7.55,0 C3.37233333,0 0,3.37233333 0,7.55 C0,11.7276393 3.37233333,15.1 7.55,15.1 C11.7276667,15.1 15.1,11.7276393 15.1,7.55 C15.1,3.37233333 11.7276667,0 7.55,0 L7.55,0 Z'
        id='path-1'
      ></path>
    </SvgIcon>
  );
};

export const InfoCircle = (props) => (
  <SvgIcon
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.53322 5.51989C6.76144 5.51989 6.12389 4.88233 6.12389 4.09378C6.12389 3.30522 6.76144 2.66767 7.53322 2.66767C8.32178 2.66767 8.95933 3.30522 8.95933 4.09378C8.95933 4.88233 8.32178 5.51989 7.53322 5.51989ZM8.74122 11.7444C8.74122 12.1136 8.42244 12.4323 8.05333 12.4323H7.01311C6.644 12.4323 6.32522 12.1136 6.32522 11.7444V7.34867C6.32522 6.96278 6.644 6.66078 7.01311 6.66078H8.05333C8.42244 6.66078 8.74122 6.97956 8.74122 7.34867V11.7444ZM7.55 0C3.37233 0 0 3.37233 0 7.55C0 11.7276 3.37233 15.1 7.55 15.1C11.7277 15.1 15.1 11.7276 15.1 7.55C15.1 3.37233 11.7277 0 7.55 0Z'
      fill='#278ADA'
    />
  </SvgIcon>
);

export const MagicButton = (props) => {
  return (
    <SvgIcon
      width='25px'
      height='26px'
      viewBox='0 0 25 26'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <title>1241FBCE-3E6C-434C-8254-9FFDC2E0B2F5</title>
      <defs>
        <path
          d='M12.489783,24.979566 C5.59186257,24.979566 0,19.3877034 0,12.489783 C0,5.59186257 5.59186257,0 12.489783,0 C19.3877034,0 24.979566,5.59186257 24.979566,12.489783 C24.979566,19.3877034 19.3877034,24.979566 12.489783,24.979566 Z'
          id='path-1'
        ></path>
        <polygon
          id='path-3'
          points='0 0 11.9754 0 11.9754 12.9265289 0 12.9265289'
        ></polygon>
      </defs>
      <g
        id='4000s-Order'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='PRO-D4010_AddItems'
          transform='translate(-1000.000000, -149.000000)'
        >
          <rect fill='#0E2C44' x='0' y='0' width='1360' height='2730'></rect>
          <rect
            id='Rectangle'
            fill='#E5E8E9'
            x='130'
            y='100'
            width='1100'
            height='500'
            rx='2'
          ></rect>
          <g
            id='List/Bar-Copy-3'
            transform='translate(150.000000, 142.000000)'
            fill='#C1CDD7'
          >
            <rect id='Rectangle-6' x='0' y='0' width='1065' height='40'></rect>
          </g>
          <g
            id='Buttons/btn_Helper-Blue'
            transform='translate(1000.000000, 149.500000)'
          >
            <g id='Color/Purple' transform='translate(0.000000, 0.000000)'>
              <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-1'></use>
              </mask>
              <use id='Mask' fill='#966CB8' xlinkHref='#path-1'></use>
              <g mask='url(#mask-2)' fill='#278ADA' id='Rectangle-11'>
                <rect x='0' y='0' width='25' height='25'></rect>
              </g>
            </g>
            <g id='Group-6' transform='translate(4.000000, 4.031925)'>
              <g id='Group-3'>
                <mask id='mask-4' fill='white'>
                  <use xlinkHref='#path-3'></use>
                </mask>
                <g id='Clip-2'></g>
                <path
                  d='M6.27485652,0.183771661 L8.18411739,3.95198827 C8.21416087,4.0112157 8.25933478,4.05997744 8.31420435,4.09240704 L11.8051174,6.15325903 C12.0321609,6.28729513 12.0321609,6.63923375 11.8051174,6.77322292 L8.31420435,8.83412184 C8.25933478,8.86655144 8.21416087,8.91526625 8.18411739,8.97458755 L6.27485652,12.7427572 C6.15072609,12.9877861 5.82468261,12.9877861 5.7005087,12.7427572 L3.7912913,8.97458755 C3.76124783,8.91526625 3.71607391,8.86655144 3.66120435,8.83412184 L0.170247826,6.77322292 C-0.0567521739,6.63923375 -0.0567521739,6.28729513 0.170247826,6.15325903 L3.66120435,4.09240704 C3.71607391,4.05997744 3.76124783,4.0112157 3.7912913,3.95198827 L5.7005087,0.183771661 C5.82468261,-0.0612572202 6.15072609,-0.0612572202 6.27485652,0.183771661'
                  id='Fill-1'
                  fill='#FFFFFF'
                  mask='url(#mask-4)'
                ></path>
              </g>
              <path
                d='M12.7600976,9.1222988 L13.8093782,11.0408563 C13.8365969,11.0905522 13.8775128,11.1314678 13.9272527,11.1586864 L15.8457754,12.207962 C16.0514082,12.3204362 16.0514082,12.6157576 15.8457754,12.7281878 L13.9272527,13.7775073 C13.8775128,13.804682 13.8365969,13.8455976 13.8093782,13.8953374 L12.7600976,15.813851 C12.647623,16.0194829 12.3523441,16.0194829 12.2398694,15.813851 L11.1905889,13.8953374 C11.1633702,13.8455976 11.1224543,13.804682 11.0727144,13.7775073 L9.15419169,12.7281878 C8.94860277,12.6157576 8.94860277,12.3204362 9.15419169,12.207962 L11.0727144,11.1586864 C11.1224543,11.1314678 11.1633702,11.0905522 11.1905889,11.0408563 L12.2398694,9.1222988 C12.3523441,8.91666694 12.647623,8.91666694 12.7600976,9.1222988'
                id='Fill-4'
                fill='#FFFFFF'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const Recurring = (props) => (
  <SvgIcon width='13px' height='18px' viewBox='0 0 13 18' {...props}>
    <title>Recurring</title>
    <defs>
      <path
        id='recurring-icon-path'
        d='M13,13.3475538 L13,6.29781996 C13,6.0561148 12.7413925,5.91512012 12.5623565,6.0561148 L10.4338179,7.68762464 C10.3542464,7.74805093 10.2945677,7.84876142 10.2945677,7.9494719 L10.2945677,13.2065592 L8.54399388,13.2065592 L4.60520275,13.2065592 L4.60520275,11.3937705 C4.60520275,11.2124916 4.40627391,11.1117811 4.26702372,11.2124916 L0.0895179801,14.415085 C-0.0298393267,14.4956534 -0.0298393267,14.6769322 0.0895179801,14.7575006 L4.26702372,17.960094 C4.40627391,18.0608045 4.60520275,17.960094 4.60520275,17.7788151 L4.60520275,15.9660264 L8.54399388,15.9660264 L10.413925,15.9660264 C11.8462127,16.0264527 13,14.8179269 13,13.3475538 M8.39479725,6.63325393 L8.39479725,4.82954782 L4.45600612,4.82954782 L2.70543229,4.82954782 L2.70543229,10.0602955 C2.70543229,10.1605014 2.66564652,10.2607073 2.5661821,10.3208309 L0.437643458,11.9441664 C0.258607498,12.0844546 0,11.9441664 0,11.7036722 L0,4.68925957 C0,3.2262535 1.1537873,2.02378277 2.58607498,2.02378277 L4.45600612,2.02378277 L8.39479725,2.02378277 L8.39479725,0.22007666 C8.39479725,0.0397060498 8.59372609,-0.060499845 8.73297628,0.0397060498 L12.910482,3.2262535 C13.0298393,3.30641822 13.0298393,3.48678883 12.910482,3.56695355 L8.73297628,6.753501 C8.59372609,6.91383043 8.39479725,6.81362454 8.39479725,6.63325393'
      />
    </defs>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(0, 0)'>
        <mask id='recurring-icon-mask' fill='white'>
          <use xlinkHref='#recurring-icon-path' />
        </mask>
        <use fill='#278ADA' xlinkHref='#recurring-icon-path' />
      </g>
    </g>
  </SvgIcon>
);

export const Lock = (props) => (
  <SvgIcon
    version='1.0'
    xmlns='http://www.w3.org/2000/svg'
    width='512.000000pt'
    height='512.000000pt'
    viewBox='0 0 512.000000 512.000000'
    preserveAspectRatio='xMidYMid meet'
    {...props}
  >
    <g
      transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
      //fill='#e0e5e9'
      stroke='none'
    >
      <path
        d='M2372 5109 c-222 -24 -457 -104 -644 -220 -341 -211 -611 -549 -721
          -904 -64 -206 -77 -342 -77 -822 l0 -371 -102 -4 c-86 -2 -112 -7 -160 -30
          -68 -31 -133 -95 -168 -164 l-25 -49 0 -1150 0 -1150 26 -50 c35 -66 101 -130
          169 -163 l55 -27 1835 0 1835 0 55 27 c68 33 134 97 169 163 l26 50 0 1150 0
          1150 -25 49 c-35 69 -100 133 -168 164 -48 23 -74 28 -159 30 l-103 4 0 371
          c0 480 -13 616 -77 822 -110 355 -380 693 -721 904 -291 181 -651 258 -1020
          220z m363 -704 c180 -32 357 -128 491 -266 117 -122 188 -246 237 -414 19 -64
          21 -105 24 -502 l4 -433 -931 0 -931 0 4 433 c4 471 4 475 70 634 86 210 302
          420 518 503 150 58 343 75 514 45z'
      />
    </g>
  </SvgIcon>
);
export const CreditCard = (props) => (
  <SvgIcon
    width='148px'
    height='148px'
    viewBox='0 0 148 148'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Fill 1</title>
    <g
      id='TG-Admin'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D0700_TapGoodsSignUp'
        transform='translate(-953.000000, -62.000000)'
        fill='#278ADA'
      >
        <path
          d='M1070.07938,129.472966 C1067.28734,129.472966 1066.16362,129.256172 1066.16362,133.388316 C1066.16362,137.706483 1062.64793,141.221346 1058.32978,141.221346 C1054.01116,141.221346 1050.49593,137.706483 1050.49593,133.388316 C1050.49593,129.070615 1054.01116,125.555286 1058.32978,125.555286 C1061.11622,125.555286 1062.24553,125.77208 1062.24553,121.639936 C1062.24553,117.321769 1065.76076,113.806906 1070.07938,113.806906 C1074.39799,113.806906 1077.91322,117.321769 1077.91322,121.639936 C1077.91322,125.958103 1074.39986,129.472966 1070.07938,129.472966 L1070.07938,129.472966 Z M1070.07938,108.585663 C1063.30024,108.585663 1057.71243,113.778 1057.0783,120.39232 C1050.46469,121.02452 1045.27415,126.611749 1045.27415,133.388316 C1045.27415,140.585883 1051.13146,146.442589 1058.32978,146.442589 C1065.10891,146.442589 1070.69672,141.250252 1071.33085,134.635931 C1077.94446,134.007461 1083.135,128.420232 1083.135,121.639936 C1083.135,114.442369 1077.27909,108.585663 1070.07938,108.585663 L1070.07938,108.585663 Z M1093.48952,125.874183 L1016.86697,202.484119 C1013.90894,205.445574 1008.74916,205.445574 1005.79113,202.484119 L983.687021,180.386031 L1071.38354,92.698612 L1093.48579,114.796699 C1096.54034,117.852798 1096.54034,122.822746 1093.48765,125.87698 L1093.48952,125.874183 Z M960.503955,146.126023 L1037.1265,69.5160874 C1040.08454,66.5546322 1045.24431,66.5546322 1048.20234,69.5160874 L1054.63923,75.9504455 L966.942712,163.637865 L960.505821,157.201642 C957.453135,154.149273 957.453135,149.179324 960.505821,146.125091 L960.503955,146.126023 Z M1067.69533,89.0042526 L979.998806,176.691672 L970.635123,167.32896 L1058.33164,79.6415413 L1067.69533,89.0042526 Z M1097.18333,111.10234 L1051.89475,65.825924 C1046.82404,60.7538726 1038.56216,60.6955946 1033.43316,65.825924 L956.815274,142.431197 C951.728242,147.523297 951.728242,155.804368 956.815274,160.892737 L1002.10198,206.172883 C1007.20207,211.27757 1015.46535,211.273841 1020.56358,206.172883 L1097.18612,129.562948 C1102.27129,124.474578 1102.27129,116.193507 1097.18612,111.101408 L1097.18333,111.10234 Z'
          id='Fill-1'
        ></path>
      </g>
    </g>
  </SvgIcon>
);
export const Eye = (props) => (
  <SvgIcon width='25px' height='26px' viewBox='0 0 25 26' {...props}>
    <g
      id='PRO-D6980_Settings_Print'
      transform='translate(-696.000000, -382.000000)'
    >
      <g id='Group' transform='translate(639.000000, 382.000000)'>
        <g
          id='Buttons/btn_CancelBg-Copy-2'
          transform='translate(57.000000, 0.000000)'
        >
          <rect
            id='Rectangle-4'
            fill='#966CB8'
            x='0'
            y='0'
            width='30'
            height='30'
            rx='2'
          ></rect>
          <path
            d='M15,19.2856349 C12.7922006,19.2856349 11.0000648,17.3656016 11.0000648,15.0000694 C11.0000648,12.6343984 12.7922006,10.7142262 15,10.7142262 C17.2077994,10.7142262 18.9999352,12.6343984 18.9999352,15.0000694 C18.9999352,17.3656016 17.2077994,19.2856349 15,19.2856349 M15,9 C10.581161,9 7,15.0000694 7,15.0000694 C7,15.0000694 10.581161,21 15,21 C19.418839,21 23,15.0000694 23,15.0000694 C23,15.0000694 19.418839,9 15,9'
            id='Fill-1'
            fill='#FFFFFF'
          ></path>
          <path
            d='M15,17 C13.896171,17 13,16.1040639 13,15.0001175 C13,13.8960536 13.896171,13 15,13 C16.103829,13 17,13.8960536 17,15.0001175 C17,16.1040639 16.103829,17 15,17'
            id='Fill-4'
            fill='#FFFFFF'
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);
export const Sparkle = (props) => (
  <SvgIcon
    width='151px'
    height='152px'
    viewBox='0 0 151 152'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Combined Shape</title>
    <g
      id='0000s-Global'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D0500_ImportWizard'
        transform='translate(-1019.000000, -64.000000)'
        fill={props.fill}
      >
        <path
          d='M1095.72702,145 L1095.72757,148.228153 C1095.72757,164.241949 1108.75875,177.27323 1124.77243,177.27323 L1128,177.27323 L1128,183.72677 L1124.77077,183.727876 C1108.75709,183.727876 1095.72591,196.758881 1095.72591,212.772954 L1095.72647,216 L1089.27243,216 L1089.27243,212.7724 C1089.27243,196.758604 1076.24125,183.727323 1060.22757,183.727323 L1057,183.727323 L1057,177.272677 L1060.22813,177.272677 C1076.2418,177.272677 1089.27298,164.241396 1089.27298,148.2276 L1089.27298,145 L1095.72702,145 Z M1128.4994,203 C1130.43301,203 1132,204.567921 1132,206.5 C1132,208.432079 1130.43301,210 1128.4994,210 C1126.56699,210 1125,208.432079 1125,206.5 C1125,204.567921 1126.56699,203 1128.4994,203 Z M1092.50055,163.004905 C1088.95376,170.719001 1082.72101,176.952628 1075.00615,180.499723 C1082.72074,184.047095 1088.95321,190.280722 1092.49972,197.994818 C1096.04734,190.280722 1102.28148,184.047095 1109.99579,180.5 C1102.28175,176.952628 1096.04817,170.719001 1092.50055,163.004905 Z M1141,105.501881 C1138.23285,100.151192 1133.8486,95.7669025 1128.49824,92.9997238 C1133.8486,90.2325451 1138.23257,85.8485319 1140.99945,80.498119 C1143.7666,85.8485319 1148.15085,90.2328213 1153.50121,93 C1148.15112,95.7671787 1143.76688,100.151468 1141,105.501881 L1141,105.501881 Z M1170,89.7771026 L1166.77741,89.7771026 C1166.77244,89.7771026 1166.76747,89.7771026 1166.7625,89.7771026 C1154.33696,89.7693692 1144.2306,79.6631873 1144.22121,67.2375356 C1144.22121,67.2325641 1144.22149,67.2275926 1144.22149,67.2226212 L1144.22149,64 L1144.22093,64 L1137.77741,64 L1137.77686,64 L1137.77686,67.2226212 C1137.77686,67.2275926 1137.77713,67.2322879 1137.77713,67.2372594 C1137.76912,79.6626349 1127.66276,89.7693692 1115.23723,89.7771026 C1115.23226,89.7771026 1115.22756,89.7771026 1115.22259,89.7771026 L1112,89.7771026 L1112,89.777655 L1112,89.777655 L1112,96.2228974 L1115.22149,96.2228974 C1115.22646,96.2228974 1115.2317,96.2226212 1115.23695,96.2226212 C1127.66746,96.2303546 1137.77741,106.344822 1137.77741,118.777379 L1137.77851,122 L1144.22259,122 L1144.22259,118.777379 C1144.22259,106.354765 1154.3168,96.2472024 1166.73377,96.222345 C1166.74813,96.222345 1166.7625,96.2228974 1166.77686,96.2228974 L1170,96.2228974 L1170,96.2212402 L1170,96.2212402 L1170,89.7771026 Z M1032.50056,157 C1028.91071,157 1026,159.909595 1026,163.499443 C1026,167.08929 1028.91071,170 1032.50056,170 C1036.0904,170 1039,167.08929 1039,163.499443 C1039,159.909595 1036.0904,157 1032.50056,157 M1103.5,124 C1105.43208,124 1107,122.43301 1107,120.5006 C1107,118.56699 1105.43208,117 1103.5,117 C1101.56792,117 1100,118.56699 1100,120.5006 C1100,122.43301 1101.56792,124 1103.5,124 M1047.5,203 C1045.56792,203 1044,204.567921 1044,206.5 C1044,208.432079 1045.56792,210 1047.5,210 C1049.43208,210 1051,208.432079 1051,206.5 C1051,204.567921 1049.43208,203 1047.5,203 M1144.50056,152 C1140.91071,152 1138,154.909845 1138,158.5 C1138,162.090155 1140.91071,165 1144.50056,165 C1148.0904,165 1151,162.090155 1151,158.5 C1151,154.909845 1148.0904,152 1144.50056,152 M1051.20057,115 L1057.8,115 L1057.8,101.8 L1071,101.8 L1071,95.2005657 L1057.8,95.2005657 L1057.8,82 L1051.20057,82 L1051.20057,95.2005657 L1038,95.2005657 L1038,101.8 L1051.20057,101.8 L1051.20057,115 Z M1051,71 L1058,71 L1058,64 L1051,64 L1051,71 Z M1082,102 L1089,102 L1089,95 L1082,95 L1082,102 Z M1051,134 L1058,134 L1058,127 L1051,127 L1051,134 Z M1019,102 L1026,102 L1026,95 L1019,95 L1019,102 Z'
          id='Combined-Shape'
        ></path>
      </g>
    </g>
  </SvgIcon>
);

export const UploadCloud = (props) => (
  <SvgIcon width='250px' height='150px' viewBox='0 0 200 150' {...props}>
    <g
      id='0000s-Global'
      stroke='none'
      strokeWidth='1'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      fillRule='evenodd'
    >
      <g
        id='PRO-D0515_AddInventoryWizard-Uploading'
        transform='translate(-584.000000, -344.000000)'
        fill='#278ADA'
      >
        <path
          d='M694.628788,418.910097 L676.393939,400.581536 L676.393939,444 L667.606845,444 L667.605276,400.581536 L649.370427,418.690745 L643,412.800966 L672.000785,384 L701,412.800966 L694.628788,418.910097 Z M737.653012,397.721249 L732.597596,397.721249 C729.299544,367.461542 702.700809,344 671.708074,344 C639.613895,344 612.796913,368.557894 610.598735,399.913953 C594.771856,405.17566 584,420.08683 584,436.750598 C584,458.458759 601.585814,476 623.34738,476 L737.65262,476 C759.414971,476 777,458.457976 777,436.750598 C777,415.042436 759.415756,397.720466 737.656545,397.720466 L737.653012,397.721249 Z'
          id='Fill-1'
        ></path>
      </g>
    </g>
  </SvgIcon>
);

export const GreenUploadCloud = (props) => (
  <SvgIcon width='193px' height='132px' viewBox='0 0 193 132' {...props}>
    <g
      id='0000s-Global'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D0516_AddInventoryWizard-Done'
        transform='translate(-584.000000, -344.000000)'
        fill='#54C06E'
      >
        <path
          d='M671.708074,344 C702.700809,344 729.299544,367.461542 732.597596,397.721249 L737.653012,397.721249 C759.415756,397.720466 777,415.042436 777,436.750598 C777,458.457976 759.414971,476 737.65262,476 L623.34738,476 C601.585814,476 584,458.458759 584,436.750598 C584,420.08683 594.771856,405.17566 610.598735,399.913953 C612.796913,368.557894 639.613895,344 671.708074,344 Z M695.363636,399.571429 L664.818182,430.848901 L650.636364,416.343407 L643,424.276099 L664.818182,446.714286 L703,407.504121 L695.363636,399.571429 Z'
          id='Combined-Shape'
        ></path>
      </g>
    </g>
  </SvgIcon>
);

export const MaintenanceIcon = (props) => (
  <SvgIcon
    width='18px'
    height='18px'
    viewBox='0 0 18 18'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>555CA094-E2C8-4C84-B611-1E90FAA6C6F4</title>
    <defs>
      <path
        d='M12.2825668,8.84352575 L16.6469398,13.2078988 L13.2078593,16.6469793 L8.84348626,12.2825734 L9.65785553,11.468237 L13.2078593,15.0182408 L15.0182013,13.2078988 L13.674,11.863 L12.6205881,12.9177511 L11.8062189,12.1034148 L12.86,11.049 L11.4681646,9.65786211 L12.2825668,8.84352575 Z M1.84791637,11.4763185 L5.17064434,14.7990465 L0.872410642,15.7745193 L1.84791637,11.4763185 Z M9.49822942,3.72528285 L12.92168,7.14873344 L6.17747576,13.8929377 L2.75405807,10.4694871 L9.49822942,3.72528285 Z M3.43904763,0 L7.80345356,4.36440593 L6.98908429,5.1787752 L5.56,3.749 L4.50224226,4.80782241 L3.68787299,3.99348605 L4.746,2.935 L3.43904763,1.62870563 L1.62870563,3.43908053 L5.17874229,6.98911719 L4.36437302,7.80348646 L-2.88657986e-14,3.43908053 L3.43904763,0 Z M12.3511049,0.872440257 L15.7745226,4.29585794 L14.0502275,6.02018591 L10.6267769,2.59673532 L12.3511049,0.872440257 Z'
        id='path-1'
      ></path>
    </defs>
    <g
      id='3000s-Inventory'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D3101_Inventory-Calendar-Items-DateSelected'
        transform='translate(-712.000000, -268.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='1660'></rect>
        <rect
          id='Rectangle-5'
          fill='#FFFFFF'
          x='465'
          y='200'
          width='725'
          height='1350'
        ></rect>
        <g id='Group-4' transform='translate(485.000000, 220.000000)'>
          <g
            id='SplashIcon/Icon_Draft'
            transform='translate(227.000000, 48.000000)'
          >
            <g id='Color/Blue' transform='translate(0.450010, 0.450000)'>
              <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-1'></use>
              </mask>
              <use id='Mask' fill='#278ADA' xlinkHref='#path-1'></use>
              <g mask='url(#mask-2)' fill='#278ADA' id='Rectangle-11'>
                <g transform='translate(-0.450010, -0.450000)'>
                  <rect x='0' y='0' width='18' height='18'></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CalendarDropOffPickUp = (props) => (
  <SvgIcon
    width='16px'
    height='20px'
    viewBox='0 0 16 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <title>6F5D0DF2-CAD8-42DB-8E45-3A792328531F</title>
    <defs>
      <rect id='path-2' x='0' y='0' width='16' height='20' rx='2'></rect>
      <polygon
        id='path-3'
        points='3.2 0 6.4 4.57142857 1.13686838e-15 4.57142857'
      ></polygon>
    </defs>
    <g
      id='70000-Operations-DropOff-PickUp'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70010-Operations-Routing-CalendarFiltered-DropOff-PickUp'
        transform='translate(-741.000000, -170.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='900'></rect>
        <g
          id='Color/MidGray'
          transform='translate(170.000000, 160.000000)'
          fill='#C1CDD7'
        >
          <rect id='Rectangle-3' x='0' y='0' width='1020' height='80'></rect>
        </g>
        <g
          id='Group-4'
          transform='translate(653.000000, 170.000000)'
          opacity='0.496924264'
        >
          <g
            id='Routing/DropOff-Copy-5'
            transform='translate(88.000000, 0.000000)'
          >
            <g id='Color/Pink'>
              <mask id='mask-3' fill='white'>
                <use xlinkHref='#path-2'></use>
              </mask>
              <use id='Mask-calendar' fill='#D3347F' xlinkHref='#path-2'></use>
              <g mask='url(#mask-3)' fill='#466B88' id='Rectangle-11'>
                <rect x='0' y='0' width='16' height='20'></rect>
              </g>
            </g>
            <g
              id='Buttons/icon_SortDown-Orange'
              transform='translate(8.320000, 5.714286) scale(1, -1) translate(-8.320000, -5.714286) translate(5.120000, 3.428571)'
            >
              <g id='Color/Orange' transform='translate(0.000000, 0.000000)'>
                <mask id='mask-4' fill='white'>
                  <use
                    xlinkHref='#path-3'
                    transform='translate(3.200000, 2.285714) rotate(180.000000) translate(-3.200000, -2.285714) '
                  ></use>
                </mask>
                <use
                  id='Mask-calendar'
                  fill='#FF886D'
                  transform='translate(3.200000, 2.285714) rotate(180.000000) translate(-3.200000, -2.285714) '
                  xlinkHref='#path-3'
                ></use>
                <g mask='url(#mask-4)' fill='#C1CDD7' id='Rectangle-3'>
                  <g transform='translate(0.000000, 0.000000)'>
                    <polygon
                      style={{ fill: 'white' }}
                      points='0 0 6.4 0 6.4 3.37972734 6.4 4.57142857 0 4.57142857'
                    ></polygon>
                  </g>
                </g>
              </g>
            </g>
            <text
              id='1'
              fontFamily='Heebo-Regular, Heebo'
              fontSize='10'
              fontWeight='normal'
            ></text>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ServiceHashIcon = (props) => (
  <SvgIcon
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnslink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Routing/Service-Calendar Copy 6</title>
    <defs>
      <polygon
        id='path-4'
        points='10.0002778 0 7.87503355 2.06516605 5.00013888 1.33998759 4.19196829 4.19107229 1.34003722 4.99921295 2.06598331 7.87400113 0 10.0006481 2.06598331 12.1258136 1.34003722 14.9991203 4.19196829 15.8087424 5.00013888 18.6598271 7.87503355 17.9331672 10.0002778 19.9983333 12.1262627 17.9331672 14.9996759 18.6598271 15.8078465 15.8087424 18.6605183 14.9991203 17.9345722 12.1258136 19.9998148 10.0006481 17.9345722 7.87400113 18.6605183 4.99921295 15.8078465 4.19107229 14.9996759 1.33998759 12.1262627 2.06516605'
      ></polygon>
    </defs>
    <g
      id='70000-Operations-Service-Hash'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      opacity='0.496924264'
    >
      <g
        id='PRO-D70010-Operations-Routing-CalendarFiltered-Service-Hash'
        transform='translate(-820.000000, -170.000000)'
      >
        <g id='Group-4' transform='translate(653.000000, 170.000000)'>
          <g
            id='Routing/Service-Calendar-Copy-6'
            transform='translate(167.000000, 0.000463)'
          >
            <g id='Color/Blue'>
              <mask id='mask-2' fill='white'>
                <use xlinkHref='#path-4'></use>
              </mask>
              <use id='Mask' fill='#278ADA' xlinkHref='#path-4'></use>
              <g mask='url(#mask-2)' fill='#466B88' id='Rectangle-12'>
                <g transform='translate(0.000000, -0.000370)'>
                  <rect
                    x='0'
                    y='0'
                    width='19.9998148'
                    height='19.999074'
                  ></rect>
                </g>
              </g>
            </g>
            <text
              id='1'
              font-family='Heebo-Regular, Heebo'
              font-size='10'
              font-weight='normal'
              fill='#C1CDD7'
            >
              <tspan x='7.31640758' y='13.3995185'>
                #
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const RoutingFilterIcon = (props) => (
  <SvgIcon
    width='15px'
    height='15px'
    viewBox='0 0 15 15'
    version='1.1'
    {...props}
  >
    <title>67870C24-0BFE-4A9B-A820-53855A935279</title>
    <defs>
      <path
        d='M14.8531668,0.000233165584 L0.146499291,0.000233165584 C0.0884453349,0.000233165584 0.0321992871,0.0356077156 0.0115422564,0.0897687497 C-0.0109561627,0.141931222 0.000293046885,0.203486936 0.0378238919,0.246422713 L5.59848227,6.03659034 L5.59848227,11.8544047 C5.59848227,11.8637647 5.60226549,11.8749566 5.60410688,11.8841833 C5.60789009,11.8935433 5.60789009,11.9009712 5.60973148,11.9103312 C5.60973148,11.9141284 5.60973148,11.9141284 5.6135147,11.9141284 C5.6135147,11.9178924 5.61729792,11.9197244 5.61729792,11.9197244 C5.62854713,11.9402763 5.64361303,11.955099 5.66048685,11.9700549 C5.66611145,11.9738521 5.66989467,11.9756509 5.67551927,11.9794148 C5.6961763,11.9906068 5.71867472,12 5.74482244,12 C5.76547947,12 5.78603606,11.994404 5.80290987,11.9850108 L5.80669309,11.9850108 L9.31068795,10.3267038 L9.31631255,10.3229399 C9.32193716,10.3191759 9.32572038,10.31358 9.33134498,10.3117479 C9.3407528,10.306152 9.35200201,10.300556 9.35762662,10.2911961 C9.36703444,10.2856001 9.36887583,10.2762401 9.37450043,10.2688122 C9.37828365,10.2594522 9.38390825,10.2538563 9.38953286,10.2446296 C9.39334955,10.2334376 9.39334955,10.2240444 9.39515746,10.2128524 C9.39515746,10.2034925 9.39897416,10.1978965 9.39897416,10.1923005 L9.39870632,6.03629056 L14.9613735,0.24812149 C14.9989043,0.205185714 15.0119615,0.143663309 14.9876551,0.0914675275 C14.9669981,0.0355410968 14.910752,0 14.8526981,0 L14.8531668,0.000233165584 Z'
        id='path-9'
      ></path>
    </defs>
    <g
      id='70000-Operations-routing-filter'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70010-Operations-Routing-CalendarFiltered-Filter'
        transform='translate(-1118.000000, -173.000000)'
      >
        <g id='List/Bar' transform='translate(170.000000, 160.000000)'>
          <g id='Color/MidGray'>
            <rect id='Rectangle-3' x='0' y='0' width='1020' height='80'></rect>
          </g>
          <g
            id='Buttons/Filter-OFF'
            transform='translate(930.000000, 5.000000)'
          >
            <rect
              id='Rectangle-2'
              x='0'
              y='0'
              width='85'
              height='30'
              rx='2'
            ></rect>
            <g id='Buttons/Filter' transform='translate(18.000000, 8.000000)'>
              <g id='Color/Blue' transform='translate(0.000000, 1.000000)'>
                <mask id='mask-5' fill='white'>
                  <use
                    xlinkHref='#path-9'
                    transform='translate(7.500000, 6.000000) scale(-1, 1) translate(-7.500000, -6.000000) '
                  ></use>
                </mask>
                <use
                  id='Mask'
                  transform='translate(7.500000, 6.000000) scale(-1, 1) translate(-7.500000, -6.000000) '
                  xlinkHref='#path-9'
                ></use>
                <g mask='url(#mask-5)' fill='#FFFFFF' id='Rectangle-3'>
                  <g transform='translate(0.000000, -2.000000)'>
                    <polygon points='0 0 15 0 15 11.0897303 15 15 0 15'></polygon>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const MapScaleSmall = (props) => (
  <SvgIcon
    width='15px'
    height='15px'
    viewBox='0 0 15 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Scale-Small@2x</title>
    <defs>
      <path
        d='M9,6 L9,15 L0,15 L0,6 L9,6 Z M12,3 L12,15 L10,15 L10,5 L0,5 L0,3 L12,3 Z M15,0 L15,15 L13,15 L13,2 L0,2 L0,0 L15,0 Z'
        id='path-12'
      ></path>
    </defs>
    <g
      id='Icons/Scale-Small'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-12'></use>
        </mask>
        <use id='Mask' fill='#8FA9BE' xlinkHref='#path-12'></use>
        <g mask='url(#mask-2)' fill='#0E2C44' id='Rectangle-11'>
          <g transform='translate(-6.000000, 6.000000)'>
            <rect x='0' y='0' width='15' height='15'></rect>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const MapScaleMedium = (props) => (
  <SvgIcon
    width='15px'
    height='15px'
    viewBox='0 0 15 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Scale-Medium</title>
    <defs>
      <path
        d='M9,6 L9,15 L0,15 L0,6 L9,6 Z M12,3 L12,15 L10,15 L10,5 L0,5 L0,3 L12,3 Z M15,0 L15,15 L13,15 L13,2 L0,2 L0,0 L15,0 Z'
        id='path-12'
      ></path>
    </defs>
    <g
      id='Icons/Scale-Medium'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-12'></use>
        </mask>
        <use id='Mask' fill='#8FA9BE' xlinkHref='#path-12'></use>
        <g mask='url(#mask-2)' fill='#0E2C44' id='Rectangle-11'>
          <g transform='translate(-2.000000, 2.000000)'>
            <rect x='0' y='0' width='15' height='15'></rect>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const MapScaleLarge = (props) => (
  <SvgIcon
    width='15px'
    height='15px'
    viewBox='0 0 15 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Scale-Large</title>
    <defs>
      <path
        d='M9,6 L9,15 L0,15 L0,6 L9,6 Z M12,3 L12,15 L10,15 L10,5 L0,5 L0,3 L12,3 Z M15,0 L15,15 L13,15 L13,2 L0,2 L0,0 L15,0 Z'
        id='path-12'
      ></path>
    </defs>
    <g
      id='Icons/Scale-Large'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-12'></use>
        </mask>
        <use id='Mask' fill='#0E2C44' xlinkHref='#path-12'></use>
        <g mask='url(#mask-2)' fill='#0E2C44' id='Rectangle-11'>
          <rect x='0' y='0' width='15' height='15'></rect>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Sort = (props) => (
  <SvgIcon
    width='15px'
    height='15px'
    viewBox='0 0 15 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnXlink='http://www.w3.org/1999/xlink'
  >
    <title>Mask</title>
    <defs>
      <path
        d='M0,0 L15,0 L15,3 L0,3 Z M0,6 L10,6 L10,9 L0,9 Z M0,12 L5,12 L5,15 L0,15 Z'
        id='path-3'
      ></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-3' fill='white'>
          <use xlinkHref='#path-3'></use>
        </mask>
        <use id='Mask3' fill='#0E2C44' xlinkHref='#path-3'></use>
      </g>
    </g>
  </SvgIcon>
);

export const AssignedDropOff = (props) => (
  <SvgIcon
    width='18px'
    height='35px'
    viewBox='0 0 18 35'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>D38D4307-569C-42DB-840D-ED480D7B8C18</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,3.34059457e-16 18,0.8954305 18,2 L18,26.8911081 C18,27.5013996 17.7213502,28.0782935 17.2433157,28.4576859 L9,35 L9,35 L0.756684281,28.4576859 C0.27864978,28.0782935 2.93519133e-15,27.5013996 0,26.8911081 L0,2 C-3.57315355e-16,0.8954305 0.8954305,-1.91384796e-17 2,0 Z'
        id='path-1'
      ></path>
      <polygon id='path-3' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70210-Operations-Routing-Orders'
        transform='translate(-530.000000, -284.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='1400'></rect>
        <rect
          id='Rectangle'
          fill='#FFFFFF'
          x='170'
          y='200'
          width='1020'
          height='1090'
        ></rect>
        <g
          id='Routing/Pin-Copy-24'
          transform='translate(530.000000, 284.000000)'
        >
          <g id='Color/Blue'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <use id='Mask' fill='#2655BE' xlinkHref='#path-1'></use>
            <g mask='url(#mask-2)' fill={`${props.color}`} id='Rectangle-11'>
              <rect x='0' y='0' width='18' height='35'></rect>
            </g>
            <text
              id='XX'
              mask='url(#mask-2)'
              fontFamily='Heebo-Regular, Heebo'
              fontSize='10'
              fontWeight='normal'
            ></text>
          </g>
          <g
            id='Buttons/icon_SortDown-Orange'
            transform='translate(4.000000, 17.000000)'
          >
            <g id='Color/Orange' transform='translate(-0.000000, 0.000000)'>
              <mask id='mask-4' fill='white'>
                <use
                  xlinkHref='#path-3'
                  transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                ></use>
              </mask>
              <use
                id='Mask'
                fill='#FF886D'
                transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                xlinkHref='#path-3'
              ></use>
              <g mask='url(#mask-4)' fill='#FFFFFF' id='Rectangle-3'>
                <g transform='translate(0.000000, 0.000000)'>
                  <polygon points='0 0 10 0 10 5.91452284 10 8 0 8'></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const AssignedPickUp = (props) => (
  <SvgIcon
    width='18px'
    height='35px'
    viewBox='0 0 18 35'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>442B245A-0248-4FA3-A884-F4EC84329804</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,3.34059457e-16 18,0.8954305 18,2 L18,26.8911081 C18,27.5013996 17.7213502,28.0782935 17.2433157,28.4576859 L9,35 L9,35 L0.756684281,28.4576859 C0.27864978,28.0782935 2.93519133e-15,27.5013996 0,26.8911081 L0,2 C-3.57315355e-16,0.8954305 0.8954305,-1.91384796e-17 2,0 Z'
        id='path-1'
      ></path>
      <path d='M100,100 h200 a20,20 0 0 1 20,20 v200 a20,20 0 0 1 -20,20 h-200 a20,20 0 0 1 -20,-20 v-200 a20,20 0 0 1 20,-20 z' />
      <polygon id='path-3' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70210-Operations-Routing-Orders'
        transform='translate(-530.000000, -474.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='1400'></rect>
        <rect
          id='Rectangle'
          fill='#FFFFFF'
          x='170'
          y='200'
          width='1020'
          height='1090'
        ></rect>
        <path
          d='M1169.5,260.5 L1169.5,739.5 L190.5,739.5 L190.5,260.5 L1169.5,260.5 Z'
          id='Mask'
          stroke='#C1CDD7'
        ></path>
        <g
          id='Routing/Pin-Copy-32'
          transform='translate(530.000000, 474.000000)'
        >
          <mask id='mask-2' fill='white'>
            <use xlinkHref='#path-1'></use>
          </mask>
          <use id='Mask' fill='#278ADA' xlinkHref='#path-1'></use>
          <g id='Color/Blue' mask='url(#mask-2)' fill={`${props.color}`}>
            <rect id='Rectangle-11' x='0' y='0' width='18' height='35'></rect>
          </g>
          <text
            id='XX'
            mask='url(#mask-2)'
            font-family='Heebo-Regular, Heebo'
            font-size='10'
            font-weight='normal'
          ></text>
          <g id='Buttons/icon_SortDown-Orange' mask='url(#mask-2)'>
            <g
              transform='translate(9.000000, 20.000000) scale(1, -1) translate(-9.000000, -20.000000) translate(4.000000, 16.000000)'
              id='Color/Orange'
            >
              <g transform='translate(-0.000000, 0.000000)'>
                <mask id='mask-4' fill='white'>
                  <use
                    xlinkHref='#path-3'
                    transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                  ></use>
                </mask>
                <use
                  id='Mask'
                  fill='#FF886D'
                  transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                  xlinkHref='#path-3'
                ></use>
                <g mask='url(#mask-4)' fill='#FFFFFF' id='Rectangle-3'>
                  <g transform='translate(0.000000, 0.000000)'>
                    <polygon points='0 0 10 0 10 5.91452284 10 8 0 8'></polygon>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const RedirectIcon = (props) => (
  <SvgIcon
    width='25px'
    height='25px'
    viewBox='0 0 25 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>E8B4F75E-B9EE-4603-AA89-ABAEADA8B595</title>
    <defs>
      <path
        d='M7.36307284,0 C11.5484276,0 14.9475793,3.30648514 14.9994019,7.40455261 C15.0515995,11.5181557 11.6807115,14.9309798 7.49228833,14.9989484 C3.98335457,15.0559683 1.00423843,12.7882299 0.0479073776,9.66090712 C-0.167054024,8.95832005 0.368320898,8.25061022 1.11535012,8.25061022 L7.17109066,8.24994058 C7.56821522,8.24994058 7.76718663,8.72156856 7.48632192,8.99725966 L6.27759447,10.1837961 C6.00924218,10.4474672 5.98234218,10.8583922 6.1971672,11.151494 L6.27759447,11.2445071 C6.54608314,11.5080442 6.9646527,11.5344615 7.26297344,11.3236251 L7.35765192,11.2445071 L10.6306566,8.03023145 C10.8991453,7.7665604 10.925943,7.35563535 10.7112543,7.0625336 L10.6306566,6.9695205 L7.37469882,3.77198591 C7.0757303,3.47838192 6.58495007,3.45929716 6.28301539,3.75002169 C6.00961721,4.01342488 5.98097842,4.42789902 6.19713311,4.72297622 L6.27756038,4.81598932 L7.48536729,6.00158827 C7.76612973,6.27727937 7.56729469,6.74877342 7.17027241,6.74890735 L1.11555469,6.7490078 C0.367502647,6.7490078 -0.166815367,6.03999217 0.048521066,5.3364676 C0.969974165,2.32767125 3.76372232,0.114943835 7.1004824,0.00411829062 L7.36307284,0 Z'
        id='path-15'
      ></path>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay-0001-0002'
        transform='translate(-595.000000, -791.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row-0001-0002'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-34'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-3' transform='translate(190.000000, 595.000000)'>
          <path
            d='M479.5,40.5 L479.5,559.5 L0.5,559.5 L0.5,40.5 L479.5,40.5 Z'
            id='Mask-0001-0002'
            stroke='#00744C'
          ></path>
          <g
            id='Row/Routing/TruckTab/Expanded-0001-0002'
            transform='translate(1.000000, 160.000000)'
          ></g>
        </g>
        <g
          id='Buttons/Square-w-Icon-Copy-2'
          transform='translate(595.000000, 791.000000)'
        >
          <g id='Form/Button-BG-0001-0002' fill='#278ADA'>
            <rect
              id='Rectangle-0001-0002'
              x='0'
              y='0'
              width='25'
              height='30'
              rx='2'
            ></rect>
          </g>
          <g
            id='Color-Blue-0001-0002'
            transform='translate(5.000000, 5.000000)'
          >
            <mask id='0001-0002' fill='white'>
              <use xlinkHref='#path-15'></use>
            </mask>
            <use id='Mask-0001-0002' fill='white' xlinkHref='#path-15'></use>
            <g mask='url(#0001-0002)' fill='#FFFFFF' id='Rectangle-34'>
              <polygon points='0 0 15 0 15 11.0897303 15 15 0 15'></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const DeliveryTruckIcon = ({ backgroundFill = '#278ADA', ...props }) => (
  <SvgIcon
    width='25px'
    height='25px'
    viewBox='0 0 30 30'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Assign to Truck / Change Truck Assignment</title>
    <defs>
      <path
        id='path-66'
        d='m 0.0522399,2.4168092 v 5.292287 c 0,0.2302 0.1921611,0.41682 0.4292231,0.41682 H 0.483011 7.67878 c 0.23464,-0.00325 0.42314,-0.1889 0.42314,-0.41682 v -5.292287 c 0,-0.230197 -0.19222,-0.416793 -0.42928,-0.416793 H 7.67112 0.481463 c -0.237037,0 -0.4292231,0.186596 -0.4292231,0.416793 M 11.4424,10.106076 c -0.5446,0.0088 -0.9839,0.43531 -0.9928,0.96412 0.0016,0.53177 0.4452,0.96252 0.9928,0.96412 0.5446,-0.0087 0.9839,-0.43533 0.9929,-0.96412 -0.0017,-0.53179 -0.4452,-0.9625 -0.9929,-0.96412 m -5.25755,-0.0015 c -0.54456,0.0087 -0.98387,0.43533 -0.99286,0.96412 0,0.53247 0.4445,0.96412 0.99286,0.96412 0.5484,0 0.99288,-0.43165 0.99288,-0.96412 0,-0.53245 -0.44448,-0.96412 -0.99288,-0.96412 m 8.07585,1.50551 h -0.9165 c -0.2461,0.82173 -1.0205,1.38763 -1.9018,1.38983 -0.8856,0.0065 -1.66649,-0.5623 -1.90785,-1.38983 H 8.10192 c -0.2469,0.82433 -1.0253,1.39093 -1.90939,1.38983 -0.88615,0.0072 -1.66792,-0.5618 -1.90938,-1.38983 H 0.73475 C 0.329811,11.610936 8.23655e-4,11.292836 0,10.899626 v -0.003 -1.3660898 c 0.00227129,-0.32772 0.230947,-0.61305 0.557539,-0.69568 v -0.01333 H 8.25464 c 0.31214,0 0.56515,-0.24573 0.56515,-0.54883 v -4.64113 c -8e-4,-0.22854 0.18929,-0.41449 0.42466,-0.41533 H 9.246 9.51471 c 0.41577,0.00247 0.80599,0.19546 1.05249,0.52064 0.0198,0.01929 0.0397,0.05785 0.0596,0.07712 l 1.5274,2.23826 1.0769,0.14835 c 0.6392,0.08536 1.115,0.61643 1.1136,1.24294 v 1.83629 c 0.3711,0.04586 0.6507,0.35024 0.6553,0.71345 v 0.9033398 c 8e-4,0.39319 -0.3267,0.71262 -0.7317,0.71345 -0.0025,0 -0.0051,0 -0.0076,-3e-5'
        transform='scale(1.25 1.45) translate(-2 -4)'
      />
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-630.000000, -791.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-3'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-2' transform='translate(190.000000, 595.000000)'>
          <path
            d='M479.5,40.5 L479.5,559.5 L0.5,559.5 L0.5,40.5 L479.5,40.5 Z'
            id='Mask-35'
            stroke='#00744C'
          ></path>
          <g
            id='Row/Routing/TruckTab/Expanded'
            transform='translate(1.000000, 160.000000)'
          ></g>
        </g>
        <g
          id='Buttons/Square-w-Icon-Copy'
          transform='translate(630.000000, 791.000000)'
        >
          <g id='Form/Button-BG' fill={backgroundFill}>
            <rect
              id='Rectangle-2'
              x='0'
              y='0'
              width='30'
              height='30'
              rx='2'
            ></rect>
          </g>
          <g id='Icons/Calendar' transform='translate(8.000000, 8.000000)'>
            <g id='Color/White' transform='translate(0.000000, 2.250000)'>
              <mask id='mask-24' fill='white'>
                <use xlinkHref='#path-66'></use>
              </mask>
              <use id='Mask-35' fill='#FFFFFF' xlinkHref='#path-66'></use>
              <g mask='url(#mask-24)' fill='#FFFFFF' id='Rectangle-3'>
                <g transform='translate(0.000000, -0.750000)'>
                  <polygon points='0 0 15 0 15 8.31729775 15 11.25 0 11.25'></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const TeamMemberIcon = ({ backgroundFill = "#278ADA", ...props }) => (
  <SvgIcon
    width='25px'
    height='25px'
    viewBox='0 0 25 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>Assign or edit Delivery Team</title>
    <defs>
      <path
        id='path-15'
        d='m 10.57963,3.51832 c 0,2.22016 -1.37852,4.02018 -3.07956,4.02018 C 5.7995,7.5385 4.42106,5.73848 4.42106,3.51832 4.42106,1.29747 5.7995,0 7.50007,0 c 1.70079,0 3.07956,1.2977 3.07956,3.51832 z m -2.99249,4.4025 c 3.06909,0 5.59196,1.03806 5.89216,3.95578 0.0058,0.0596 0.0119,0.4726 0.017,0.8128 0.0014,0.0894 0.0026,0.1738 0.0038,0.2455 C 11.8549,14.2542 9.81481,15 7.50006,15 5.15991,15.0004 3.15266,14.2803 1.500081,12.9349 H 1.4999 c 0.00179,-0.099 0.00364,-0.2224 0.00554,-0.3498 0.00471,-0.3153 0.00979,-0.6549 0.015307,-0.7085 C 1.820616,8.95888 4.34397,7.92082 7.41259,7.92082 c 0.01701,0 0.03347,6.1e-4 0.04992,0.00122 0.01244,4.7e-4 0.02488,9.3e-4 0.03755,0.00112 C 7.51253,7.92297 7.525,7.92251 7.53749,7.92205 7.55403,7.92143 7.57059,7.92082 7.58714,7.92082 Z'
      />
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay-0001-0002'
        transform='translate(-595.000000, -791.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row-0001-0002'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-34'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-3' transform='translate(190.000000, 595.000000)'>
          <path
            d='M479.5,40.5 L479.5,559.5 L0.5,559.5 L0.5,40.5 L479.5,40.5 Z'
            id='Mask-0001-0002'
            stroke='#00744C'
          ></path>
          <g
            id='Row/Routing/TruckTab/Expanded-0001-0002'
            transform='translate(1.000000, 160.000000)'
          ></g>
        </g>
        <g
          id='Buttons/Square-w-Icon-Copy-2'
          transform='translate(595.000000, 791.000000)'
        >
          <g id='Form/Button-BG-0001-0002' fill={backgroundFill}>
            <rect
              id='Rectangle-0001-0002'
              x='0'
              y='0'
              width='25'
              height='30'
              rx='2'
            ></rect>
          </g>
          <g
            id='Color-Blue-0001-0002'
            transform='translate(5.000000, 5.000000)'
          >
            <mask id='0001-0002' fill='white'>
              <use xlinkHref='#path-15'></use>
            </mask>
            <use id='Mask-0001-0002' fill='white' xlinkHref='#path-15'></use>
            <g mask='url(#0001-0002)' fill='#FFFFFF' id='Rectangle-34'>
              <polygon points='0 0 15 0 15 11.0897303 15 15 0 15'></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const BlueCheckButton = (props) => (
  <SvgIcon
    width='25px'
    height='25px'
    viewBox='0 0 30 30'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>1D8308D3-B0C5-49A7-8110-5D5FE2BA68F4</title>
    <defs>
      <polygon
        id='path-16'
        points='0 6.08910394 2.09970356 3.98723419 5.44996003 7.19956086 12.9975188 -1.99840144e-14 15 1.94856939 5.35281523 11.25 2.77008052 8.75983025'
      ></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-630.000000, -791.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-3'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-2' transform='translate(190.000000, 595.000000)'>
          <path
            d='M479.5,40.5 L479.5,559.5 L0.5,559.5 L0.5,40.5 L479.5,40.5 Z'
            id='Mask-35'
            stroke='#00744C'
          ></path>
          <g
            id='Row/Routing/TruckTab/Expanded'
            transform='translate(1.000000, 160.000000)'
          ></g>
        </g>
        <g
          id='Buttons/Square-w-Icon-Copy'
          transform='translate(630.000000, 791.000000)'
        >
          <g id='Form/Button-BG' fill='#278ADA'>
            <rect
              id='Rectangle-2'
              x='0'
              y='0'
              width='30'
              height='30'
              rx='2'
            ></rect>
          </g>
          <g id='Icons/Calendar' transform='translate(8.000000, 8.000000)'>
            <g id='Color/White' transform='translate(0.000000, 2.250000)'>
              <mask id='mask-24' fill='white'>
                <use xlinkHref='#path-16'></use>
              </mask>
              <use id='Mask-35' fill='#FFFFFF' xlinkHref='#path-16'></use>
              <g mask='url(#mask-24)' fill='#FFFFFF' id='Rectangle-3'>
                <g transform='translate(0.000000, -0.750000)'>
                  <polygon points='0 0 15 0 15 8.31729775 15 11.25 0 11.25'></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const UnassignedDropOffIcon = (props) => (
  <SvgIcon
    width='18px'
    height='25px'
    viewBox='0 0 18 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>150EC489-B5AF-4993-BA12-810A21D04B3B</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z'
        id='path-30'
      ></path>
      <polygon id='path-34' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-701.000000, -560.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-3'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-5' transform='translate(690.000000, 550.000000)'>
          <g
            id='Lines/Rental-Dividers-Light-Copy-8'
            transform='translate(0.000000, 0.000000)'
            fill='#FF886D'
          >
            <polygon
              id='Rectangle-14-Copy-5'
              points='0 0 480 0 480 40 0 40'
            ></polygon>
          </g>
          <g
            id='Routing/Pin-Copy-29'
            transform='translate(11.000000, 10.000000)'
          >
            <g id='Color/Blue'>
              <mask id='mask-22' fill='white'>
                <use xlinkHref='#path-30'></use>
              </mask>
              <use id='Mask' fill='#278ADA' xlinkHref='#path-30'></use>
              <g mask='url(#mask-22)' fill='#FFFFFF' id='Rectangle-3'>
                <polygon points='0 0 18 0 18 18.4828839 18 25 0 25'></polygon>
              </g>
            </g>
            <g
              id='Buttons/icon_SortDown-Orange'
              transform='translate(4.000000, 7.000000)'
            >
              <g id='Color/Orange' transform='translate(-0.000000, 0.000000)'>
                <mask id='mask-44' fill='white'>
                  <use
                    xlinkHref='#path-34'
                    transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                  ></use>
                </mask>
                <use
                  id='Mask'
                  fill='#FF886D'
                  transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                  xlinkHref='#path-34'
                ></use>
                <g mask='url(#mask-44)' fill='#FF886D' id='Rectangle-3'>
                  <g transform='translate(0.000000, 0.000000)'>
                    <rect x='0' y='0' width='10' height='8'></rect>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const UnassignedPickUpIcon = (props) => (
  <SvgIcon
    width='18px'
    height='25px'
    viewBox='0 0 18 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <title>BB593EA1-4AB7-4000-B664-F4236E92C128</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,-2.02906125e-16 18,0.8954305 18,2 L18,16.8911081 C18,17.5013996 17.7213502,18.0782935 17.2433157,18.4576859 L9,25 L9,25 L0.756684281,18.4576859 C0.27864978,18.0782935 3.62745282e-15,17.5013996 0,16.8911081 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z'
        id='path-19'
      ></path>
      <polygon id='path-39' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-701.000000, -855.000000)'
      >
        <rect fill='#E5E8E9' x='0' y='0' width='1360' height='2300'></rect>
        <g
          id='Row'
          transform='translate(170.000000, 500.000000)'
          fill='#FFFFFF'
        >
          <polygon
            id='Rectangle-3'
            points='0 0 1020 0 1020 1164.42168 1020 1575 0 1575'
          ></polygon>
        </g>
        <g id='Group-5' transform='translate(690.000000, 550.000000)'>
          <g
            id='Lines/Rental-Dividers-Light-Copy-8'
            transform='translate(0.000000, 295.000000)'
            fill='#FF886D'
          >
            <polygon
              id='Rectangle-14-Copy-5'
              points='0 0 480 0 480 40 0 40'
            ></polygon>
          </g>
          <g
            id='Routing/Pin-Copy-40'
            transform='translate(11.000000, 305.000000)'
          >
            <g id='Color/Pink' transform='translate(-0.000000, 0.000000)'>
              <mask id='mask-29' fill='white'>
                <use xlinkHref='#path-19'></use>
              </mask>
              <use id='Mask' fill='#D3347F' xlinkHref='#path-19'></use>
              <g mask='url(#mask-29)' fill='#FFFFFF' id='Rectangle-3'>
                <polygon points='0 0 18 0 18 18.4828839 18 25 0 25'></polygon>
              </g>
            </g>
            <g
              id='Color/Orange'
              transform='translate(9.000000, 10.000000) scale(1, -1) translate(-9.000000, -10.000000) translate(4.000000, 6.000000)'
            >
              <mask id='mask-49' fill='white'>
                <use
                  xlinkHref='#path-39'
                  transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                ></use>
              </mask>
              <use
                id='Mask'
                fill='#FF886D'
                transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                xlinkHref='#path-39'
              ></use>
              <g mask='url(#mask-49)' fill='#FF886D' id='Rectangle-3'>
                <g transform='translate(0.000000, 0.000000)'>
                  <rect x='0' y='0' width='10' height='8'></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const UnassignedServiceIcon = (props) => (
  <SvgIcon
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>ED0064F9-49EF-4563-8E82-0434FDB0F16BSVG</title>
    <defs>
      <path
        d='M10.0003704,0 L7.87510649,2.06529992 L5.00018519,1.34007445 L4.19200711,4.19134396 L1.34004963,4.99953701 L2.06600244,7.87451155 L0,10.0012964 L2.06600244,12.1265996 L1.34004963,15.0000926 L4.19200711,15.8097672 L5.00018519,18.6610367 L7.87510649,17.9343297 L10.0003704,19.9996296 L12.1263751,17.9343297 L14.9998148,18.6610367 L15.8079929,15.8097672 L18.6606911,15.0000926 L17.9347383,12.1265996 L20,10.0012964 L17.9347383,7.87451155 L18.6606911,4.99953701 L15.8079929,4.19134396 L14.9998148,1.34007445 L12.1263751,2.06529992 L10.0003704,0 Z M7.8839957,11.0095005 L4.45868365,8.52121414 L8.69143302,8.52121414 L10.0003704,4.49506454 L11.308567,8.52121414 L15.5420571,8.52121414 L12.1167451,11.0095005 L13.4249417,15.0356501 L10.0003704,12.5473637 L6.57505834,15.0356501 L7.8839957,11.0095005 Z'
        id='path-09'
      ></path>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-700.000000, -1060.000000)'
      >
        <g id='Group-5' transform='translate(690.000000, 550.000000)'>
          <g
            id='Routing/Pin-Copy-41'
            transform='translate(10.000000, 510.000000)'
          >
            <g id='Color/Blue' transform='translate(0.000000, 0.000370)'>
              <mask id='mask-02' fill='white'>
                <use xlinkHref='#path-09'></use>
              </mask>
              <use id='Mask' fill='#278ADA' xlinkHref='#path-09'></use>
              <g mask='url(#mask-02)' fill='#FFFFFF' id='Rectangle-3'>
                <g transform='translate(0.000000, -0.000370)'>
                  <polygon points='0 0 20 0 20 14.7863071 20 20 0 20'></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);
export const AddStopIcon = (props) => (
  <SvgIcon
    width='18px'
    height='35px'
    viewBox='0 0 18 35'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnXlink='http://www.w3.org/1999/xlink'
  >
    <title>D38D4307-569C-42DB-840D-ED480D7B8C18</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,3.34059457e-16 18,0.8954305 18,2 L18,26.8911081 C18,27.5013996 17.7213502,28.0782935 17.2433157,28.4576859 L9,35 L9,35 L0.756684281,28.4576859 C0.27864978,28.0782935 2.93519133e-15,27.5013996 0,26.8911081 L0,2 C-3.57315355e-16,0.8954305 0.8954305,-1.91384796e-17 2,0 Z'
        id='path-1'
      ></path>
      <polygon id='path-3' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70210-Operations-Routing-Orders'
        transform='translate(-530.000000, -284.000000)'
      >
        <rect fill='transparent' x='0' y='0' width='1360' height='1400'></rect>
        <rect
          id='Rectangle'
          fill='transparent'
          x='170'
          y='200'
          width='1020'
          height='1090'
        ></rect>
        <g
          id='Routing/Pin-Copy-24'
          transform='translate(530.000000, 284.000000)'
        >
          <g id='Color/Blue'>
            <mask id='mask-2' fill='white'>
              <use xlinkHref='#path-1'></use>
            </mask>
            <g mask='url(#mask-2)' fill='#FFFFFF' id='Rectangle-11'>
              <rect x='0' y='10' width='18' height='25'></rect>
            </g>
            <text
              id='XX'
              mask='url(#mask-2)'
              font-family='Heebo-Regular, Heebo'
              font-size='10'
              font-weight='normal'
            ></text>
          </g>
          <g
            id='Buttons/icon_SortDown-Orange'
            transform='translate(4.000000, 17.000000)'
          >
            <g id='Color/Orange' transform='translate(-0.000000, 0.000000)'>
              <mask id='mask-4' fill='white'>
                <use
                  xlinkHref='#path-3'
                  transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                ></use>
              </mask>
              <use
                id='Mask'
                fill='#FF886D'
                transform='translate(5.000000, 4.000000) rotate(180.000000) translate(-5.000000, -4.000000) '
                xlinkHref='#path-3'
              ></use>
              <g mask='url(#mask-4)' fill='#FFFFFF' id='Rectangle-3'>
                <g transform='translate(0.000000, 0.000000)'>
                  <polygon points='0 0 10 0 10 5.91452284 10 8 0 8'></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CustomStopIcon = (props) => (
  <SvgIcon
    width='18px'
    height='18px'
    viewBox='0 0 18 18'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnXlink='http://www.w3.org/1999/xlink'
  >
    <title>Fill 1</title>
    <defs>
      <path
        d='M2,0 L16,0 C17.1045695,3.34059457e-16 18,0.8954305 18,2 L18,26.8911081 C18,27.5013996 17.7213502,28.0782935 17.2433157,28.4576859 L9,35 L9,35 L0.756684281,28.4576859 C0.27864978,28.0782935 2.93519133e-15,27.5013996 0,26.8911081 L0,2 C-3.57315355e-16,0.8954305 0.8954305,-1.91384796e-17 2,0 Z'
        id='path-1'
      ></path>
      <polygon id='path-3' points='5 0 10 8 1.77635684e-15 8'></polygon>
    </defs>
    <g
      id='70000-Operations'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70110-Operations-Routing-Trucks'
        transform='translate(-214.000000, -706.900000)'
        fill={`${props.color}`}
      >
        <polygon
          id='Fill-1'
          points='219.272143 706.9 214 712.172143 214 719.627857 219.272143 724.9 226.728292 724.9 232 719.627857 232 712.172143 226.728292 706.9'
        ></polygon>
      </g>
    </g>
  </SvgIcon>
);

export const EyesClosed = (props) => (
  <svg
    width='19.2px'
    height='10.6666667px'
    viewBox='0 0 19.2 10.6666667'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Eye-Closed</title>
    <defs>
      <path
        d='M17.4429746,0.429109775 C17.7385422,-0.0154176909 18.3349436,-0.133792092 18.775127,0.16480401 C19.2153104,0.463358548 19.3324842,1.06591251 19.036752,1.51060624 C18.0316412,3.02266464 16.971276,4.26567898 15.8568908,5.23383029 L16.9110023,7.07756978 C17.1760422,7.54142453 17.0187133,8.13454346 16.5595221,8.40225747 C16.1331626,8.65097672 15.5965412,8.53164635 15.3098192,8.14198342 L15.2481055,8.04734209 L14.2987839,6.3859025 C13.1083673,7.11863506 11.8619147,7.56058555 10.56029,7.70556094 L10.5600021,9.69689436 C10.5600021,10.2325302 10.1302688,10.6666667 9.60006568,10.6666667 C9.10763132,10.6666667 8.7020076,10.2922577 8.64638297,9.809907 L8.6399236,9.69689436 L8.6399236,7.7057272 C7.33829892,7.56071025 6.0916406,7.11863506 4.90110062,6.3859025 L3.95177901,8.04734209 L3.89022985,8.14198342 C3.60334333,8.53164635 3.06672195,8.65097672 2.64036242,8.40225747 C2.18121233,8.13450189 2.02388348,7.54142453 2.28904677,7.07756978 L3.34282914,5.23366404 C2.2284439,4.26551273 1.1682433,3.02249839 0.163132482,1.51060624 C-0.132435103,1.06591251 -0.0152613166,0.463400112 0.42475752,0.16480401 C0.864940926,-0.133792092 1.46138348,-0.0154176909 1.75690992,0.429109775 C4.17275527,4.06322052 6.77958402,5.81913518 9.59990111,5.81913518 C12.4200948,5.81913518 15.0270469,4.06338678 17.4429334,0.429109775 L17.4429746,0.429109775 Z'
        id='path-1'
      ></path>
    </defs>
    <g
      id='70000-Operations-eyes-closed'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-D70310-Operations-Routing-Map-MultiDay'
        transform='translate(-191.400000, -1600.333333)'
      >
        <g id='Color/Blue' transform='translate(191.400000, 1600.333333)'>
          <mask id='mask-2-eye' fill='white'>
            <use xlinkHref='#path-1'></use>
          </mask>
          <use id='Mask' fill='#278ADA' xlinkHref='#path-1'></use>
          <g mask='url(#mask-2-eye)' fill='#8FA9BE' id='Rectangle-11'>
            <g transform='translate(-0.400000, -5.333333)'>
              <rect x='0' y='0' width='20' height='20'></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const PurchaseOrder = (props) => (
  <svg
    width='15px'
    height='19px'
    viewBox='0 0 15 19'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Color/Blue</title>
    <defs>
      <path
        d='M4.61538462,12.4686168 C4.29692308,12.4686168 4.03846154,12.7340164 4.03846154,13.0623519 C4.03846154,13.3906875 4.29692308,13.6560871 4.61538462,13.6560871 L10.3846154,13.6560871 C10.7036538,13.6560871 10.9615385,13.3906875 10.9615385,13.0623519 C10.9615385,12.7340164 10.7036538,12.4686168 10.3846154,12.4686168 L4.61538462,12.4686168 Z M2.88461538,9.49994123 C2.88461538,9.17219944 3.14307692,8.90620611 3.46153846,8.90620611 L11.5384615,8.90620611 C11.8575,8.90620611 12.1153846,9.17219944 12.1153846,9.49994123 C12.1153846,9.82768301 11.8575,10.0936763 11.5384615,10.0936763 L3.46153846,10.0936763 C3.14307692,10.0936763 2.88461538,9.82768301 2.88461538,9.49994123 L2.88461538,9.49994123 Z M3.46153846,5.3437954 C3.14307692,5.3437954 2.88461538,5.60978873 2.88461538,5.93753051 C2.88461538,6.2652723 3.14307692,6.53126563 3.46153846,6.53126563 L11.5384615,6.53126563 C11.8575,6.53126563 12.1153846,6.2652723 12.1153846,5.93753051 C12.1153846,5.60978873 11.8575,5.3437954 11.5384615,5.3437954 L3.46153846,5.3437954 Z M14.6953846,0.0702400692 C14.8828846,0.17354998 15,0.374826185 15,0.593914444 L15,18.405968 C15,18.6286187 14.8794231,18.8322698 14.6873077,18.9343923 C14.4946154,19.035921 14.2638462,19.0181089 14.0878846,18.8886747 L12.6923077,17.8632941 L11.2967308,18.8886747 C11.0959615,19.0371084 10.8271154,19.0371084 10.6263462,18.8886747 L9.23076923,17.8632941 L7.83519231,18.8886747 C7.63442308,19.0371084 7.36557692,19.0371084 7.16480769,18.8886747 L5.76923077,17.8632941 L4.37365385,18.8886747 C4.17288462,19.0371084 3.90403846,19.0371084 3.70326923,18.8886747 L2.30769231,17.8632941 L0.912115385,18.8886747 C0.736153846,19.0181089 0.504807692,19.035921 0.312692308,18.9343923 C0.120576923,18.8322698 0,18.6286187 0,18.405968 L0,0.593914444 C0,0.374826185 0.117115385,0.17354998 0.304615385,0.0702400692 C0.492692308,-0.0330698415 0.72,-0.0217888743 0.897115385,0.0999268251 L2.30769231,1.06771507 L3.71826923,0.0999268251 C3.91211538,-0.0330698415 4.16480769,-0.0330698415 4.35865385,0.0999268251 L5.76923077,1.06771507 L7.17980769,0.0999268251 C7.37365385,-0.0330698415 7.62634615,-0.0330698415 7.82019231,0.0999268251 L9.23076923,1.06771507 L10.6413462,0.0999268251 C10.8351923,-0.0330698415 11.0878846,-0.0330698415 11.2817308,0.0999268251 L12.6923077,1.06771507 L14.1028846,0.0999268251 C14.28,-0.0217888743 14.5073077,-0.0330698415 14.6953846,0.0702400692 L14.6953846,0.0702400692 Z'
        id='path-1000'
      ></path>
    </defs>
    <g
      id='PO-Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='PO-Color/Blue'>
        <mask id='mask-2' fill='white'>
          <use xlinkHref='#path-1000'></use>
        </mask>
        <use id='Mask' fill='#FFFFFF' xlinkHref='#path-1000'></use>
      </g>
    </g>
  </svg>
);

export const PurchaseOrderFilled = (props) => (
  <svg
    width='15px'
    height='19px'
    viewBox='0 0 15 19'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Color/Blue</title>
    <defs>
      <path
        d='M4.61538462,12.4686168 C4.29692308,12.4686168 4.03846154,12.7340164 4.03846154,13.0623519 C4.03846154,13.3906875 4.29692308,13.6560871 4.61538462,13.6560871 L10.3846154,13.6560871 C10.7036538,13.6560871 10.9615385,13.3906875 10.9615385,13.0623519 C10.9615385,12.7340164 10.7036538,12.4686168 10.3846154,12.4686168 L4.61538462,12.4686168 Z M2.88461538,9.49994123 C2.88461538,9.17219944 3.14307692,8.90620611 3.46153846,8.90620611 L11.5384615,8.90620611 C11.8575,8.90620611 12.1153846,9.17219944 12.1153846,9.49994123 C12.1153846,9.82768301 11.8575,10.0936763 11.5384615,10.0936763 L3.46153846,10.0936763 C3.14307692,10.0936763 2.88461538,9.82768301 2.88461538,9.49994123 L2.88461538,9.49994123 Z M3.46153846,5.3437954 C3.14307692,5.3437954 2.88461538,5.60978873 2.88461538,5.93753051 C2.88461538,6.2652723 3.14307692,6.53126563 3.46153846,6.53126563 L11.5384615,6.53126563 C11.8575,6.53126563 12.1153846,6.2652723 12.1153846,5.93753051 C12.1153846,5.60978873 11.8575,5.3437954 11.5384615,5.3437954 L3.46153846,5.3437954 Z M14.6953846,0.0702400692 C14.8828846,0.17354998 15,0.374826185 15,0.593914444 L15,18.405968 C15,18.6286187 14.8794231,18.8322698 14.6873077,18.9343923 C14.4946154,19.035921 14.2638462,19.0181089 14.0878846,18.8886747 L12.6923077,17.8632941 L11.2967308,18.8886747 C11.0959615,19.0371084 10.8271154,19.0371084 10.6263462,18.8886747 L9.23076923,17.8632941 L7.83519231,18.8886747 C7.63442308,19.0371084 7.36557692,19.0371084 7.16480769,18.8886747 L5.76923077,17.8632941 L4.37365385,18.8886747 C4.17288462,19.0371084 3.90403846,19.0371084 3.70326923,18.8886747 L2.30769231,17.8632941 L0.912115385,18.8886747 C0.736153846,19.0181089 0.504807692,19.035921 0.312692308,18.9343923 C0.120576923,18.8322698 0,18.6286187 0,18.405968 L0,0.593914444 C0,0.374826185 0.117115385,0.17354998 0.304615385,0.0702400692 C0.492692308,-0.0330698415 0.72,-0.0217888743 0.897115385,0.0999268251 L2.30769231,1.06771507 L3.71826923,0.0999268251 C3.91211538,-0.0330698415 4.16480769,-0.0330698415 4.35865385,0.0999268251 L5.76923077,1.06771507 L7.17980769,0.0999268251 C7.37365385,-0.0330698415 7.62634615,-0.0330698415 7.82019231,0.0999268251 L9.23076923,1.06771507 L10.6413462,0.0999268251 C10.8351923,-0.0330698415 11.0878846,-0.0330698415 11.2817308,0.0999268251 L12.6923077,1.06771507 L14.1028846,0.0999268251 C14.28,-0.0217888743 14.5073077,-0.0330698415 14.6953846,0.0702400692 L14.6953846,0.0702400692 Z'
        id='path-1123'
      ></path>
    </defs>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Color/Blue'>
        <mask id='mask-2' fill='blue'>
          <use xlinkHref='#path-1123'></use>
        </mask>
        <use id='Mask' fill='#278ada' xlinkHref='#path-1123'></use>
      </g>
    </g>
  </svg>
);

export const ClosedEye = (props) => (
  <svg
    width='14.4px'
    height='8px'
    viewBox='0 0 14.4 8'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Eye-Open Copy</title>
    <defs>
      <path
        d='M13.0822309,0.321832331 C13.3039066,-0.0115632682 13.7512077,-0.100344069 14.0813452,0.123603007 C14.4114828,0.347518911 14.4993631,0.799434385 14.277564,1.13295468 C13.5237309,2.26699848 12.728457,3.19925924 11.8926681,3.92537272 L12.6832517,5.30817734 C12.8820316,5.6560684 12.764035,6.10090759 12.4196416,6.30169311 C12.0998719,6.48823254 11.6974059,6.39873476 11.4823644,6.10648757 L11.4360791,6.03550657 L10.7240879,4.78942688 C9.8312755,5.33897629 8.89643604,5.67043917 7.92021754,5.77917071 L7.92000154,7.27267077 C7.92000154,7.67439766 7.59770163,8 7.20004926,8 C6.83072349,8 6.5265057,7.71919331 6.48478722,7.35743025 L6.4799427,7.27267077 L6.4799427,5.7792954 C5.50372419,5.67053269 4.56873045,5.33897629 3.67582546,4.78942688 L2.96383425,6.03550657 L2.91767239,6.10648757 C2.7025075,6.39873476 2.30004146,6.48823254 1.98027181,6.30169311 C1.63590925,6.10087642 1.51791261,5.6560684 1.71678508,5.30817734 L2.50712186,3.92524803 C1.67133292,3.19913455 0.876182473,2.26687379 0.122349361,1.13295468 C-0.0993263273,0.799434385 -0.0114459875,0.347550084 0.31856814,0.123603007 C0.648705695,-0.100344069 1.09603761,-0.0115632682 1.31768244,0.321832331 C3.12956645,3.04741539 5.08468802,4.36435139 7.19992583,4.36435139 C9.31507108,4.36435139 11.2702852,3.04754008 13.0822001,0.321832331 L13.0822309,0.321832331 Z'
        id='path-156'
      ></path>
    </defs>
    <g
      id='Pinnacle-(PurchaseOrders1)'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-Inventory-POs-Details1'
        transform='translate(-466.300000, -668.000000)'
      >
        <g id='Color/Blue1' transform='translate(466.300000, 668.000000)'>
          <mask id='mask-200' fill='white'>
            <use xlinkHref='#path-156'></use>
          </mask>
          <use id='Mask' fill='#278ADA' xlinkHref='#path-156'></use>
          <g mask='url(#mask-200)' fill='#278ADA' id='Rectangle-111'>
            <g transform='translate(-0.300000, -4.000000)'>
              <rect x='0' y='0' width='15' height='15'></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const OpenEye = (props) => (
  <svg
    width='15px'
    height='11px'
    viewBox='0 0 15 11'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Icons/Eye-Open</title>
    <defs>
      <path
        d='M7.5,3.92847403 C6.6720906,3.92847403 6.00039052,4.63208132 6.00039052,5.49931821 C6.00039052,6.36791868 6.6720906,7.07152597 7.5,7.07152597 C8.3279094,7.07152597 8.99960948,6.36791868 8.99960948,5.49931821 C8.99960948,4.63208132 8.3279094,3.92847403 7.5,3.92847403 L7.5,3.92847403 Z M7.5,2.35762985 C9.15712054,2.35762985 10.5005207,3.76348085 10.5005207,5.49931821 C10.5005207,7.23515557 9.15712054,8.64237015 7.5,8.64237015 C5.84287946,8.64237015 4.4994793,7.23515557 4.4994793,5.49931821 C4.4994793,3.76348085 5.84287946,2.35762985 7.5,2.35762985 L7.5,2.35762985 Z M7.5,1.57084418 C5.37294975,1.57084418 3.39690185,2.82670138 1.55623536,5.41886699 L1.50026035,5.49931821 L1.55623536,5.57976943 C3.33702161,8.08875666 5.24537881,9.34597744 7.29432439,9.4237015 L7.5,9.42779224 C9.62835199,9.42779224 11.6043999,8.17329862 13.4437646,5.57976943 L13.4997397,5.49931821 L13.4437646,5.41886699 C11.6629784,2.90987976 9.75592294,1.65402256 7.70567561,1.57493492 L7.5,1.57084418 Z M7.5,0 C10.2675085,0 12.7304087,1.72083798 14.8730799,5.06160902 C15.0423067,5.32614355 15.0423067,5.67249287 14.8730799,5.93839098 C12.7304087,9.27916202 10.2675085,11 7.5,11 C4.73249154,11 2.26959125,9.27916202 0.126920073,5.93839098 C-0.042306691,5.67249287 -0.042306691,5.32614355 0.126920073,5.06160902 C2.26959125,1.72083798 4.73249154,0 7.5,0 L7.5,0 Z'
        id='path-134'
      ></path>
    </defs>
    <g
      id='Pinnacle-(PurchaseOrders2)'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-Inventory-POs-Details2'
        transform='translate(-466.000000, -636.000000)'
      >
        <g id='Color/Blue' transform='translate(466.000000, 636.000000)'>
          <mask id='open-eye' fill='white'>
            <use xlinkHref='#path-134'></use>
          </mask>
          <use id='Mask' fill='#278ADA' xlinkHref='#path-134'></use>
          <g mask='url(#open-eye)' fill='#278ADA' id='Rectangle-11'>
            <g transform='translate(0.000000, -2.000000)'>
              <rect x='0' y='0' width='15' height='15'></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const MessageBubbleWithDots = (props) => (
  <svg
    width='15.0000036px'
    height='14px'
    viewBox='0 0 15.0000036 14'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>Buttons/MessageBubble Copy 2</title>
    <defs>
      <path
        d='M9.31973,0 L5.6865965,0 C2.54599395,0 1.63724553e-06,2.51959567 1.63724553e-06,5.62763872 C-0.00212609817,8.42335446 2.06985275,10.7967483 4.86520616,11.2005834 C4.98412854,11.9419058 4.93499159,12.7001185 4.72147333,13.4203679 C4.650107,13.6596741 4.78829054,13.9109216 5.03013594,13.9815481 C5.14128288,14.0139877 5.26081826,14.0033874 5.36438332,13.9518543 C6.31214886,13.4829164 7.65165491,12.6090257 8.3656086,11.259971 L9.31337413,11.259971 C12.454009,11.259971 15.0000016,8.74040723 15.0000016,5.63233225 C15.0026129,2.52489585 12.4597196,0.00348023682 9.31973,0 L9.31973,0 Z M10.9999896,6.99810591 C10.4477022,6.99810591 10.0000016,6.55081167 10.0000016,5.99905296 C10.0000016,5.44729424 10.4477022,5 10.9999896,5 C11.5522547,5 12.0000016,5.44729424 12.0000016,5.99905296 C12.0010259,6.55081167 11.5541952,6.99895268 11.0019078,7 L10.9999896,6.99810591 Z M7.50000164,6.99810591 C6.94769719,6.99810591 6.50000164,6.55081167 6.50000164,5.99905296 C6.50000164,5.44729424 6.94769719,5 7.50000164,5 C8.05225971,5 8.50000164,5.44729424 8.50000164,5.99905296 C8.50102588,6.55081167 8.0542002,6.99895268 7.50189664,7 L7.50000164,6.99810591 Z M4.00000164,6.99810591 C3.4477418,6.99810591 3.00000164,6.55081167 3.00000164,5.99905296 C3.00000164,5.44729424 3.4477418,5 4.00000164,5 C4.55225971,5 5.00000164,5.44729424 5.00000164,5.99905296 C5.00102588,6.55081167 4.5541779,6.99895268 4.00189664,7 L4.00000164,6.99810591 Z'
        id='path-123'
      ></path>
    </defs>
    <g
      id='Pinnacle-(PurchaseOrders3)'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='PRO-Inventory-POs-Details3'
        transform='translate(-749.999998, -701.000000)'
      >
        <g
          id='Buttons/MessageBubble-Copy-2'
          transform='translate(749.999998, 701.000000)'
        >
          <mask id='mask-222' fill='white'>
            <use xlinkHref='#path-123'></use>
          </mask>
          <use id='Mask' fill='#D3347F' xlinkHref='#path-123'></use>
          <g id='Color/Blue' mask='url(#mask-222)' fill='#278ADA'>
            <g transform='translate(0.000002, 0.000000)' id='Rectangle-11'>
              <rect x='0' y='0' width='15' height='14'></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EventStar = (props) => (
  <svg
    width={props.width || '20px'}
    height={props.height || '23px'}
    viewBox='0 0 20 23'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.9994 11.5C19.9994 11.2027 19.7586 10.9649 19.4575 10.9649C14.5416 10.9649 10.543 6.28863 10.543 0.535128C10.543 0.237835 10.3022 0 10.0012 0C9.70011 0 9.45928 0.237835 9.45928 0.535128C9.45928 6.28863 5.45715 10.9649 0.54481 10.9649C0.243765 10.9649 0.00292969 11.2027 0.00292969 11.5C0.00292969 11.7973 0.243765 12.0351 0.54481 12.0351C5.45715 12.0351 9.45928 16.7114 9.45928 22.4649C9.45928 22.7622 9.70011 23 10.0012 23C10.3022 23 10.543 22.7622 10.543 22.4649C10.543 16.7114 14.5416 12.0351 19.4575 12.0351C19.7586 12.0351 19.9994 11.7973 19.9994 11.5Z'
      fill={props.fillColor || 'currentColor'}
    />
  </svg>
);

export const EventIcon = (props) => (
  <svg
    width='10'
    height='15'
    viewBox='0 0 10 15'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M9.78088 7.5C9.78088 7.30611 9.66308 7.151 9.51583 7.151C7.11132 7.151 5.15549 4.10128 5.15549 0.348996C5.15549 0.155109 5.03769 0 4.89044 0C4.74319 0 4.62539 0.155109 4.62539 0.348996C4.62539 4.10128 2.66783 7.151 0.26505 7.151C0.1178 7.151 0 7.30611 0 7.5C0 7.69389 0.1178 7.849 0.26505 7.849C2.66783 7.849 4.62539 10.8987 4.62539 14.651C4.62539 14.8449 4.74319 15 4.89044 15C5.03769 15 5.15549 14.8449 5.15549 14.651C5.15549 10.8987 7.11132 7.849 9.51583 7.849C9.66308 7.849 9.78088 7.69389 9.78088 7.5Z' />
  </svg>
);

export const RefreshIcon = ({ onClick }) => (
  <svg
    onClick={onClick}
    className='refresh-icon'
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 30 30'
  >
    <path d='M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z'></path>
  </svg>
);

export const BackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    {...props}
  >
    <path d="M0 5.99996L5.87246 12L7.9999 9.82633L4.25499 6.00001L8 2.17367L5.87253 0L0 5.99996Z" fill="#5C80A2"/>
  </svg>
);

export const TapwiseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="white"
    {...props}
  >
    <path d="M13.0556 7.02381C10.5159 6.42857 8.53175 4.44444 7.97619 1.94444L7.5 0L7.02381 1.94444C6.42858 4.48413 4.44445 6.46825 1.94444 7.02381L0 7.5L1.94444 7.97619C4.48413 8.57143 6.46826 10.5556 7.02381 13.0556L7.5 15L7.97619 13.0556C8.57143 10.5159 10.5556 8.53175 13.0556 7.97619L15 7.5L13.0556 7.02381Z"/>
  </svg>
);

export const Pin = (props) => (
  <SvgIcon width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.26279 0.407167C8.71908 -0.136373 7.83638 -0.136373 7.29047 0.407167C6.8238 0.873686 6.75776 1.59107 7.09235 2.12801L3.89613 4.70047L1.59801 4.25376C1.19959 4.17674 0.80336 4.36598 0.611851 4.72468C0.420342 5.08337 0.486379 5.51688 0.772543 5.80515L3.82349 8.85514C3.77506 8.89475 3.72883 8.93876 3.68701 8.98937L0.105562 13.2717C-0.233432 13.681 0.316882 14.2333 0.728518 13.8944L5.01217 10.3141C5.06279 10.2723 5.10462 10.2261 5.14424 10.1755L8.19518 13.2255C8.37349 13.4015 8.60682 13.4961 8.84235 13.4961C8.98984 13.4961 9.13732 13.4609 9.2738 13.3883C9.63261 13.1969 9.82191 12.8008 9.74487 12.4025L9.29801 10.1051L11.8713 6.90984C12.4084 7.24433 13.126 7.17831 13.5927 6.71179C14.1364 6.16825 14.1364 5.28362 13.5927 4.74228L9.25839 0.409367H9.26279V0.407167Z" fill="#0E2C44"/>
  </SvgIcon>
);

export const ForkLiftIcon = ({ backgroundFill = "#278ADA", ...props }) => (
  <SvgIcon
    width="25px"
    height="25px"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Assign Items to Truck</title>
    <rect width="30" height="30" rx="2" fill={backgroundFill}/>
    <g>
      <path d="M19.3727 20.5618H12.1909C11.9697 19.9719 11.5126 19.5 10.9079 19.2788V8.54305C10.9079 7.26007 9.8609 6.22778 8.57792 6.22778H7.7226C7.32443 6.22778 7 6.55222 7 6.96513C7 7.37804 7.32443 7.70247 7.73735 7.70247H8.59267C9.06457 7.70247 9.44799 8.08589 9.44799 8.54305V19.2788C8.62216 19.5737 8.03228 20.3701 8.03228 21.2991C8.03228 22.4936 8.99083 23.4522 10.1853 23.4522C11.1144 23.4522 11.896 22.8623 12.2057 22.0365H19.3874C19.8003 22.0365 20.1247 21.712 20.1247 21.2991C20.1247 20.8862 19.8003 20.5618 19.3874 20.5618H19.3727ZM10.1853 22.0365C9.78717 22.0365 9.46273 21.712 9.46273 21.3139C9.46273 20.9157 9.78717 20.5913 10.1853 20.5913C10.5835 20.5913 10.9079 20.9157 10.9079 21.3139C10.9079 21.712 10.5835 22.0365 10.1853 22.0365Z" fill="white"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.1044 12.4067H16.5855V14.604C16.5855 14.7515 16.4233 14.8252 16.3053 14.7515L15.5532 14.2354L14.8011 14.7515C14.6832 14.8252 14.5209 14.7515 14.5209 14.604V12.4067H13.002C12.4269 12.4067 11.9697 12.8639 11.9697 13.439V18.5562C11.9697 19.1313 12.4269 19.5885 13.002 19.5885H18.1192C18.6943 19.5885 19.1515 19.1313 19.1515 18.5562V13.439C19.1515 12.8639 18.6943 12.4067 18.1192 12.4067H18.1044Z" fill="white"/>
    </g>
  </SvgIcon>
)
